// Auto-generated file. Run `npm run licenses` after dependencies change.
export type LicenseEntry = {
  name: string;
  version: string;
  license: string;
  homepage: string | null;
  licenseFile: string | null;
};

export const licenses: LicenseEntry[] = [
  {
    "name": "@adobe/css-tools",
    "version": "4.4.4",
    "license": "MIT",
    "homepage": "https://github.com/adobe/css-tools.git",
    "licenseFile": "/licenses/adobe-css-tools-4.4.4.txt"
  },
  {
    "name": "@alloc/quick-lru",
    "version": "5.2.0",
    "license": "MIT",
    "homepage": "sindresorhus/quick-lru",
    "licenseFile": "/licenses/alloc-quick-lru-5.2.0.txt"
  },
  {
    "name": "@ampproject/remapping",
    "version": "2.3.0",
    "license": "Apache-2.0",
    "homepage": "https://github.com/ampproject/remapping.git",
    "licenseFile": "/licenses/ampproject-remapping-2.3.0.txt"
  },
  {
    "name": "@apideck/better-ajv-errors",
    "version": "0.3.6",
    "license": "MIT",
    "homepage": "https://github.com/apideck-libraries/better-ajv-errors",
    "licenseFile": "/licenses/apideck-better-ajv-errors-0.3.6.txt"
  },
  {
    "name": "@babel/code-frame",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-code-frame",
    "licenseFile": "/licenses/babel-code-frame-7.27.1.txt"
  },
  {
    "name": "@babel/compat-data",
    "version": "7.28.0",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel.git",
    "licenseFile": "/licenses/babel-compat-data-7.28.0.txt"
  },
  {
    "name": "@babel/core",
    "version": "7.28.3",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-core",
    "licenseFile": "/licenses/babel-core-7.28.3.txt"
  },
  {
    "name": "@babel/eslint-parser",
    "version": "7.28.0",
    "license": "MIT",
    "homepage": "https://babel.dev/",
    "licenseFile": "/licenses/babel-eslint-parser-7.28.0.txt"
  },
  {
    "name": "@babel/generator",
    "version": "7.28.3",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-generator",
    "licenseFile": "/licenses/babel-generator-7.28.3.txt"
  },
  {
    "name": "@babel/helper-annotate-as-pure",
    "version": "7.27.3",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-helper-annotate-as-pure",
    "licenseFile": "/licenses/babel-helper-annotate-as-pure-7.27.3.txt"
  },
  {
    "name": "@babel/helper-compilation-targets",
    "version": "7.27.2",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel.git",
    "licenseFile": "/licenses/babel-helper-compilation-targets-7.27.2.txt"
  },
  {
    "name": "@babel/helper-create-class-features-plugin",
    "version": "7.28.3",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel.git",
    "licenseFile": "/licenses/babel-helper-create-class-features-plugin-7.28.3.txt"
  },
  {
    "name": "@babel/helper-create-regexp-features-plugin",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel.git",
    "licenseFile": "/licenses/babel-helper-create-regexp-features-plugin-7.27.1.txt"
  },
  {
    "name": "@babel/helper-define-polyfill-provider",
    "version": "0.6.5",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel-polyfills.git",
    "licenseFile": "/licenses/babel-helper-define-polyfill-provider-0.6.5.txt"
  },
  {
    "name": "@babel/helper-globals",
    "version": "7.28.0",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel.git",
    "licenseFile": "/licenses/babel-helper-globals-7.28.0.txt"
  },
  {
    "name": "@babel/helper-member-expression-to-functions",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-helper-member-expression-to-functions",
    "licenseFile": "/licenses/babel-helper-member-expression-to-functions-7.27.1.txt"
  },
  {
    "name": "@babel/helper-module-imports",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-helper-module-imports",
    "licenseFile": "/licenses/babel-helper-module-imports-7.27.1.txt"
  },
  {
    "name": "@babel/helper-module-transforms",
    "version": "7.28.3",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-helper-module-transforms",
    "licenseFile": "/licenses/babel-helper-module-transforms-7.28.3.txt"
  },
  {
    "name": "@babel/helper-optimise-call-expression",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-helper-optimise-call-expression",
    "licenseFile": "/licenses/babel-helper-optimise-call-expression-7.27.1.txt"
  },
  {
    "name": "@babel/helper-plugin-utils",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-helper-plugin-utils",
    "licenseFile": "/licenses/babel-helper-plugin-utils-7.27.1.txt"
  },
  {
    "name": "@babel/helper-remap-async-to-generator",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-helper-remap-async-to-generator",
    "licenseFile": "/licenses/babel-helper-remap-async-to-generator-7.27.1.txt"
  },
  {
    "name": "@babel/helper-replace-supers",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-helper-replace-supers",
    "licenseFile": "/licenses/babel-helper-replace-supers-7.27.1.txt"
  },
  {
    "name": "@babel/helper-skip-transparent-expression-wrappers",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel.git",
    "licenseFile": "/licenses/babel-helper-skip-transparent-expression-wrappers-7.27.1.txt"
  },
  {
    "name": "@babel/helper-string-parser",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-helper-string-parser",
    "licenseFile": "/licenses/babel-helper-string-parser-7.27.1.txt"
  },
  {
    "name": "@babel/helper-validator-identifier",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel.git",
    "licenseFile": "/licenses/babel-helper-validator-identifier-7.27.1.txt"
  },
  {
    "name": "@babel/helper-validator-option",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel.git",
    "licenseFile": "/licenses/babel-helper-validator-option-7.27.1.txt"
  },
  {
    "name": "@babel/helper-wrap-function",
    "version": "7.28.3",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-helper-wrap-function",
    "licenseFile": "/licenses/babel-helper-wrap-function-7.28.3.txt"
  },
  {
    "name": "@babel/helpers",
    "version": "7.28.3",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-helpers",
    "licenseFile": "/licenses/babel-helpers-7.28.3.txt"
  },
  {
    "name": "@babel/parser",
    "version": "7.28.3",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-parser",
    "licenseFile": "/licenses/babel-parser-7.28.3.txt"
  },
  {
    "name": "@babel/plugin-bugfix-firefox-class-in-computed-class-key",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-bugfix-firefox-class-in-computed-class-key",
    "licenseFile": "/licenses/babel-plugin-bugfix-firefox-class-in-computed-class-key-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-bugfix-safari-class-field-initializer-scope",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-bugfix-safari-class-field-initializer-scope",
    "licenseFile": "/licenses/babel-plugin-bugfix-safari-class-field-initializer-scope-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-bugfix-safari-id-destructuring-collision-in-function-expression",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-bugfix-safari-id-destructuring-collision-in-function-expression",
    "licenseFile": "/licenses/babel-plugin-bugfix-safari-id-destructuring-collision-in-function-expression-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-bugfix-v8-spread-parameters-in-optional-chaining",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-bugfix-v8-spread-parameters-in-optional-chaining",
    "licenseFile": "/licenses/babel-plugin-bugfix-v8-spread-parameters-in-optional-chaining-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-bugfix-v8-static-class-fields-redefine-readonly",
    "version": "7.28.3",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-bugfix-v8-static-class-fields-redefine-readonly",
    "licenseFile": "/licenses/babel-plugin-bugfix-v8-static-class-fields-redefine-readonly-7.28.3.txt"
  },
  {
    "name": "@babel/plugin-proposal-class-properties",
    "version": "7.18.6",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-proposal-class-properties",
    "licenseFile": "/licenses/babel-plugin-proposal-class-properties-7.18.6.txt"
  },
  {
    "name": "@babel/plugin-proposal-decorators",
    "version": "7.28.0",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-proposal-decorators",
    "licenseFile": "/licenses/babel-plugin-proposal-decorators-7.28.0.txt"
  },
  {
    "name": "@babel/plugin-proposal-nullish-coalescing-operator",
    "version": "7.18.6",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-proposal-nullish-coalescing-operator",
    "licenseFile": "/licenses/babel-plugin-proposal-nullish-coalescing-operator-7.18.6.txt"
  },
  {
    "name": "@babel/plugin-proposal-numeric-separator",
    "version": "7.18.6",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-proposal-numeric-separator",
    "licenseFile": "/licenses/babel-plugin-proposal-numeric-separator-7.18.6.txt"
  },
  {
    "name": "@babel/plugin-proposal-optional-chaining",
    "version": "7.21.0",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-proposal-optional-chaining",
    "licenseFile": "/licenses/babel-plugin-proposal-optional-chaining-7.21.0.txt"
  },
  {
    "name": "@babel/plugin-proposal-private-methods",
    "version": "7.18.6",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-proposal-private-methods",
    "licenseFile": "/licenses/babel-plugin-proposal-private-methods-7.18.6.txt"
  },
  {
    "name": "@babel/plugin-proposal-private-property-in-object",
    "version": "7.21.0-placeholder-for-preset-env.2",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-proposal-private-property-in-object",
    "licenseFile": "/licenses/babel-plugin-proposal-private-property-in-object-7.21.0-placeholder-for-preset-env.2.txt"
  },
  {
    "name": "@babel/plugin-proposal-private-property-in-object",
    "version": "7.21.11",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-proposal-private-property-in-object",
    "licenseFile": "/licenses/babel-plugin-proposal-private-property-in-object-7.21.11.txt"
  },
  {
    "name": "@babel/plugin-syntax-async-generators",
    "version": "7.8.4",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel/tree/master/packages/babel-plugin-syntax-async-generators",
    "licenseFile": "/licenses/babel-plugin-syntax-async-generators-7.8.4.txt"
  },
  {
    "name": "@babel/plugin-syntax-bigint",
    "version": "7.8.3",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel/tree/master/packages/babel-plugin-syntax-bigint",
    "licenseFile": "/licenses/babel-plugin-syntax-bigint-7.8.3.txt"
  },
  {
    "name": "@babel/plugin-syntax-class-properties",
    "version": "7.12.13",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-syntax-class-properties",
    "licenseFile": "/licenses/babel-plugin-syntax-class-properties-7.12.13.txt"
  },
  {
    "name": "@babel/plugin-syntax-class-static-block",
    "version": "7.14.5",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-syntax-class-static-block",
    "licenseFile": "/licenses/babel-plugin-syntax-class-static-block-7.14.5.txt"
  },
  {
    "name": "@babel/plugin-syntax-decorators",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-syntax-decorators",
    "licenseFile": "/licenses/babel-plugin-syntax-decorators-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-syntax-flow",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-syntax-flow",
    "licenseFile": "/licenses/babel-plugin-syntax-flow-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-syntax-import-assertions",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel.git",
    "licenseFile": "/licenses/babel-plugin-syntax-import-assertions-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-syntax-import-attributes",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel.git",
    "licenseFile": "/licenses/babel-plugin-syntax-import-attributes-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-syntax-import-meta",
    "version": "7.10.4",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel.git",
    "licenseFile": "/licenses/babel-plugin-syntax-import-meta-7.10.4.txt"
  },
  {
    "name": "@babel/plugin-syntax-json-strings",
    "version": "7.8.3",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel/tree/master/packages/babel-plugin-syntax-json-strings",
    "licenseFile": "/licenses/babel-plugin-syntax-json-strings-7.8.3.txt"
  },
  {
    "name": "@babel/plugin-syntax-jsx",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-syntax-jsx",
    "licenseFile": "/licenses/babel-plugin-syntax-jsx-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-syntax-logical-assignment-operators",
    "version": "7.10.4",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel.git",
    "licenseFile": "/licenses/babel-plugin-syntax-logical-assignment-operators-7.10.4.txt"
  },
  {
    "name": "@babel/plugin-syntax-nullish-coalescing-operator",
    "version": "7.8.3",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel/tree/master/packages/babel-plugin-syntax-nullish-coalescing-operator",
    "licenseFile": "/licenses/babel-plugin-syntax-nullish-coalescing-operator-7.8.3.txt"
  },
  {
    "name": "@babel/plugin-syntax-numeric-separator",
    "version": "7.10.4",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel.git",
    "licenseFile": "/licenses/babel-plugin-syntax-numeric-separator-7.10.4.txt"
  },
  {
    "name": "@babel/plugin-syntax-object-rest-spread",
    "version": "7.8.3",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel/tree/master/packages/babel-plugin-syntax-object-rest-spread",
    "licenseFile": "/licenses/babel-plugin-syntax-object-rest-spread-7.8.3.txt"
  },
  {
    "name": "@babel/plugin-syntax-optional-catch-binding",
    "version": "7.8.3",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel/tree/master/packages/babel-plugin-syntax-optional-catch-binding",
    "licenseFile": "/licenses/babel-plugin-syntax-optional-catch-binding-7.8.3.txt"
  },
  {
    "name": "@babel/plugin-syntax-optional-chaining",
    "version": "7.8.3",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel/tree/master/packages/babel-plugin-syntax-optional-chaining",
    "licenseFile": "/licenses/babel-plugin-syntax-optional-chaining-7.8.3.txt"
  },
  {
    "name": "@babel/plugin-syntax-private-property-in-object",
    "version": "7.14.5",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-syntax-private-property-in-object",
    "licenseFile": "/licenses/babel-plugin-syntax-private-property-in-object-7.14.5.txt"
  },
  {
    "name": "@babel/plugin-syntax-top-level-await",
    "version": "7.14.5",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-syntax-top-level-await",
    "licenseFile": "/licenses/babel-plugin-syntax-top-level-await-7.14.5.txt"
  },
  {
    "name": "@babel/plugin-syntax-typescript",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-syntax-typescript",
    "licenseFile": "/licenses/babel-plugin-syntax-typescript-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-syntax-unicode-sets-regex",
    "version": "7.18.6",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-syntax-unicode-sets-regex",
    "licenseFile": "/licenses/babel-plugin-syntax-unicode-sets-regex-7.18.6.txt"
  },
  {
    "name": "@babel/plugin-transform-arrow-functions",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-arrow-functions",
    "licenseFile": "/licenses/babel-plugin-transform-arrow-functions-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-async-generator-functions",
    "version": "7.28.0",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-async-generator-functions",
    "licenseFile": "/licenses/babel-plugin-transform-async-generator-functions-7.28.0.txt"
  },
  {
    "name": "@babel/plugin-transform-async-to-generator",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-async-to-generator",
    "licenseFile": "/licenses/babel-plugin-transform-async-to-generator-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-block-scoped-functions",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-block-scoped-functions",
    "licenseFile": "/licenses/babel-plugin-transform-block-scoped-functions-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-block-scoping",
    "version": "7.28.0",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-block-scoping",
    "licenseFile": "/licenses/babel-plugin-transform-block-scoping-7.28.0.txt"
  },
  {
    "name": "@babel/plugin-transform-class-properties",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-class-properties",
    "licenseFile": "/licenses/babel-plugin-transform-class-properties-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-class-static-block",
    "version": "7.28.3",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-class-static-block",
    "licenseFile": "/licenses/babel-plugin-transform-class-static-block-7.28.3.txt"
  },
  {
    "name": "@babel/plugin-transform-classes",
    "version": "7.28.3",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-classes",
    "licenseFile": "/licenses/babel-plugin-transform-classes-7.28.3.txt"
  },
  {
    "name": "@babel/plugin-transform-computed-properties",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-computed-properties",
    "licenseFile": "/licenses/babel-plugin-transform-computed-properties-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-destructuring",
    "version": "7.28.0",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-destructuring",
    "licenseFile": "/licenses/babel-plugin-transform-destructuring-7.28.0.txt"
  },
  {
    "name": "@babel/plugin-transform-dotall-regex",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-dotall-regex",
    "licenseFile": "/licenses/babel-plugin-transform-dotall-regex-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-duplicate-keys",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-duplicate-keys",
    "licenseFile": "/licenses/babel-plugin-transform-duplicate-keys-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-duplicate-named-capturing-groups-regex",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-duplicate-named-capturing-groups-regex",
    "licenseFile": "/licenses/babel-plugin-transform-duplicate-named-capturing-groups-regex-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-dynamic-import",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel.git",
    "licenseFile": "/licenses/babel-plugin-transform-dynamic-import-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-explicit-resource-management",
    "version": "7.28.0",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-explicit-resource-management",
    "licenseFile": "/licenses/babel-plugin-transform-explicit-resource-management-7.28.0.txt"
  },
  {
    "name": "@babel/plugin-transform-exponentiation-operator",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-exponentiation-operator",
    "licenseFile": "/licenses/babel-plugin-transform-exponentiation-operator-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-export-namespace-from",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-export-namespace-from",
    "licenseFile": "/licenses/babel-plugin-transform-export-namespace-from-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-flow-strip-types",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-flow-strip-types",
    "licenseFile": "/licenses/babel-plugin-transform-flow-strip-types-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-for-of",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-for-of",
    "licenseFile": "/licenses/babel-plugin-transform-for-of-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-function-name",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-function-name",
    "licenseFile": "/licenses/babel-plugin-transform-function-name-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-json-strings",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-json-strings",
    "licenseFile": "/licenses/babel-plugin-transform-json-strings-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-literals",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-literals",
    "licenseFile": "/licenses/babel-plugin-transform-literals-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-logical-assignment-operators",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-logical-assignment-operators",
    "licenseFile": "/licenses/babel-plugin-transform-logical-assignment-operators-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-member-expression-literals",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-member-expression-literals",
    "licenseFile": "/licenses/babel-plugin-transform-member-expression-literals-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-modules-amd",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-modules-amd",
    "licenseFile": "/licenses/babel-plugin-transform-modules-amd-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-modules-commonjs",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-modules-commonjs",
    "licenseFile": "/licenses/babel-plugin-transform-modules-commonjs-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-modules-systemjs",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-modules-systemjs",
    "licenseFile": "/licenses/babel-plugin-transform-modules-systemjs-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-modules-umd",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-modules-umd",
    "licenseFile": "/licenses/babel-plugin-transform-modules-umd-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-named-capturing-groups-regex",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-named-capturing-groups-regex",
    "licenseFile": "/licenses/babel-plugin-transform-named-capturing-groups-regex-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-new-target",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-new-target",
    "licenseFile": "/licenses/babel-plugin-transform-new-target-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-nullish-coalescing-operator",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-nullish-coalescing-operator",
    "licenseFile": "/licenses/babel-plugin-transform-nullish-coalescing-operator-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-numeric-separator",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-numeric-separator",
    "licenseFile": "/licenses/babel-plugin-transform-numeric-separator-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-object-rest-spread",
    "version": "7.28.0",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-object-rest-spread",
    "licenseFile": "/licenses/babel-plugin-transform-object-rest-spread-7.28.0.txt"
  },
  {
    "name": "@babel/plugin-transform-object-super",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-object-super",
    "licenseFile": "/licenses/babel-plugin-transform-object-super-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-optional-catch-binding",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-optional-catch-binding",
    "licenseFile": "/licenses/babel-plugin-transform-optional-catch-binding-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-optional-chaining",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-optional-chaining",
    "licenseFile": "/licenses/babel-plugin-transform-optional-chaining-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-parameters",
    "version": "7.27.7",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-parameters",
    "licenseFile": "/licenses/babel-plugin-transform-parameters-7.27.7.txt"
  },
  {
    "name": "@babel/plugin-transform-private-methods",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-private-methods",
    "licenseFile": "/licenses/babel-plugin-transform-private-methods-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-private-property-in-object",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-private-property-in-object",
    "licenseFile": "/licenses/babel-plugin-transform-private-property-in-object-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-property-literals",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-property-literals",
    "licenseFile": "/licenses/babel-plugin-transform-property-literals-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-react-constant-elements",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-react-constant-elements",
    "licenseFile": "/licenses/babel-plugin-transform-react-constant-elements-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-react-display-name",
    "version": "7.28.0",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-react-display-name",
    "licenseFile": "/licenses/babel-plugin-transform-react-display-name-7.28.0.txt"
  },
  {
    "name": "@babel/plugin-transform-react-jsx",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-react-jsx",
    "licenseFile": "/licenses/babel-plugin-transform-react-jsx-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-react-jsx-development",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel.git",
    "licenseFile": "/licenses/babel-plugin-transform-react-jsx-development-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-react-pure-annotations",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel.git",
    "licenseFile": "/licenses/babel-plugin-transform-react-pure-annotations-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-regenerator",
    "version": "7.28.3",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-regenerator",
    "licenseFile": "/licenses/babel-plugin-transform-regenerator-7.28.3.txt"
  },
  {
    "name": "@babel/plugin-transform-regexp-modifiers",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-regexp-modifiers",
    "licenseFile": "/licenses/babel-plugin-transform-regexp-modifiers-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-reserved-words",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-reserved-words",
    "licenseFile": "/licenses/babel-plugin-transform-reserved-words-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-runtime",
    "version": "7.28.3",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-runtime",
    "licenseFile": "/licenses/babel-plugin-transform-runtime-7.28.3.txt"
  },
  {
    "name": "@babel/plugin-transform-shorthand-properties",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-shorthand-properties",
    "licenseFile": "/licenses/babel-plugin-transform-shorthand-properties-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-spread",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-spread",
    "licenseFile": "/licenses/babel-plugin-transform-spread-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-sticky-regex",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-sticky-regex",
    "licenseFile": "/licenses/babel-plugin-transform-sticky-regex-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-template-literals",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-template-literals",
    "licenseFile": "/licenses/babel-plugin-transform-template-literals-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-typeof-symbol",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-typeof-symbol",
    "licenseFile": "/licenses/babel-plugin-transform-typeof-symbol-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-typescript",
    "version": "7.28.0",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-typescript",
    "licenseFile": "/licenses/babel-plugin-transform-typescript-7.28.0.txt"
  },
  {
    "name": "@babel/plugin-transform-unicode-escapes",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-unicode-escapes",
    "licenseFile": "/licenses/babel-plugin-transform-unicode-escapes-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-unicode-property-regex",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-unicode-property-regex",
    "licenseFile": "/licenses/babel-plugin-transform-unicode-property-regex-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-unicode-regex",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-unicode-regex",
    "licenseFile": "/licenses/babel-plugin-transform-unicode-regex-7.27.1.txt"
  },
  {
    "name": "@babel/plugin-transform-unicode-sets-regex",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-plugin-transform-unicode-sets-regex",
    "licenseFile": "/licenses/babel-plugin-transform-unicode-sets-regex-7.27.1.txt"
  },
  {
    "name": "@babel/preset-env",
    "version": "7.28.3",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-preset-env",
    "licenseFile": "/licenses/babel-preset-env-7.28.3.txt"
  },
  {
    "name": "@babel/preset-modules",
    "version": "0.1.6-no-external-plugins",
    "license": "MIT",
    "homepage": "https://github.com/babel/preset-modules.git",
    "licenseFile": "/licenses/babel-preset-modules-0.1.6-no-external-plugins.txt"
  },
  {
    "name": "@babel/preset-react",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-preset-react",
    "licenseFile": "/licenses/babel-preset-react-7.27.1.txt"
  },
  {
    "name": "@babel/preset-typescript",
    "version": "7.27.1",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-preset-typescript",
    "licenseFile": "/licenses/babel-preset-typescript-7.27.1.txt"
  },
  {
    "name": "@babel/runtime",
    "version": "7.28.3",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-runtime",
    "licenseFile": "/licenses/babel-runtime-7.28.3.txt"
  },
  {
    "name": "@babel/template",
    "version": "7.27.2",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-template",
    "licenseFile": "/licenses/babel-template-7.27.2.txt"
  },
  {
    "name": "@babel/traverse",
    "version": "7.28.3",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-traverse",
    "licenseFile": "/licenses/babel-traverse-7.28.3.txt"
  },
  {
    "name": "@babel/types",
    "version": "7.28.2",
    "license": "MIT",
    "homepage": "https://babel.dev/docs/en/next/babel-types",
    "licenseFile": "/licenses/babel-types-7.28.2.txt"
  },
  {
    "name": "@bcoe/v8-coverage",
    "version": "0.2.3",
    "license": "MIT",
    "homepage": "https://demurgos.github.io/v8-coverage",
    "licenseFile": "/licenses/bcoe-v8-coverage-0.2.3.txt"
  },
  {
    "name": "@csstools/normalize.css",
    "version": "12.1.1",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/normalize.css#readme",
    "licenseFile": "/licenses/csstools-normalize.css-12.1.1.txt"
  },
  {
    "name": "@csstools/postcss-cascade-layers",
    "version": "1.1.1",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-cascade-layers#readme",
    "licenseFile": "/licenses/csstools-postcss-cascade-layers-1.1.1.txt"
  },
  {
    "name": "@csstools/postcss-color-function",
    "version": "1.1.1",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-color-function#readme",
    "licenseFile": "/licenses/csstools-postcss-color-function-1.1.1.txt"
  },
  {
    "name": "@csstools/postcss-font-format-keywords",
    "version": "1.0.1",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-font-format-keywords#readme",
    "licenseFile": "/licenses/csstools-postcss-font-format-keywords-1.0.1.txt"
  },
  {
    "name": "@csstools/postcss-hwb-function",
    "version": "1.0.2",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-hwb-function#readme",
    "licenseFile": "/licenses/csstools-postcss-hwb-function-1.0.2.txt"
  },
  {
    "name": "@csstools/postcss-ic-unit",
    "version": "1.0.1",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-ic-unit#readme",
    "licenseFile": "/licenses/csstools-postcss-ic-unit-1.0.1.txt"
  },
  {
    "name": "@csstools/postcss-is-pseudo-class",
    "version": "2.0.7",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-is-pseudo-class#readme",
    "licenseFile": "/licenses/csstools-postcss-is-pseudo-class-2.0.7.txt"
  },
  {
    "name": "@csstools/postcss-nested-calc",
    "version": "1.0.0",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-nested-calc#readme",
    "licenseFile": "/licenses/csstools-postcss-nested-calc-1.0.0.txt"
  },
  {
    "name": "@csstools/postcss-normalize-display-values",
    "version": "1.0.1",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins.git",
    "licenseFile": "/licenses/csstools-postcss-normalize-display-values-1.0.1.txt"
  },
  {
    "name": "@csstools/postcss-oklab-function",
    "version": "1.1.1",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-oklab-function#readme",
    "licenseFile": "/licenses/csstools-postcss-oklab-function-1.1.1.txt"
  },
  {
    "name": "@csstools/postcss-progressive-custom-properties",
    "version": "1.3.0",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins.git",
    "licenseFile": "/licenses/csstools-postcss-progressive-custom-properties-1.3.0.txt"
  },
  {
    "name": "@csstools/postcss-stepped-value-functions",
    "version": "1.0.1",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-stepped-value-functions#readme",
    "licenseFile": "/licenses/csstools-postcss-stepped-value-functions-1.0.1.txt"
  },
  {
    "name": "@csstools/postcss-text-decoration-shorthand",
    "version": "1.0.0",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-text-decoration-shorthand#readme",
    "licenseFile": "/licenses/csstools-postcss-text-decoration-shorthand-1.0.0.txt"
  },
  {
    "name": "@csstools/postcss-trigonometric-functions",
    "version": "1.0.2",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-trigonometric-functions#readme",
    "licenseFile": "/licenses/csstools-postcss-trigonometric-functions-1.0.2.txt"
  },
  {
    "name": "@csstools/postcss-unset-value",
    "version": "1.0.2",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-unset-value#readme",
    "licenseFile": "/licenses/csstools-postcss-unset-value-1.0.2.txt"
  },
  {
    "name": "@csstools/selector-specificity",
    "version": "2.2.0",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/packages/selector-specificity#readme",
    "licenseFile": "/licenses/csstools-selector-specificity-2.2.0.txt"
  },
  {
    "name": "@eslint-community/eslint-utils",
    "version": "4.7.0",
    "license": "MIT",
    "homepage": "https://github.com/eslint-community/eslint-utils#readme",
    "licenseFile": "/licenses/eslint-community-eslint-utils-4.7.0.txt"
  },
  {
    "name": "@eslint-community/regexpp",
    "version": "4.12.1",
    "license": "MIT",
    "homepage": "https://github.com/eslint-community/regexpp#readme",
    "licenseFile": "/licenses/eslint-community-regexpp-4.12.1.txt"
  },
  {
    "name": "@eslint/eslintrc",
    "version": "2.1.4",
    "license": "MIT",
    "homepage": "https://github.com/eslint/eslintrc#readme",
    "licenseFile": "/licenses/eslint-eslintrc-2.1.4.txt"
  },
  {
    "name": "@eslint/js",
    "version": "8.57.1",
    "license": "MIT",
    "homepage": "https://eslint.org",
    "licenseFile": "/licenses/eslint-js-8.57.1.txt"
  },
  {
    "name": "@humanwhocodes/config-array",
    "version": "0.13.0",
    "license": "Apache-2.0",
    "homepage": "https://github.com/humanwhocodes/config-array#readme",
    "licenseFile": "/licenses/humanwhocodes-config-array-0.13.0.txt"
  },
  {
    "name": "@humanwhocodes/module-importer",
    "version": "1.0.1",
    "license": "Apache-2.0",
    "homepage": "https://github.com/humanwhocodes/module-importer.git",
    "licenseFile": "/licenses/humanwhocodes-module-importer-1.0.1.txt"
  },
  {
    "name": "@humanwhocodes/object-schema",
    "version": "2.0.3",
    "license": "BSD-3-Clause",
    "homepage": "https://github.com/humanwhocodes/object-schema#readme",
    "licenseFile": "/licenses/humanwhocodes-object-schema-2.0.3.txt"
  },
  {
    "name": "@isaacs/cliui",
    "version": "8.0.2",
    "license": "ISC",
    "homepage": "yargs/cliui",
    "licenseFile": "/licenses/isaacs-cliui-8.0.2.txt"
  },
  {
    "name": "@istanbuljs/load-nyc-config",
    "version": "1.1.0",
    "license": "ISC",
    "homepage": "https://github.com/istanbuljs/load-nyc-config#readme",
    "licenseFile": "/licenses/istanbuljs-load-nyc-config-1.1.0.txt"
  },
  {
    "name": "@istanbuljs/schema",
    "version": "0.1.3",
    "license": "MIT",
    "homepage": "https://github.com/istanbuljs/schema#readme",
    "licenseFile": "/licenses/istanbuljs-schema-0.1.3.txt"
  },
  {
    "name": "@jest/console",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-console-27.5.1.txt"
  },
  {
    "name": "@jest/console",
    "version": "28.1.3",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-console-28.1.3.txt"
  },
  {
    "name": "@jest/core",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://jestjs.io/",
    "licenseFile": "/licenses/jest-core-27.5.1.txt"
  },
  {
    "name": "@jest/environment",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-environment-27.5.1.txt"
  },
  {
    "name": "@jest/fake-timers",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-fake-timers-27.5.1.txt"
  },
  {
    "name": "@jest/globals",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-globals-27.5.1.txt"
  },
  {
    "name": "@jest/reporters",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://jestjs.io/",
    "licenseFile": "/licenses/jest-reporters-27.5.1.txt"
  },
  {
    "name": "@jest/schemas",
    "version": "28.1.3",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-schemas-28.1.3.txt"
  },
  {
    "name": "@jest/source-map",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-source-map-27.5.1.txt"
  },
  {
    "name": "@jest/test-result",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-test-result-27.5.1.txt"
  },
  {
    "name": "@jest/test-result",
    "version": "28.1.3",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-test-result-28.1.3.txt"
  },
  {
    "name": "@jest/test-sequencer",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-test-sequencer-27.5.1.txt"
  },
  {
    "name": "@jest/transform",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-transform-27.5.1.txt"
  },
  {
    "name": "@jest/types",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-types-27.5.1.txt"
  },
  {
    "name": "@jest/types",
    "version": "28.1.3",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-types-28.1.3.txt"
  },
  {
    "name": "@jridgewell/gen-mapping",
    "version": "0.3.13",
    "license": "MIT",
    "homepage": "https://github.com/jridgewell/sourcemaps/tree/main/packages/gen-mapping",
    "licenseFile": "/licenses/jridgewell-gen-mapping-0.3.13.txt"
  },
  {
    "name": "@jridgewell/resolve-uri",
    "version": "3.1.2",
    "license": "MIT",
    "homepage": "https://github.com/jridgewell/resolve-uri",
    "licenseFile": "/licenses/jridgewell-resolve-uri-3.1.2.txt"
  },
  {
    "name": "@jridgewell/source-map",
    "version": "0.3.11",
    "license": "MIT",
    "homepage": "https://github.com/jridgewell/sourcemaps/tree/main/packages/source-map",
    "licenseFile": "/licenses/jridgewell-source-map-0.3.11.txt"
  },
  {
    "name": "@jridgewell/sourcemap-codec",
    "version": "1.5.5",
    "license": "MIT",
    "homepage": "https://github.com/jridgewell/sourcemaps/tree/main/packages/sourcemap-codec",
    "licenseFile": "/licenses/jridgewell-sourcemap-codec-1.5.5.txt"
  },
  {
    "name": "@jridgewell/trace-mapping",
    "version": "0.3.30",
    "license": "MIT",
    "homepage": "https://github.com/jridgewell/sourcemaps/tree/main/packages/trace-mapping",
    "licenseFile": "/licenses/jridgewell-trace-mapping-0.3.30.txt"
  },
  {
    "name": "@kurkle/color",
    "version": "0.3.4",
    "license": "MIT",
    "homepage": "https://github.com/kurkle/color#readme",
    "licenseFile": "/licenses/kurkle-color-0.3.4.txt"
  },
  {
    "name": "@leichtgewicht/ip-codec",
    "version": "2.0.5",
    "license": "MIT",
    "homepage": "https://github.com/martinheidegger/ip-codec#readme",
    "licenseFile": "/licenses/leichtgewicht-ip-codec-2.0.5.txt"
  },
  {
    "name": "@nicolo-ribaudo/eslint-scope-5-internals",
    "version": "5.1.1-v1",
    "license": "MIT",
    "homepage": null,
    "licenseFile": "/licenses/nicolo-ribaudo-eslint-scope-5-internals-5.1.1-v1.txt"
  },
  {
    "name": "@nodelib/fs.scandir",
    "version": "2.1.5",
    "license": "MIT",
    "homepage": "https://github.com/nodelib/nodelib/tree/master/packages/fs/fs.scandir",
    "licenseFile": "/licenses/nodelib-fs.scandir-2.1.5.txt"
  },
  {
    "name": "@nodelib/fs.stat",
    "version": "2.0.5",
    "license": "MIT",
    "homepage": "https://github.com/nodelib/nodelib/tree/master/packages/fs/fs.stat",
    "licenseFile": "/licenses/nodelib-fs.stat-2.0.5.txt"
  },
  {
    "name": "@nodelib/fs.walk",
    "version": "1.2.8",
    "license": "MIT",
    "homepage": "https://github.com/nodelib/nodelib/tree/master/packages/fs/fs.walk",
    "licenseFile": "/licenses/nodelib-fs.walk-1.2.8.txt"
  },
  {
    "name": "@pkgjs/parseargs",
    "version": "0.11.0",
    "license": "MIT",
    "homepage": "https://github.com/pkgjs/parseargs#readme",
    "licenseFile": "/licenses/pkgjs-parseargs-0.11.0.txt"
  },
  {
    "name": "@pmmmwh/react-refresh-webpack-plugin",
    "version": "0.5.17",
    "license": "MIT",
    "homepage": "https://github.com/pmmmwh/react-refresh-webpack-plugin#readme",
    "licenseFile": "/licenses/pmmmwh-react-refresh-webpack-plugin-0.5.17.txt"
  },
  {
    "name": "@react-leaflet/core",
    "version": "3.0.0",
    "license": "Hippocratic-2.1",
    "homepage": "https://react-leaflet.js.org/docs/core-introduction",
    "licenseFile": "/licenses/react-leaflet-core-3.0.0.txt"
  },
  {
    "name": "@rollup/plugin-babel",
    "version": "5.3.1",
    "license": "MIT",
    "homepage": "https://github.com/rollup/plugins/tree/master/packages/babel#readme",
    "licenseFile": "/licenses/rollup-plugin-babel-5.3.1.txt"
  },
  {
    "name": "@rollup/plugin-node-resolve",
    "version": "11.2.1",
    "license": "MIT",
    "homepage": "https://github.com/rollup/plugins/tree/master/packages/node-resolve/#readme",
    "licenseFile": "/licenses/rollup-plugin-node-resolve-11.2.1.txt"
  },
  {
    "name": "@rollup/plugin-replace",
    "version": "2.4.2",
    "license": "MIT",
    "homepage": "https://github.com/rollup/plugins/tree/master/packages/replace#readme",
    "licenseFile": "/licenses/rollup-plugin-replace-2.4.2.txt"
  },
  {
    "name": "@rollup/pluginutils",
    "version": "3.1.0",
    "license": "MIT",
    "homepage": "https://github.com/rollup/plugins/tree/master/packages/pluginutils#readme",
    "licenseFile": "/licenses/rollup-pluginutils-3.1.0.txt"
  },
  {
    "name": "@rtsao/scc",
    "version": "1.1.0",
    "license": "MIT",
    "homepage": "rtsao/scc",
    "licenseFile": "/licenses/rtsao-scc-1.1.0.txt"
  },
  {
    "name": "@rushstack/eslint-patch",
    "version": "1.12.0",
    "license": "MIT",
    "homepage": "https://rushstack.io",
    "licenseFile": "/licenses/rushstack-eslint-patch-1.12.0.txt"
  },
  {
    "name": "@sinclair/typebox",
    "version": "0.24.51",
    "license": "MIT",
    "homepage": "https://github.com/sinclairzx81/typebox",
    "licenseFile": "/licenses/sinclair-typebox-0.24.51.txt"
  },
  {
    "name": "@sinonjs/commons",
    "version": "1.8.6",
    "license": "BSD-3-Clause",
    "homepage": "https://github.com/sinonjs/commons#readme",
    "licenseFile": "/licenses/sinonjs-commons-1.8.6.txt"
  },
  {
    "name": "@sinonjs/fake-timers",
    "version": "8.1.0",
    "license": "BSD-3-Clause",
    "homepage": "https://github.com/sinonjs/fake-timers",
    "licenseFile": "/licenses/sinonjs-fake-timers-8.1.0.txt"
  },
  {
    "name": "@surma/rollup-plugin-off-main-thread",
    "version": "2.2.3",
    "license": "Apache-2.0",
    "homepage": "https://github.com/surma/rollup-plugin-off-main-thread",
    "licenseFile": "/licenses/surma-rollup-plugin-off-main-thread-2.2.3.txt"
  },
  {
    "name": "@svgr/babel-plugin-add-jsx-attribute",
    "version": "5.4.0",
    "license": "MIT",
    "homepage": "https://react-svgr.com",
    "licenseFile": "/licenses/svgr-babel-plugin-add-jsx-attribute-5.4.0.txt"
  },
  {
    "name": "@svgr/babel-plugin-remove-jsx-attribute",
    "version": "5.4.0",
    "license": "MIT",
    "homepage": "https://react-svgr.com",
    "licenseFile": "/licenses/svgr-babel-plugin-remove-jsx-attribute-5.4.0.txt"
  },
  {
    "name": "@svgr/babel-plugin-remove-jsx-empty-expression",
    "version": "5.0.1",
    "license": "MIT",
    "homepage": "https://react-svgr.com",
    "licenseFile": "/licenses/svgr-babel-plugin-remove-jsx-empty-expression-5.0.1.txt"
  },
  {
    "name": "@svgr/babel-plugin-replace-jsx-attribute-value",
    "version": "5.0.1",
    "license": "MIT",
    "homepage": "https://react-svgr.com",
    "licenseFile": "/licenses/svgr-babel-plugin-replace-jsx-attribute-value-5.0.1.txt"
  },
  {
    "name": "@svgr/babel-plugin-svg-dynamic-title",
    "version": "5.4.0",
    "license": "MIT",
    "homepage": "https://react-svgr.com",
    "licenseFile": "/licenses/svgr-babel-plugin-svg-dynamic-title-5.4.0.txt"
  },
  {
    "name": "@svgr/babel-plugin-svg-em-dimensions",
    "version": "5.4.0",
    "license": "MIT",
    "homepage": "https://react-svgr.com",
    "licenseFile": "/licenses/svgr-babel-plugin-svg-em-dimensions-5.4.0.txt"
  },
  {
    "name": "@svgr/babel-plugin-transform-react-native-svg",
    "version": "5.4.0",
    "license": "MIT",
    "homepage": "https://react-svgr.com",
    "licenseFile": "/licenses/svgr-babel-plugin-transform-react-native-svg-5.4.0.txt"
  },
  {
    "name": "@svgr/babel-plugin-transform-svg-component",
    "version": "5.5.0",
    "license": "MIT",
    "homepage": "https://react-svgr.com",
    "licenseFile": "/licenses/svgr-babel-plugin-transform-svg-component-5.5.0.txt"
  },
  {
    "name": "@svgr/babel-preset",
    "version": "5.5.0",
    "license": "MIT",
    "homepage": "https://react-svgr.com",
    "licenseFile": "/licenses/svgr-babel-preset-5.5.0.txt"
  },
  {
    "name": "@svgr/core",
    "version": "5.5.0",
    "license": "MIT",
    "homepage": "https://react-svgr.com",
    "licenseFile": "/licenses/svgr-core-5.5.0.txt"
  },
  {
    "name": "@svgr/hast-util-to-babel-ast",
    "version": "5.5.0",
    "license": "MIT",
    "homepage": "https://react-svgr.com",
    "licenseFile": "/licenses/svgr-hast-util-to-babel-ast-5.5.0.txt"
  },
  {
    "name": "@svgr/plugin-jsx",
    "version": "5.5.0",
    "license": "MIT",
    "homepage": "https://react-svgr.com",
    "licenseFile": "/licenses/svgr-plugin-jsx-5.5.0.txt"
  },
  {
    "name": "@svgr/plugin-svgo",
    "version": "5.5.0",
    "license": "MIT",
    "homepage": "https://react-svgr.com",
    "licenseFile": "/licenses/svgr-plugin-svgo-5.5.0.txt"
  },
  {
    "name": "@svgr/webpack",
    "version": "5.5.0",
    "license": "MIT",
    "homepage": "https://react-svgr.com",
    "licenseFile": "/licenses/svgr-webpack-5.5.0.txt"
  },
  {
    "name": "@testing-library/dom",
    "version": "10.4.1",
    "license": "MIT",
    "homepage": "https://github.com/testing-library/dom-testing-library#readme",
    "licenseFile": "/licenses/testing-library-dom-10.4.1.txt"
  },
  {
    "name": "@testing-library/jest-dom",
    "version": "6.8.0",
    "license": "MIT",
    "homepage": "https://github.com/testing-library/jest-dom#readme",
    "licenseFile": "/licenses/testing-library-jest-dom-6.8.0.txt"
  },
  {
    "name": "@testing-library/react",
    "version": "16.3.0",
    "license": "MIT",
    "homepage": "https://github.com/testing-library/react-testing-library#readme",
    "licenseFile": "/licenses/testing-library-react-16.3.0.txt"
  },
  {
    "name": "@testing-library/user-event",
    "version": "13.5.0",
    "license": "MIT",
    "homepage": "https://github.com/testing-library/user-event#readme",
    "licenseFile": "/licenses/testing-library-user-event-13.5.0.txt"
  },
  {
    "name": "@tootallnate/once",
    "version": "1.1.2",
    "license": "MIT",
    "homepage": "git://github.com/TooTallNate/once.git",
    "licenseFile": null
  },
  {
    "name": "@trysound/sax",
    "version": "0.2.0",
    "license": "ISC",
    "homepage": "git://github.com/svg/sax.git",
    "licenseFile": "/licenses/trysound-sax-0.2.0.txt"
  },
  {
    "name": "@types/aria-query",
    "version": "5.0.4",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/aria-query",
    "licenseFile": "/licenses/types-aria-query-5.0.4.txt"
  },
  {
    "name": "@types/babel__core",
    "version": "7.20.5",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/babel__core",
    "licenseFile": "/licenses/types-babel__core-7.20.5.txt"
  },
  {
    "name": "@types/babel__generator",
    "version": "7.27.0",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/babel__generator",
    "licenseFile": "/licenses/types-babel__generator-7.27.0.txt"
  },
  {
    "name": "@types/babel__template",
    "version": "7.4.4",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/babel__template",
    "licenseFile": "/licenses/types-babel__template-7.4.4.txt"
  },
  {
    "name": "@types/babel__traverse",
    "version": "7.28.0",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/babel__traverse",
    "licenseFile": "/licenses/types-babel__traverse-7.28.0.txt"
  },
  {
    "name": "@types/body-parser",
    "version": "1.19.6",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/body-parser",
    "licenseFile": "/licenses/types-body-parser-1.19.6.txt"
  },
  {
    "name": "@types/bonjour",
    "version": "3.5.13",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/bonjour",
    "licenseFile": "/licenses/types-bonjour-3.5.13.txt"
  },
  {
    "name": "@types/connect",
    "version": "3.4.38",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/connect",
    "licenseFile": "/licenses/types-connect-3.4.38.txt"
  },
  {
    "name": "@types/connect-history-api-fallback",
    "version": "1.5.4",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/connect-history-api-fallback",
    "licenseFile": "/licenses/types-connect-history-api-fallback-1.5.4.txt"
  },
  {
    "name": "@types/eslint",
    "version": "8.56.12",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/eslint",
    "licenseFile": "/licenses/types-eslint-8.56.12.txt"
  },
  {
    "name": "@types/eslint-scope",
    "version": "3.7.7",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/eslint-scope",
    "licenseFile": "/licenses/types-eslint-scope-3.7.7.txt"
  },
  {
    "name": "@types/estree",
    "version": "0.0.39",
    "license": "MIT",
    "homepage": "https://www.github.com/DefinitelyTyped/DefinitelyTyped.git",
    "licenseFile": "/licenses/types-estree-0.0.39.txt"
  },
  {
    "name": "@types/estree",
    "version": "1.0.8",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/estree",
    "licenseFile": "/licenses/types-estree-1.0.8.txt"
  },
  {
    "name": "@types/express",
    "version": "4.17.23",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/express",
    "licenseFile": "/licenses/types-express-4.17.23.txt"
  },
  {
    "name": "@types/express-serve-static-core",
    "version": "4.19.6",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/express-serve-static-core",
    "licenseFile": "/licenses/types-express-serve-static-core-4.19.6.txt"
  },
  {
    "name": "@types/express-serve-static-core",
    "version": "5.0.7",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/express-serve-static-core",
    "licenseFile": "/licenses/types-express-serve-static-core-5.0.7.txt"
  },
  {
    "name": "@types/geojson",
    "version": "7946.0.16",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/geojson",
    "licenseFile": "/licenses/types-geojson-7946.0.16.txt"
  },
  {
    "name": "@types/graceful-fs",
    "version": "4.1.9",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/graceful-fs",
    "licenseFile": "/licenses/types-graceful-fs-4.1.9.txt"
  },
  {
    "name": "@types/history",
    "version": "4.7.11",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/history",
    "licenseFile": "/licenses/types-history-4.7.11.txt"
  },
  {
    "name": "@types/html-minifier-terser",
    "version": "6.1.0",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/html-minifier-terser",
    "licenseFile": "/licenses/types-html-minifier-terser-6.1.0.txt"
  },
  {
    "name": "@types/http-errors",
    "version": "2.0.5",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/http-errors",
    "licenseFile": "/licenses/types-http-errors-2.0.5.txt"
  },
  {
    "name": "@types/http-proxy",
    "version": "1.17.16",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/http-proxy",
    "licenseFile": "/licenses/types-http-proxy-1.17.16.txt"
  },
  {
    "name": "@types/istanbul-lib-coverage",
    "version": "2.0.6",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/istanbul-lib-coverage",
    "licenseFile": "/licenses/types-istanbul-lib-coverage-2.0.6.txt"
  },
  {
    "name": "@types/istanbul-lib-report",
    "version": "3.0.3",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/istanbul-lib-report",
    "licenseFile": "/licenses/types-istanbul-lib-report-3.0.3.txt"
  },
  {
    "name": "@types/istanbul-reports",
    "version": "3.0.4",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/istanbul-reports",
    "licenseFile": "/licenses/types-istanbul-reports-3.0.4.txt"
  },
  {
    "name": "@types/json-schema",
    "version": "7.0.15",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/json-schema",
    "licenseFile": "/licenses/types-json-schema-7.0.15.txt"
  },
  {
    "name": "@types/json5",
    "version": "0.0.29",
    "license": "MIT",
    "homepage": "https://www.github.com/DefinitelyTyped/DefinitelyTyped.git",
    "licenseFile": null
  },
  {
    "name": "@types/leaflet",
    "version": "1.9.20",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/leaflet",
    "licenseFile": "/licenses/types-leaflet-1.9.20.txt"
  },
  {
    "name": "@types/mime",
    "version": "1.3.5",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/mime",
    "licenseFile": "/licenses/types-mime-1.3.5.txt"
  },
  {
    "name": "@types/node",
    "version": "24.3.0",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/node",
    "licenseFile": "/licenses/types-node-24.3.0.txt"
  },
  {
    "name": "@types/node-forge",
    "version": "1.3.14",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/node-forge",
    "licenseFile": "/licenses/types-node-forge-1.3.14.txt"
  },
  {
    "name": "@types/parse-json",
    "version": "4.0.2",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/parse-json",
    "licenseFile": "/licenses/types-parse-json-4.0.2.txt"
  },
  {
    "name": "@types/prettier",
    "version": "2.7.3",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/prettier",
    "licenseFile": "/licenses/types-prettier-2.7.3.txt"
  },
  {
    "name": "@types/q",
    "version": "1.5.8",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/q",
    "licenseFile": "/licenses/types-q-1.5.8.txt"
  },
  {
    "name": "@types/qs",
    "version": "6.14.0",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/qs",
    "licenseFile": "/licenses/types-qs-6.14.0.txt"
  },
  {
    "name": "@types/range-parser",
    "version": "1.2.7",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/range-parser",
    "licenseFile": "/licenses/types-range-parser-1.2.7.txt"
  },
  {
    "name": "@types/react",
    "version": "19.1.12",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/react",
    "licenseFile": "/licenses/types-react-19.1.12.txt"
  },
  {
    "name": "@types/react-leaflet",
    "version": "2.8.3",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/react-leaflet",
    "licenseFile": "/licenses/types-react-leaflet-2.8.3.txt"
  },
  {
    "name": "@types/react-router",
    "version": "5.1.20",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/react-router",
    "licenseFile": "/licenses/types-react-router-5.1.20.txt"
  },
  {
    "name": "@types/react-router-dom",
    "version": "5.3.3",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/react-router-dom",
    "licenseFile": "/licenses/types-react-router-dom-5.3.3.txt"
  },
  {
    "name": "@types/resolve",
    "version": "1.17.1",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped.git",
    "licenseFile": "/licenses/types-resolve-1.17.1.txt"
  },
  {
    "name": "@types/retry",
    "version": "0.12.0",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped.git",
    "licenseFile": "/licenses/types-retry-0.12.0.txt"
  },
  {
    "name": "@types/semver",
    "version": "7.7.0",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/semver",
    "licenseFile": "/licenses/types-semver-7.7.0.txt"
  },
  {
    "name": "@types/send",
    "version": "0.17.5",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/send",
    "licenseFile": "/licenses/types-send-0.17.5.txt"
  },
  {
    "name": "@types/serve-index",
    "version": "1.9.4",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/serve-index",
    "licenseFile": "/licenses/types-serve-index-1.9.4.txt"
  },
  {
    "name": "@types/serve-static",
    "version": "1.15.8",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/serve-static",
    "licenseFile": "/licenses/types-serve-static-1.15.8.txt"
  },
  {
    "name": "@types/sockjs",
    "version": "0.3.36",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/sockjs",
    "licenseFile": "/licenses/types-sockjs-0.3.36.txt"
  },
  {
    "name": "@types/stack-utils",
    "version": "2.0.3",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/stack-utils",
    "licenseFile": "/licenses/types-stack-utils-2.0.3.txt"
  },
  {
    "name": "@types/trusted-types",
    "version": "2.0.7",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/trusted-types",
    "licenseFile": "/licenses/types-trusted-types-2.0.7.txt"
  },
  {
    "name": "@types/ws",
    "version": "8.18.1",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/ws",
    "licenseFile": "/licenses/types-ws-8.18.1.txt"
  },
  {
    "name": "@types/yargs",
    "version": "16.0.9",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/yargs",
    "licenseFile": "/licenses/types-yargs-16.0.9.txt"
  },
  {
    "name": "@types/yargs",
    "version": "17.0.33",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/yargs",
    "licenseFile": "/licenses/types-yargs-17.0.33.txt"
  },
  {
    "name": "@types/yargs-parser",
    "version": "21.0.3",
    "license": "MIT",
    "homepage": "https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/yargs-parser",
    "licenseFile": "/licenses/types-yargs-parser-21.0.3.txt"
  },
  {
    "name": "@typescript-eslint/eslint-plugin",
    "version": "5.62.0",
    "license": "MIT",
    "homepage": "https://github.com/typescript-eslint/typescript-eslint.git",
    "licenseFile": "/licenses/typescript-eslint-eslint-plugin-5.62.0.txt"
  },
  {
    "name": "@typescript-eslint/experimental-utils",
    "version": "5.62.0",
    "license": "MIT",
    "homepage": "https://github.com/typescript-eslint/typescript-eslint.git",
    "licenseFile": "/licenses/typescript-eslint-experimental-utils-5.62.0.txt"
  },
  {
    "name": "@typescript-eslint/parser",
    "version": "5.62.0",
    "license": "BSD-2-Clause",
    "homepage": "https://github.com/typescript-eslint/typescript-eslint.git",
    "licenseFile": "/licenses/typescript-eslint-parser-5.62.0.txt"
  },
  {
    "name": "@typescript-eslint/scope-manager",
    "version": "5.62.0",
    "license": "MIT",
    "homepage": "https://github.com/typescript-eslint/typescript-eslint.git",
    "licenseFile": "/licenses/typescript-eslint-scope-manager-5.62.0.txt"
  },
  {
    "name": "@typescript-eslint/type-utils",
    "version": "5.62.0",
    "license": "MIT",
    "homepage": "https://github.com/typescript-eslint/typescript-eslint.git",
    "licenseFile": "/licenses/typescript-eslint-type-utils-5.62.0.txt"
  },
  {
    "name": "@typescript-eslint/types",
    "version": "5.62.0",
    "license": "MIT",
    "homepage": "https://github.com/typescript-eslint/typescript-eslint.git",
    "licenseFile": "/licenses/typescript-eslint-types-5.62.0.txt"
  },
  {
    "name": "@typescript-eslint/typescript-estree",
    "version": "5.62.0",
    "license": "BSD-2-Clause",
    "homepage": "https://github.com/typescript-eslint/typescript-eslint.git",
    "licenseFile": "/licenses/typescript-eslint-typescript-estree-5.62.0.txt"
  },
  {
    "name": "@typescript-eslint/utils",
    "version": "5.62.0",
    "license": "MIT",
    "homepage": "https://github.com/typescript-eslint/typescript-eslint.git",
    "licenseFile": "/licenses/typescript-eslint-utils-5.62.0.txt"
  },
  {
    "name": "@typescript-eslint/visitor-keys",
    "version": "5.62.0",
    "license": "MIT",
    "homepage": "https://github.com/typescript-eslint/typescript-eslint.git",
    "licenseFile": "/licenses/typescript-eslint-visitor-keys-5.62.0.txt"
  },
  {
    "name": "@ungap/structured-clone",
    "version": "1.3.0",
    "license": "ISC",
    "homepage": "https://github.com/ungap/structured-clone#readme",
    "licenseFile": "/licenses/ungap-structured-clone-1.3.0.txt"
  },
  {
    "name": "@webassemblyjs/ast",
    "version": "1.14.1",
    "license": "MIT",
    "homepage": "https://github.com/xtuc/webassemblyjs.git",
    "licenseFile": "/licenses/webassemblyjs-ast-1.14.1.txt"
  },
  {
    "name": "@webassemblyjs/floating-point-hex-parser",
    "version": "1.13.2",
    "license": "MIT",
    "homepage": "https://github.com/xtuc/webassemblyjs.git",
    "licenseFile": "/licenses/webassemblyjs-floating-point-hex-parser-1.13.2.txt"
  },
  {
    "name": "@webassemblyjs/helper-api-error",
    "version": "1.13.2",
    "license": "MIT",
    "homepage": "https://github.com/xtuc/webassemblyjs.git",
    "licenseFile": "/licenses/webassemblyjs-helper-api-error-1.13.2.txt"
  },
  {
    "name": "@webassemblyjs/helper-buffer",
    "version": "1.14.1",
    "license": "MIT",
    "homepage": "https://github.com/xtuc/webassemblyjs.git",
    "licenseFile": "/licenses/webassemblyjs-helper-buffer-1.14.1.txt"
  },
  {
    "name": "@webassemblyjs/helper-numbers",
    "version": "1.13.2",
    "license": "MIT",
    "homepage": "https://github.com/xtuc/webassemblyjs.git",
    "licenseFile": "/licenses/webassemblyjs-helper-numbers-1.13.2.txt"
  },
  {
    "name": "@webassemblyjs/helper-wasm-bytecode",
    "version": "1.13.2",
    "license": "MIT",
    "homepage": "https://github.com/xtuc/webassemblyjs.git",
    "licenseFile": "/licenses/webassemblyjs-helper-wasm-bytecode-1.13.2.txt"
  },
  {
    "name": "@webassemblyjs/helper-wasm-section",
    "version": "1.14.1",
    "license": "MIT",
    "homepage": "https://github.com/xtuc/webassemblyjs.git",
    "licenseFile": "/licenses/webassemblyjs-helper-wasm-section-1.14.1.txt"
  },
  {
    "name": "@webassemblyjs/ieee754",
    "version": "1.13.2",
    "license": "MIT",
    "homepage": "https://github.com/xtuc/webassemblyjs.git",
    "licenseFile": "/licenses/webassemblyjs-ieee754-1.13.2.txt"
  },
  {
    "name": "@webassemblyjs/leb128",
    "version": "1.13.2",
    "license": "Apache-2.0",
    "homepage": "https://github.com/xtuc/webassemblyjs.git",
    "licenseFile": "/licenses/webassemblyjs-leb128-1.13.2.txt"
  },
  {
    "name": "@webassemblyjs/utf8",
    "version": "1.13.2",
    "license": "MIT",
    "homepage": "https://github.com/xtuc/webassemblyjs.git",
    "licenseFile": "/licenses/webassemblyjs-utf8-1.13.2.txt"
  },
  {
    "name": "@webassemblyjs/wasm-edit",
    "version": "1.14.1",
    "license": "MIT",
    "homepage": "https://github.com/xtuc/webassemblyjs.git",
    "licenseFile": "/licenses/webassemblyjs-wasm-edit-1.14.1.txt"
  },
  {
    "name": "@webassemblyjs/wasm-gen",
    "version": "1.14.1",
    "license": "MIT",
    "homepage": "https://github.com/xtuc/webassemblyjs.git",
    "licenseFile": "/licenses/webassemblyjs-wasm-gen-1.14.1.txt"
  },
  {
    "name": "@webassemblyjs/wasm-opt",
    "version": "1.14.1",
    "license": "MIT",
    "homepage": "https://github.com/xtuc/webassemblyjs.git",
    "licenseFile": "/licenses/webassemblyjs-wasm-opt-1.14.1.txt"
  },
  {
    "name": "@webassemblyjs/wasm-parser",
    "version": "1.14.1",
    "license": "MIT",
    "homepage": "https://github.com/xtuc/webassemblyjs.git",
    "licenseFile": "/licenses/webassemblyjs-wasm-parser-1.14.1.txt"
  },
  {
    "name": "@webassemblyjs/wast-printer",
    "version": "1.14.1",
    "license": "MIT",
    "homepage": "https://github.com/xtuc/webassemblyjs.git",
    "licenseFile": "/licenses/webassemblyjs-wast-printer-1.14.1.txt"
  },
  {
    "name": "@xtuc/ieee754",
    "version": "1.2.0",
    "license": "BSD-3-Clause",
    "homepage": "git://github.com/feross/ieee754.git",
    "licenseFile": "/licenses/xtuc-ieee754-1.2.0.txt"
  },
  {
    "name": "@xtuc/long",
    "version": "4.2.2",
    "license": "Apache-2.0",
    "homepage": "https://github.com/dcodeIO/long.js.git",
    "licenseFile": "/licenses/xtuc-long-4.2.2.txt"
  },
  {
    "name": "abab",
    "version": "2.0.6",
    "license": "BSD-3-Clause",
    "homepage": "https://github.com/jsdom/abab#readme",
    "licenseFile": "/licenses/abab-2.0.6.txt"
  },
  {
    "name": "accepts",
    "version": "1.3.8",
    "license": "MIT",
    "homepage": "jshttp/accepts",
    "licenseFile": "/licenses/accepts-1.3.8.txt"
  },
  {
    "name": "acorn",
    "version": "8.15.0",
    "license": "MIT",
    "homepage": "https://github.com/acornjs/acorn",
    "licenseFile": "/licenses/acorn-8.15.0.txt"
  },
  {
    "name": "acorn",
    "version": "7.4.1",
    "license": "MIT",
    "homepage": "https://github.com/acornjs/acorn",
    "licenseFile": "/licenses/acorn-7.4.1.txt"
  },
  {
    "name": "acorn-globals",
    "version": "6.0.0",
    "license": "MIT",
    "homepage": "https://github.com/ForbesLindesay/acorn-globals.git",
    "licenseFile": "/licenses/acorn-globals-6.0.0.txt"
  },
  {
    "name": "acorn-import-phases",
    "version": "1.0.4",
    "license": "MIT",
    "homepage": "https://github.com/nicolo-ribaudo/acorn-import-phases.git",
    "licenseFile": "/licenses/acorn-import-phases-1.0.4.txt"
  },
  {
    "name": "acorn-jsx",
    "version": "5.3.2",
    "license": "MIT",
    "homepage": "https://github.com/acornjs/acorn-jsx",
    "licenseFile": "/licenses/acorn-jsx-5.3.2.txt"
  },
  {
    "name": "acorn-walk",
    "version": "7.2.0",
    "license": "MIT",
    "homepage": "https://github.com/acornjs/acorn",
    "licenseFile": "/licenses/acorn-walk-7.2.0.txt"
  },
  {
    "name": "address",
    "version": "1.2.2",
    "license": "MIT",
    "homepage": "git://github.com/node-modules/address.git",
    "licenseFile": "/licenses/address-1.2.2.txt"
  },
  {
    "name": "adjust-sourcemap-loader",
    "version": "4.0.0",
    "license": "MIT",
    "homepage": "https://github.com/bholloway/adjust-sourcemap-loader",
    "licenseFile": "/licenses/adjust-sourcemap-loader-4.0.0.txt"
  },
  {
    "name": "agent-base",
    "version": "6.0.2",
    "license": "MIT",
    "homepage": "git://github.com/TooTallNate/node-agent-base.git",
    "licenseFile": null
  },
  {
    "name": "ajv",
    "version": "6.12.6",
    "license": "MIT",
    "homepage": "https://github.com/ajv-validator/ajv",
    "licenseFile": "/licenses/ajv-6.12.6.txt"
  },
  {
    "name": "ajv",
    "version": "8.17.1",
    "license": "MIT",
    "homepage": "https://ajv.js.org",
    "licenseFile": "/licenses/ajv-8.17.1.txt"
  },
  {
    "name": "ajv-formats",
    "version": "2.1.1",
    "license": "MIT",
    "homepage": "https://github.com/ajv-validator/ajv-formats#readme",
    "licenseFile": "/licenses/ajv-formats-2.1.1.txt"
  },
  {
    "name": "ajv-keywords",
    "version": "3.5.2",
    "license": "MIT",
    "homepage": "https://github.com/epoberezkin/ajv-keywords#readme",
    "licenseFile": "/licenses/ajv-keywords-3.5.2.txt"
  },
  {
    "name": "ajv-keywords",
    "version": "5.1.0",
    "license": "MIT",
    "homepage": "https://github.com/epoberezkin/ajv-keywords#readme",
    "licenseFile": "/licenses/ajv-keywords-5.1.0.txt"
  },
  {
    "name": "ansi-escapes",
    "version": "4.3.2",
    "license": "MIT",
    "homepage": "sindresorhus/ansi-escapes",
    "licenseFile": "/licenses/ansi-escapes-4.3.2.txt"
  },
  {
    "name": "ansi-html",
    "version": "0.0.9",
    "license": "Apache-2.0",
    "homepage": "https://github.com/Tjatse/ansi-html",
    "licenseFile": "/licenses/ansi-html-0.0.9.txt"
  },
  {
    "name": "ansi-html-community",
    "version": "0.0.8",
    "license": "Apache-2.0",
    "homepage": "https://github.com/mahdyar/ansi-html-community",
    "licenseFile": "/licenses/ansi-html-community-0.0.8.txt"
  },
  {
    "name": "ansi-regex",
    "version": "6.2.0",
    "license": "MIT",
    "homepage": "chalk/ansi-regex",
    "licenseFile": "/licenses/ansi-regex-6.2.0.txt"
  },
  {
    "name": "ansi-regex",
    "version": "5.0.1",
    "license": "MIT",
    "homepage": "chalk/ansi-regex",
    "licenseFile": "/licenses/ansi-regex-5.0.1.txt"
  },
  {
    "name": "ansi-styles",
    "version": "6.2.1",
    "license": "MIT",
    "homepage": "chalk/ansi-styles",
    "licenseFile": "/licenses/ansi-styles-6.2.1.txt"
  },
  {
    "name": "ansi-styles",
    "version": "4.3.0",
    "license": "MIT",
    "homepage": "chalk/ansi-styles",
    "licenseFile": "/licenses/ansi-styles-4.3.0.txt"
  },
  {
    "name": "ansi-styles",
    "version": "3.2.1",
    "license": "MIT",
    "homepage": "chalk/ansi-styles",
    "licenseFile": "/licenses/ansi-styles-3.2.1.txt"
  },
  {
    "name": "ansi-styles",
    "version": "5.2.0",
    "license": "MIT",
    "homepage": "chalk/ansi-styles",
    "licenseFile": "/licenses/ansi-styles-5.2.0.txt"
  },
  {
    "name": "any-promise",
    "version": "1.3.0",
    "license": "MIT",
    "homepage": "http://github.com/kevinbeaty/any-promise",
    "licenseFile": "/licenses/any-promise-1.3.0.txt"
  },
  {
    "name": "anymatch",
    "version": "3.1.3",
    "license": "ISC",
    "homepage": "https://github.com/micromatch/anymatch",
    "licenseFile": "/licenses/anymatch-3.1.3.txt"
  },
  {
    "name": "arg",
    "version": "5.0.2",
    "license": "MIT",
    "homepage": "vercel/arg",
    "licenseFile": "/licenses/arg-5.0.2.txt"
  },
  {
    "name": "argparse",
    "version": "2.0.1",
    "license": "Python-2.0",
    "homepage": "nodeca/argparse",
    "licenseFile": "/licenses/argparse-2.0.1.txt"
  },
  {
    "name": "argparse",
    "version": "1.0.10",
    "license": "MIT",
    "homepage": "nodeca/argparse",
    "licenseFile": "/licenses/argparse-1.0.10.txt"
  },
  {
    "name": "aria-query",
    "version": "5.3.0",
    "license": "Apache-2.0",
    "homepage": "https://github.com/A11yance/aria-query#readme",
    "licenseFile": "/licenses/aria-query-5.3.0.txt"
  },
  {
    "name": "aria-query",
    "version": "5.3.2",
    "license": "Apache-2.0",
    "homepage": "https://github.com/A11yance/aria-query#readme",
    "licenseFile": "/licenses/aria-query-5.3.2.txt"
  },
  {
    "name": "array-buffer-byte-length",
    "version": "1.0.2",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/array-buffer-byte-length#readme",
    "licenseFile": "/licenses/array-buffer-byte-length-1.0.2.txt"
  },
  {
    "name": "array-flatten",
    "version": "1.1.1",
    "license": "MIT",
    "homepage": "https://github.com/blakeembrey/array-flatten",
    "licenseFile": "/licenses/array-flatten-1.1.1.txt"
  },
  {
    "name": "array-includes",
    "version": "3.1.9",
    "license": "MIT",
    "homepage": "git://github.com/es-shims/array-includes.git",
    "licenseFile": "/licenses/array-includes-3.1.9.txt"
  },
  {
    "name": "array-union",
    "version": "2.1.0",
    "license": "MIT",
    "homepage": "sindresorhus/array-union",
    "licenseFile": "/licenses/array-union-2.1.0.txt"
  },
  {
    "name": "array.prototype.findlast",
    "version": "1.2.5",
    "license": "MIT",
    "homepage": "https://github.com/es-shims/Array.prototype.findLast#readme",
    "licenseFile": "/licenses/array.prototype.findlast-1.2.5.txt"
  },
  {
    "name": "array.prototype.findlastindex",
    "version": "1.2.6",
    "license": "MIT",
    "homepage": "https://github.com/es-shims/Array.prototype.findLastIndex#readme",
    "licenseFile": "/licenses/array.prototype.findlastindex-1.2.6.txt"
  },
  {
    "name": "array.prototype.flat",
    "version": "1.3.3",
    "license": "MIT",
    "homepage": "git://github.com/es-shims/Array.prototype.flat.git",
    "licenseFile": "/licenses/array.prototype.flat-1.3.3.txt"
  },
  {
    "name": "array.prototype.flatmap",
    "version": "1.3.3",
    "license": "MIT",
    "homepage": "git://github.com/es-shims/Array.prototype.flatMap.git",
    "licenseFile": "/licenses/array.prototype.flatmap-1.3.3.txt"
  },
  {
    "name": "array.prototype.reduce",
    "version": "1.0.8",
    "license": "MIT",
    "homepage": "https://github.com/es-shims/Array.prototype.reduce#readme",
    "licenseFile": "/licenses/array.prototype.reduce-1.0.8.txt"
  },
  {
    "name": "array.prototype.tosorted",
    "version": "1.1.4",
    "license": "MIT",
    "homepage": "https://github.com/es-shims/Array.prototype.toSorted#readme",
    "licenseFile": "/licenses/array.prototype.tosorted-1.1.4.txt"
  },
  {
    "name": "arraybuffer.prototype.slice",
    "version": "1.0.4",
    "license": "MIT",
    "homepage": "https://github.com/es-shims/ArrayBuffer.prototype.slice#readme",
    "licenseFile": "/licenses/arraybuffer.prototype.slice-1.0.4.txt"
  },
  {
    "name": "asap",
    "version": "2.0.6",
    "license": "MIT",
    "homepage": "https://github.com/kriskowal/asap.git",
    "licenseFile": "/licenses/asap-2.0.6.txt"
  },
  {
    "name": "ast-types-flow",
    "version": "0.0.8",
    "license": "MIT",
    "homepage": "https://github.com/kyldvs/ast-types-flow#readme",
    "licenseFile": "/licenses/ast-types-flow-0.0.8.txt"
  },
  {
    "name": "async",
    "version": "3.2.6",
    "license": "MIT",
    "homepage": "https://caolan.github.io/async/",
    "licenseFile": "/licenses/async-3.2.6.txt"
  },
  {
    "name": "async-function",
    "version": "1.0.0",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/async-function#readme",
    "licenseFile": "/licenses/async-function-1.0.0.txt"
  },
  {
    "name": "asynckit",
    "version": "0.4.0",
    "license": "MIT",
    "homepage": "https://github.com/alexindigo/asynckit#readme",
    "licenseFile": "/licenses/asynckit-0.4.0.txt"
  },
  {
    "name": "at-least-node",
    "version": "1.0.0",
    "license": "ISC",
    "homepage": "https://github.com/RyanZim/at-least-node#readme",
    "licenseFile": "/licenses/at-least-node-1.0.0.txt"
  },
  {
    "name": "autoprefixer",
    "version": "10.4.21",
    "license": "MIT",
    "homepage": "postcss/autoprefixer",
    "licenseFile": "/licenses/autoprefixer-10.4.21.txt"
  },
  {
    "name": "available-typed-arrays",
    "version": "1.0.7",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/available-typed-arrays#readme",
    "licenseFile": "/licenses/available-typed-arrays-1.0.7.txt"
  },
  {
    "name": "axe-core",
    "version": "4.10.3",
    "license": "MPL-2.0",
    "homepage": "https://www.deque.com/axe/",
    "licenseFile": "/licenses/axe-core-4.10.3.txt"
  },
  {
    "name": "axobject-query",
    "version": "4.1.0",
    "license": "Apache-2.0",
    "homepage": "https://github.com/A11yance/axobject-query#readme",
    "licenseFile": "/licenses/axobject-query-4.1.0.txt"
  },
  {
    "name": "babel-jest",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/babel-jest-27.5.1.txt"
  },
  {
    "name": "babel-loader",
    "version": "8.4.1",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel-loader",
    "licenseFile": "/licenses/babel-loader-8.4.1.txt"
  },
  {
    "name": "babel-plugin-istanbul",
    "version": "6.1.1",
    "license": "BSD-3-Clause",
    "homepage": "https://github.com/istanbuljs/babel-plugin-istanbul#readme",
    "licenseFile": "/licenses/babel-plugin-istanbul-6.1.1.txt"
  },
  {
    "name": "babel-plugin-jest-hoist",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/babel-plugin-jest-hoist-27.5.1.txt"
  },
  {
    "name": "babel-plugin-macros",
    "version": "3.1.0",
    "license": "MIT",
    "homepage": "https://github.com/kentcdodds/babel-plugin-macros#readme",
    "licenseFile": "/licenses/babel-plugin-macros-3.1.0.txt"
  },
  {
    "name": "babel-plugin-named-asset-import",
    "version": "0.3.8",
    "license": "MIT",
    "homepage": "https://github.com/facebook/create-react-app.git",
    "licenseFile": "/licenses/babel-plugin-named-asset-import-0.3.8.txt"
  },
  {
    "name": "babel-plugin-polyfill-corejs2",
    "version": "0.4.14",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel-polyfills.git",
    "licenseFile": "/licenses/babel-plugin-polyfill-corejs2-0.4.14.txt"
  },
  {
    "name": "babel-plugin-polyfill-corejs3",
    "version": "0.13.0",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel-polyfills.git",
    "licenseFile": "/licenses/babel-plugin-polyfill-corejs3-0.13.0.txt"
  },
  {
    "name": "babel-plugin-polyfill-regenerator",
    "version": "0.6.5",
    "license": "MIT",
    "homepage": "https://github.com/babel/babel-polyfills.git",
    "licenseFile": "/licenses/babel-plugin-polyfill-regenerator-0.6.5.txt"
  },
  {
    "name": "babel-plugin-transform-react-remove-prop-types",
    "version": "0.4.24",
    "license": "MIT",
    "homepage": "https://github.com/oliviertassinari/babel-plugin-transform-react-remove-prop-types.git",
    "licenseFile": "/licenses/babel-plugin-transform-react-remove-prop-types-0.4.24.txt"
  },
  {
    "name": "babel-preset-current-node-syntax",
    "version": "1.2.0",
    "license": "MIT",
    "homepage": "https://github.com/nicolo-ribaudo/babel-preset-current-node-syntax.git",
    "licenseFile": "/licenses/babel-preset-current-node-syntax-1.2.0.txt"
  },
  {
    "name": "babel-preset-jest",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/babel-preset-jest-27.5.1.txt"
  },
  {
    "name": "babel-preset-react-app",
    "version": "10.1.0",
    "license": "MIT",
    "homepage": "https://github.com/facebook/create-react-app.git",
    "licenseFile": "/licenses/babel-preset-react-app-10.1.0.txt"
  },
  {
    "name": "balanced-match",
    "version": "1.0.2",
    "license": "MIT",
    "homepage": "https://github.com/juliangruber/balanced-match",
    "licenseFile": "/licenses/balanced-match-1.0.2.txt"
  },
  {
    "name": "batch",
    "version": "0.6.1",
    "license": "MIT",
    "homepage": "https://github.com/visionmedia/batch.git",
    "licenseFile": "/licenses/batch-0.6.1.txt"
  },
  {
    "name": "bfj",
    "version": "7.1.0",
    "license": "MIT",
    "homepage": "https://gitlab.com/philbooth/bfj",
    "licenseFile": "/licenses/bfj-7.1.0.txt"
  },
  {
    "name": "big.js",
    "version": "5.2.2",
    "license": "MIT",
    "homepage": "https://github.com/MikeMcl/big.js.git",
    "licenseFile": "/licenses/big.js-5.2.2.txt"
  },
  {
    "name": "binary-extensions",
    "version": "2.3.0",
    "license": "MIT",
    "homepage": "sindresorhus/binary-extensions",
    "licenseFile": "/licenses/binary-extensions-2.3.0.txt"
  },
  {
    "name": "bluebird",
    "version": "3.7.2",
    "license": "MIT",
    "homepage": "https://github.com/petkaantonov/bluebird",
    "licenseFile": "/licenses/bluebird-3.7.2.txt"
  },
  {
    "name": "body-parser",
    "version": "1.20.3",
    "license": "MIT",
    "homepage": "expressjs/body-parser",
    "licenseFile": "/licenses/body-parser-1.20.3.txt"
  },
  {
    "name": "bonjour-service",
    "version": "1.3.0",
    "license": "MIT",
    "homepage": "https://github.com/onlxltd/bonjour-service",
    "licenseFile": "/licenses/bonjour-service-1.3.0.txt"
  },
  {
    "name": "boolbase",
    "version": "1.0.0",
    "license": "ISC",
    "homepage": "https://github.com/fb55/boolbase",
    "licenseFile": null
  },
  {
    "name": "brace-expansion",
    "version": "1.1.12",
    "license": "MIT",
    "homepage": "https://github.com/juliangruber/brace-expansion",
    "licenseFile": "/licenses/brace-expansion-1.1.12.txt"
  },
  {
    "name": "brace-expansion",
    "version": "2.0.2",
    "license": "MIT",
    "homepage": "https://github.com/juliangruber/brace-expansion",
    "licenseFile": "/licenses/brace-expansion-2.0.2.txt"
  },
  {
    "name": "braces",
    "version": "3.0.3",
    "license": "MIT",
    "homepage": "https://github.com/micromatch/braces",
    "licenseFile": "/licenses/braces-3.0.3.txt"
  },
  {
    "name": "browser-process-hrtime",
    "version": "1.0.0",
    "license": "BSD-2-Clause",
    "homepage": "git://github.com/kumavis/browser-process-hrtime.git",
    "licenseFile": "/licenses/browser-process-hrtime-1.0.0.txt"
  },
  {
    "name": "browserslist",
    "version": "4.25.4",
    "license": "MIT",
    "homepage": "browserslist/browserslist",
    "licenseFile": "/licenses/browserslist-4.25.4.txt"
  },
  {
    "name": "bser",
    "version": "2.1.1",
    "license": "Apache-2.0",
    "homepage": "https://facebook.github.io/watchman/docs/bser.html",
    "licenseFile": null
  },
  {
    "name": "buffer-from",
    "version": "1.1.2",
    "license": "MIT",
    "homepage": "LinusU/buffer-from",
    "licenseFile": "/licenses/buffer-from-1.1.2.txt"
  },
  {
    "name": "builtin-modules",
    "version": "3.3.0",
    "license": "MIT",
    "homepage": "sindresorhus/builtin-modules",
    "licenseFile": "/licenses/builtin-modules-3.3.0.txt"
  },
  {
    "name": "bytes",
    "version": "3.1.2",
    "license": "MIT",
    "homepage": "visionmedia/bytes.js",
    "licenseFile": "/licenses/bytes-3.1.2.txt"
  },
  {
    "name": "call-bind",
    "version": "1.0.8",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/call-bind#readme",
    "licenseFile": "/licenses/call-bind-1.0.8.txt"
  },
  {
    "name": "call-bind-apply-helpers",
    "version": "1.0.2",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/call-bind-apply-helpers#readme",
    "licenseFile": "/licenses/call-bind-apply-helpers-1.0.2.txt"
  },
  {
    "name": "call-bound",
    "version": "1.0.4",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/call-bound#readme",
    "licenseFile": "/licenses/call-bound-1.0.4.txt"
  },
  {
    "name": "callsites",
    "version": "3.1.0",
    "license": "MIT",
    "homepage": "sindresorhus/callsites",
    "licenseFile": "/licenses/callsites-3.1.0.txt"
  },
  {
    "name": "camel-case",
    "version": "4.1.2",
    "license": "MIT",
    "homepage": "https://github.com/blakeembrey/change-case/tree/master/packages/camel-case#readme",
    "licenseFile": "/licenses/camel-case-4.1.2.txt"
  },
  {
    "name": "camelcase",
    "version": "5.3.1",
    "license": "MIT",
    "homepage": "sindresorhus/camelcase",
    "licenseFile": "/licenses/camelcase-5.3.1.txt"
  },
  {
    "name": "camelcase",
    "version": "6.3.0",
    "license": "MIT",
    "homepage": "sindresorhus/camelcase",
    "licenseFile": "/licenses/camelcase-6.3.0.txt"
  },
  {
    "name": "camelcase-css",
    "version": "2.0.1",
    "license": "MIT",
    "homepage": "stevenvachon/camelcase-css",
    "licenseFile": "/licenses/camelcase-css-2.0.1.txt"
  },
  {
    "name": "caniuse-api",
    "version": "3.0.0",
    "license": "MIT",
    "homepage": "https://github.com/nyalab/caniuse-api.git",
    "licenseFile": "/licenses/caniuse-api-3.0.0.txt"
  },
  {
    "name": "caniuse-lite",
    "version": "1.0.30001737",
    "license": "CC-BY-4.0",
    "homepage": "browserslist/caniuse-lite",
    "licenseFile": "/licenses/caniuse-lite-1.0.30001737.txt"
  },
  {
    "name": "case-sensitive-paths-webpack-plugin",
    "version": "2.4.0",
    "license": "MIT",
    "homepage": "https://github.com/Urthen/case-sensitive-paths-webpack-plugin#readme",
    "licenseFile": "/licenses/case-sensitive-paths-webpack-plugin-2.4.0.txt"
  },
  {
    "name": "chalk",
    "version": "4.1.2",
    "license": "MIT",
    "homepage": "chalk/chalk",
    "licenseFile": "/licenses/chalk-4.1.2.txt"
  },
  {
    "name": "chalk",
    "version": "2.4.2",
    "license": "MIT",
    "homepage": "chalk/chalk",
    "licenseFile": "/licenses/chalk-2.4.2.txt"
  },
  {
    "name": "char-regex",
    "version": "1.0.2",
    "license": "MIT",
    "homepage": "https://github.com/Richienb/char-regex.git",
    "licenseFile": "/licenses/char-regex-1.0.2.txt"
  },
  {
    "name": "char-regex",
    "version": "2.0.2",
    "license": "MIT",
    "homepage": "Richienb/char-regex",
    "licenseFile": "/licenses/char-regex-2.0.2.txt"
  },
  {
    "name": "chart.js",
    "version": "4.5.0",
    "license": "MIT",
    "homepage": "https://www.chartjs.org",
    "licenseFile": "/licenses/chart.js-4.5.0.txt"
  },
  {
    "name": "check-types",
    "version": "11.2.3",
    "license": "MIT",
    "homepage": "https://gitlab.com/philbooth/check-types.js",
    "licenseFile": "/licenses/check-types-11.2.3.txt"
  },
  {
    "name": "chokidar",
    "version": "3.6.0",
    "license": "MIT",
    "homepage": "https://github.com/paulmillr/chokidar",
    "licenseFile": "/licenses/chokidar-3.6.0.txt"
  },
  {
    "name": "chrome-trace-event",
    "version": "1.0.4",
    "license": "MIT",
    "homepage": "github:samccone/chrome-trace-event",
    "licenseFile": "/licenses/chrome-trace-event-1.0.4.txt"
  },
  {
    "name": "ci-info",
    "version": "3.9.0",
    "license": "MIT",
    "homepage": "https://github.com/watson/ci-info",
    "licenseFile": "/licenses/ci-info-3.9.0.txt"
  },
  {
    "name": "cjs-module-lexer",
    "version": "1.4.3",
    "license": "MIT",
    "homepage": "https://github.com/nodejs/cjs-module-lexer#readme",
    "licenseFile": "/licenses/cjs-module-lexer-1.4.3.txt"
  },
  {
    "name": "clean-css",
    "version": "5.3.3",
    "license": "MIT",
    "homepage": "https://github.com/clean-css/clean-css",
    "licenseFile": "/licenses/clean-css-5.3.3.txt"
  },
  {
    "name": "cliui",
    "version": "7.0.4",
    "license": "ISC",
    "homepage": "yargs/cliui",
    "licenseFile": "/licenses/cliui-7.0.4.txt"
  },
  {
    "name": "co",
    "version": "4.6.0",
    "license": "MIT",
    "homepage": "tj/co",
    "licenseFile": "/licenses/co-4.6.0.txt"
  },
  {
    "name": "coa",
    "version": "2.0.2",
    "license": "MIT",
    "homepage": "http://github.com/veged/coa",
    "licenseFile": "/licenses/coa-2.0.2.txt"
  },
  {
    "name": "collect-v8-coverage",
    "version": "1.0.2",
    "license": "MIT",
    "homepage": "SimenB/collect-v8-coverage",
    "licenseFile": "/licenses/collect-v8-coverage-1.0.2.txt"
  },
  {
    "name": "color-convert",
    "version": "1.9.3",
    "license": "MIT",
    "homepage": "Qix-/color-convert",
    "licenseFile": "/licenses/color-convert-1.9.3.txt"
  },
  {
    "name": "color-convert",
    "version": "2.0.1",
    "license": "MIT",
    "homepage": "Qix-/color-convert",
    "licenseFile": "/licenses/color-convert-2.0.1.txt"
  },
  {
    "name": "color-name",
    "version": "1.1.3",
    "license": "MIT",
    "homepage": "https://github.com/dfcreative/color-name",
    "licenseFile": "/licenses/color-name-1.1.3.txt"
  },
  {
    "name": "color-name",
    "version": "1.1.4",
    "license": "MIT",
    "homepage": "https://github.com/colorjs/color-name",
    "licenseFile": "/licenses/color-name-1.1.4.txt"
  },
  {
    "name": "colord",
    "version": "2.9.3",
    "license": "MIT",
    "homepage": "omgovich/colord",
    "licenseFile": "/licenses/colord-2.9.3.txt"
  },
  {
    "name": "colorette",
    "version": "2.0.20",
    "license": "MIT",
    "homepage": "jorgebucaran/colorette",
    "licenseFile": "/licenses/colorette-2.0.20.txt"
  },
  {
    "name": "combined-stream",
    "version": "1.0.8",
    "license": "MIT",
    "homepage": "https://github.com/felixge/node-combined-stream",
    "licenseFile": "/licenses/combined-stream-1.0.8.txt"
  },
  {
    "name": "commander",
    "version": "8.3.0",
    "license": "MIT",
    "homepage": "https://github.com/tj/commander.js.git",
    "licenseFile": "/licenses/commander-8.3.0.txt"
  },
  {
    "name": "commander",
    "version": "7.2.0",
    "license": "MIT",
    "homepage": "https://github.com/tj/commander.js.git",
    "licenseFile": "/licenses/commander-7.2.0.txt"
  },
  {
    "name": "commander",
    "version": "4.1.1",
    "license": "MIT",
    "homepage": "https://github.com/tj/commander.js.git",
    "licenseFile": "/licenses/commander-4.1.1.txt"
  },
  {
    "name": "commander",
    "version": "2.20.3",
    "license": "MIT",
    "homepage": "https://github.com/tj/commander.js.git",
    "licenseFile": "/licenses/commander-2.20.3.txt"
  },
  {
    "name": "common-tags",
    "version": "1.8.2",
    "license": "MIT",
    "homepage": "https://github.com/zspecza/common-tags",
    "licenseFile": "/licenses/common-tags-1.8.2.txt"
  },
  {
    "name": "commondir",
    "version": "1.0.1",
    "license": "MIT",
    "homepage": "http://github.com/substack/node-commondir.git",
    "licenseFile": "/licenses/commondir-1.0.1.txt"
  },
  {
    "name": "compressible",
    "version": "2.0.18",
    "license": "MIT",
    "homepage": "jshttp/compressible",
    "licenseFile": "/licenses/compressible-2.0.18.txt"
  },
  {
    "name": "compression",
    "version": "1.8.1",
    "license": "MIT",
    "homepage": "expressjs/compression",
    "licenseFile": "/licenses/compression-1.8.1.txt"
  },
  {
    "name": "concat-map",
    "version": "0.0.1",
    "license": "MIT",
    "homepage": "git://github.com/substack/node-concat-map.git",
    "licenseFile": "/licenses/concat-map-0.0.1.txt"
  },
  {
    "name": "confusing-browser-globals",
    "version": "1.0.11",
    "license": "MIT",
    "homepage": "https://github.com/facebook/create-react-app.git",
    "licenseFile": "/licenses/confusing-browser-globals-1.0.11.txt"
  },
  {
    "name": "connect-history-api-fallback",
    "version": "2.0.0",
    "license": "MIT",
    "homepage": "http://github.com/bripkens/connect-history-api-fallback.git",
    "licenseFile": "/licenses/connect-history-api-fallback-2.0.0.txt"
  },
  {
    "name": "content-disposition",
    "version": "0.5.4",
    "license": "MIT",
    "homepage": "jshttp/content-disposition",
    "licenseFile": "/licenses/content-disposition-0.5.4.txt"
  },
  {
    "name": "content-type",
    "version": "1.0.5",
    "license": "MIT",
    "homepage": "jshttp/content-type",
    "licenseFile": "/licenses/content-type-1.0.5.txt"
  },
  {
    "name": "convert-source-map",
    "version": "1.9.0",
    "license": "MIT",
    "homepage": "https://github.com/thlorenz/convert-source-map",
    "licenseFile": "/licenses/convert-source-map-1.9.0.txt"
  },
  {
    "name": "convert-source-map",
    "version": "2.0.0",
    "license": "MIT",
    "homepage": "https://github.com/thlorenz/convert-source-map",
    "licenseFile": "/licenses/convert-source-map-2.0.0.txt"
  },
  {
    "name": "cookie",
    "version": "0.7.1",
    "license": "MIT",
    "homepage": "jshttp/cookie",
    "licenseFile": "/licenses/cookie-0.7.1.txt"
  },
  {
    "name": "cookie",
    "version": "1.0.2",
    "license": "MIT",
    "homepage": "jshttp/cookie",
    "licenseFile": "/licenses/cookie-1.0.2.txt"
  },
  {
    "name": "cookie-signature",
    "version": "1.0.6",
    "license": "MIT",
    "homepage": "https://github.com/visionmedia/node-cookie-signature.git",
    "licenseFile": null
  },
  {
    "name": "core-js",
    "version": "3.45.1",
    "license": "MIT",
    "homepage": "https://github.com/zloirock/core-js.git",
    "licenseFile": "/licenses/core-js-3.45.1.txt"
  },
  {
    "name": "core-js-compat",
    "version": "3.45.1",
    "license": "MIT",
    "homepage": "https://github.com/zloirock/core-js.git",
    "licenseFile": "/licenses/core-js-compat-3.45.1.txt"
  },
  {
    "name": "core-js-pure",
    "version": "3.45.1",
    "license": "MIT",
    "homepage": "https://github.com/zloirock/core-js.git",
    "licenseFile": "/licenses/core-js-pure-3.45.1.txt"
  },
  {
    "name": "core-util-is",
    "version": "1.0.3",
    "license": "MIT",
    "homepage": "git://github.com/isaacs/core-util-is",
    "licenseFile": "/licenses/core-util-is-1.0.3.txt"
  },
  {
    "name": "cosmiconfig",
    "version": "7.1.0",
    "license": "MIT",
    "homepage": "https://github.com/davidtheclark/cosmiconfig#readme",
    "licenseFile": "/licenses/cosmiconfig-7.1.0.txt"
  },
  {
    "name": "cosmiconfig",
    "version": "6.0.0",
    "license": "MIT",
    "homepage": "https://github.com/davidtheclark/cosmiconfig#readme",
    "licenseFile": "/licenses/cosmiconfig-6.0.0.txt"
  },
  {
    "name": "cross-spawn",
    "version": "7.0.6",
    "license": "MIT",
    "homepage": "https://github.com/moxystudio/node-cross-spawn",
    "licenseFile": "/licenses/cross-spawn-7.0.6.txt"
  },
  {
    "name": "crypto-random-string",
    "version": "2.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/crypto-random-string",
    "licenseFile": "/licenses/crypto-random-string-2.0.0.txt"
  },
  {
    "name": "css-blank-pseudo",
    "version": "3.0.3",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/css-blank-pseudo#readme",
    "licenseFile": "/licenses/css-blank-pseudo-3.0.3.txt"
  },
  {
    "name": "css-declaration-sorter",
    "version": "6.4.1",
    "license": "ISC",
    "homepage": "https://github.com/Siilwyn/css-declaration-sorter.git",
    "licenseFile": "/licenses/css-declaration-sorter-6.4.1.txt"
  },
  {
    "name": "css-has-pseudo",
    "version": "3.0.4",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/css-has-pseudo#readme",
    "licenseFile": "/licenses/css-has-pseudo-3.0.4.txt"
  },
  {
    "name": "css-loader",
    "version": "6.11.0",
    "license": "MIT",
    "homepage": "https://github.com/webpack-contrib/css-loader",
    "licenseFile": "/licenses/css-loader-6.11.0.txt"
  },
  {
    "name": "css-minimizer-webpack-plugin",
    "version": "3.4.1",
    "license": "MIT",
    "homepage": "https://github.com/webpack-contrib/css-minimizer-webpack-plugin",
    "licenseFile": "/licenses/css-minimizer-webpack-plugin-3.4.1.txt"
  },
  {
    "name": "css-prefers-color-scheme",
    "version": "6.0.3",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/css-prefers-color-scheme#readme",
    "licenseFile": "/licenses/css-prefers-color-scheme-6.0.3.txt"
  },
  {
    "name": "css-select",
    "version": "4.3.0",
    "license": "BSD-2-Clause",
    "homepage": "git://github.com/fb55/css-select.git",
    "licenseFile": "/licenses/css-select-4.3.0.txt"
  },
  {
    "name": "css-select",
    "version": "2.1.0",
    "license": "BSD-2-Clause",
    "homepage": "git://github.com/fb55/css-select.git",
    "licenseFile": "/licenses/css-select-2.1.0.txt"
  },
  {
    "name": "css-select-base-adapter",
    "version": "0.1.1",
    "license": "MIT",
    "homepage": "https://github.com/nrkn/css-select-base-adapter#readme",
    "licenseFile": "/licenses/css-select-base-adapter-0.1.1.txt"
  },
  {
    "name": "css-tree",
    "version": "1.0.0-alpha.37",
    "license": "MIT",
    "homepage": "csstree/csstree",
    "licenseFile": "/licenses/css-tree-1.0.0-alpha.37.txt"
  },
  {
    "name": "css-tree",
    "version": "1.1.3",
    "license": "MIT",
    "homepage": "csstree/csstree",
    "licenseFile": "/licenses/css-tree-1.1.3.txt"
  },
  {
    "name": "css-what",
    "version": "6.2.2",
    "license": "BSD-2-Clause",
    "homepage": "https://github.com/fb55/css-what",
    "licenseFile": "/licenses/css-what-6.2.2.txt"
  },
  {
    "name": "css-what",
    "version": "3.4.2",
    "license": "BSD-2-Clause",
    "homepage": "https://github.com/fb55/css-what",
    "licenseFile": "/licenses/css-what-3.4.2.txt"
  },
  {
    "name": "css.escape",
    "version": "1.5.1",
    "license": "MIT",
    "homepage": "https://mths.be/cssescape",
    "licenseFile": null
  },
  {
    "name": "cssdb",
    "version": "7.11.2",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/cssdb#readme",
    "licenseFile": "/licenses/cssdb-7.11.2.txt"
  },
  {
    "name": "cssesc",
    "version": "3.0.0",
    "license": "MIT",
    "homepage": "https://mths.be/cssesc",
    "licenseFile": null
  },
  {
    "name": "cssnano",
    "version": "5.1.15",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "cssnano-preset-default",
    "version": "5.2.14",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "cssnano-utils",
    "version": "3.1.0",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": "/licenses/cssnano-utils-3.1.0.txt"
  },
  {
    "name": "csso",
    "version": "4.2.0",
    "license": "MIT",
    "homepage": "https://github.com/css/csso",
    "licenseFile": "/licenses/csso-4.2.0.txt"
  },
  {
    "name": "cssom",
    "version": "0.4.4",
    "license": "MIT",
    "homepage": "NV/CSSOM",
    "licenseFile": "/licenses/cssom-0.4.4.txt"
  },
  {
    "name": "cssom",
    "version": "0.3.8",
    "license": "MIT",
    "homepage": "NV/CSSOM",
    "licenseFile": "/licenses/cssom-0.3.8.txt"
  },
  {
    "name": "cssstyle",
    "version": "2.3.0",
    "license": "MIT",
    "homepage": "https://github.com/jsdom/cssstyle",
    "licenseFile": "/licenses/cssstyle-2.3.0.txt"
  },
  {
    "name": "csstype",
    "version": "3.1.3",
    "license": "MIT",
    "homepage": "https://github.com/frenic/csstype",
    "licenseFile": "/licenses/csstype-3.1.3.txt"
  },
  {
    "name": "damerau-levenshtein",
    "version": "1.0.8",
    "license": "BSD-2-Clause",
    "homepage": "https://github.com/tad-lispy/node-damerau-levenshtein.git",
    "licenseFile": "/licenses/damerau-levenshtein-1.0.8.txt"
  },
  {
    "name": "data-urls",
    "version": "2.0.0",
    "license": "MIT",
    "homepage": "jsdom/data-urls",
    "licenseFile": "/licenses/data-urls-2.0.0.txt"
  },
  {
    "name": "data-view-buffer",
    "version": "1.0.2",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/data-view-buffer#readme",
    "licenseFile": "/licenses/data-view-buffer-1.0.2.txt"
  },
  {
    "name": "data-view-byte-length",
    "version": "1.0.2",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/data-view-byte-length#readme",
    "licenseFile": "/licenses/data-view-byte-length-1.0.2.txt"
  },
  {
    "name": "data-view-byte-offset",
    "version": "1.0.1",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/data-view-byte-offset#readme",
    "licenseFile": "/licenses/data-view-byte-offset-1.0.1.txt"
  },
  {
    "name": "debug",
    "version": "2.6.9",
    "license": "MIT",
    "homepage": "git://github.com/visionmedia/debug.git",
    "licenseFile": "/licenses/debug-2.6.9.txt"
  },
  {
    "name": "debug",
    "version": "4.4.1",
    "license": "MIT",
    "homepage": "git://github.com/debug-js/debug.git",
    "licenseFile": "/licenses/debug-4.4.1.txt"
  },
  {
    "name": "debug",
    "version": "3.2.7",
    "license": "MIT",
    "homepage": "git://github.com/visionmedia/debug.git",
    "licenseFile": "/licenses/debug-3.2.7.txt"
  },
  {
    "name": "decimal.js",
    "version": "10.6.0",
    "license": "MIT",
    "homepage": "https://github.com/MikeMcl/decimal.js.git",
    "licenseFile": "/licenses/decimal.js-10.6.0.txt"
  },
  {
    "name": "dedent",
    "version": "0.7.0",
    "license": "MIT",
    "homepage": "https://github.com/dmnd/dedent",
    "licenseFile": "/licenses/dedent-0.7.0.txt"
  },
  {
    "name": "deep-is",
    "version": "0.1.4",
    "license": "MIT",
    "homepage": "http://github.com/thlorenz/deep-is.git",
    "licenseFile": "/licenses/deep-is-0.1.4.txt"
  },
  {
    "name": "deepmerge",
    "version": "4.3.1",
    "license": "MIT",
    "homepage": "https://github.com/TehShrike/deepmerge",
    "licenseFile": "/licenses/deepmerge-4.3.1.txt"
  },
  {
    "name": "default-gateway",
    "version": "6.0.3",
    "license": "BSD-2-Clause",
    "homepage": "silverwind/default-gateway",
    "licenseFile": "/licenses/default-gateway-6.0.3.txt"
  },
  {
    "name": "define-data-property",
    "version": "1.1.4",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/define-data-property#readme",
    "licenseFile": "/licenses/define-data-property-1.1.4.txt"
  },
  {
    "name": "define-lazy-prop",
    "version": "2.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/define-lazy-prop",
    "licenseFile": "/licenses/define-lazy-prop-2.0.0.txt"
  },
  {
    "name": "define-properties",
    "version": "1.2.1",
    "license": "MIT",
    "homepage": "git://github.com/ljharb/define-properties.git",
    "licenseFile": "/licenses/define-properties-1.2.1.txt"
  },
  {
    "name": "delayed-stream",
    "version": "1.0.0",
    "license": "MIT",
    "homepage": "https://github.com/felixge/node-delayed-stream",
    "licenseFile": "/licenses/delayed-stream-1.0.0.txt"
  },
  {
    "name": "depd",
    "version": "2.0.0",
    "license": "MIT",
    "homepage": "dougwilson/nodejs-depd",
    "licenseFile": "/licenses/depd-2.0.0.txt"
  },
  {
    "name": "depd",
    "version": "1.1.2",
    "license": "MIT",
    "homepage": "dougwilson/nodejs-depd",
    "licenseFile": "/licenses/depd-1.1.2.txt"
  },
  {
    "name": "dequal",
    "version": "2.0.3",
    "license": "MIT",
    "homepage": "lukeed/dequal",
    "licenseFile": "/licenses/dequal-2.0.3.txt"
  },
  {
    "name": "destroy",
    "version": "1.2.0",
    "license": "MIT",
    "homepage": "stream-utils/destroy",
    "licenseFile": "/licenses/destroy-1.2.0.txt"
  },
  {
    "name": "detect-newline",
    "version": "3.1.0",
    "license": "MIT",
    "homepage": "sindresorhus/detect-newline",
    "licenseFile": "/licenses/detect-newline-3.1.0.txt"
  },
  {
    "name": "detect-node",
    "version": "2.1.0",
    "license": "MIT",
    "homepage": "https://github.com/iliakan/detect-node",
    "licenseFile": "/licenses/detect-node-2.1.0.txt"
  },
  {
    "name": "detect-port-alt",
    "version": "1.1.6",
    "license": "MIT",
    "homepage": "https://github.com/node-modules/detect-port",
    "licenseFile": "/licenses/detect-port-alt-1.1.6.txt"
  },
  {
    "name": "didyoumean",
    "version": "1.2.2",
    "license": "Apache-2.0",
    "homepage": "https://github.com/dcporter/didyoumean.js",
    "licenseFile": "/licenses/didyoumean-1.2.2.txt"
  },
  {
    "name": "diff-sequences",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/diff-sequences-27.5.1.txt"
  },
  {
    "name": "dir-glob",
    "version": "3.0.1",
    "license": "MIT",
    "homepage": "kevva/dir-glob",
    "licenseFile": "/licenses/dir-glob-3.0.1.txt"
  },
  {
    "name": "dlv",
    "version": "1.1.3",
    "license": "MIT",
    "homepage": "developit/dlv",
    "licenseFile": null
  },
  {
    "name": "dns-packet",
    "version": "5.6.1",
    "license": "MIT",
    "homepage": "https://github.com/mafintosh/dns-packet",
    "licenseFile": "/licenses/dns-packet-5.6.1.txt"
  },
  {
    "name": "doctrine",
    "version": "3.0.0",
    "license": "Apache-2.0",
    "homepage": "https://github.com/eslint/doctrine",
    "licenseFile": "/licenses/doctrine-3.0.0.txt"
  },
  {
    "name": "doctrine",
    "version": "2.1.0",
    "license": "Apache-2.0",
    "homepage": "https://github.com/eslint/doctrine",
    "licenseFile": "/licenses/doctrine-2.1.0.txt"
  },
  {
    "name": "dom-accessibility-api",
    "version": "0.6.3",
    "license": "MIT",
    "homepage": "https://github.com/eps1lon/dom-accessibility-api.git",
    "licenseFile": "/licenses/dom-accessibility-api-0.6.3.txt"
  },
  {
    "name": "dom-accessibility-api",
    "version": "0.5.16",
    "license": "MIT",
    "homepage": "https://github.com/eps1lon/dom-accessibility-api.git",
    "licenseFile": "/licenses/dom-accessibility-api-0.5.16.txt"
  },
  {
    "name": "dom-converter",
    "version": "0.2.0",
    "license": "MIT",
    "homepage": "https://github.com/AriaMinaei/dom-converter",
    "licenseFile": "/licenses/dom-converter-0.2.0.txt"
  },
  {
    "name": "dom-serializer",
    "version": "1.4.1",
    "license": "MIT",
    "homepage": "git://github.com/cheeriojs/dom-renderer.git",
    "licenseFile": "/licenses/dom-serializer-1.4.1.txt"
  },
  {
    "name": "dom-serializer",
    "version": "0.2.2",
    "license": "MIT",
    "homepage": "git://github.com/cheeriojs/dom-renderer.git",
    "licenseFile": "/licenses/dom-serializer-0.2.2.txt"
  },
  {
    "name": "domelementtype",
    "version": "2.3.0",
    "license": "BSD-2-Clause",
    "homepage": "git://github.com/fb55/domelementtype.git",
    "licenseFile": "/licenses/domelementtype-2.3.0.txt"
  },
  {
    "name": "domelementtype",
    "version": "1.3.1",
    "license": "BSD-2-Clause",
    "homepage": "git://github.com/fb55/domelementtype.git",
    "licenseFile": "/licenses/domelementtype-1.3.1.txt"
  },
  {
    "name": "domexception",
    "version": "2.0.1",
    "license": "MIT",
    "homepage": "jsdom/domexception",
    "licenseFile": "/licenses/domexception-2.0.1.txt"
  },
  {
    "name": "domhandler",
    "version": "4.3.1",
    "license": "BSD-2-Clause",
    "homepage": "git://github.com/fb55/domhandler.git",
    "licenseFile": "/licenses/domhandler-4.3.1.txt"
  },
  {
    "name": "domutils",
    "version": "2.8.0",
    "license": "BSD-2-Clause",
    "homepage": "git://github.com/fb55/domutils.git",
    "licenseFile": "/licenses/domutils-2.8.0.txt"
  },
  {
    "name": "domutils",
    "version": "1.7.0",
    "license": "BSD-2-Clause",
    "homepage": "git://github.com/FB55/domutils.git",
    "licenseFile": "/licenses/domutils-1.7.0.txt"
  },
  {
    "name": "dot-case",
    "version": "3.0.4",
    "license": "MIT",
    "homepage": "https://github.com/blakeembrey/change-case/tree/master/packages/dot-case#readme",
    "licenseFile": "/licenses/dot-case-3.0.4.txt"
  },
  {
    "name": "dotenv",
    "version": "10.0.0",
    "license": "BSD-2-Clause",
    "homepage": "git://github.com/motdotla/dotenv.git",
    "licenseFile": "/licenses/dotenv-10.0.0.txt"
  },
  {
    "name": "dotenv-expand",
    "version": "5.1.0",
    "license": "BSD-2-Clause",
    "homepage": null,
    "licenseFile": "/licenses/dotenv-expand-5.1.0.txt"
  },
  {
    "name": "dunder-proto",
    "version": "1.0.1",
    "license": "MIT",
    "homepage": "https://github.com/es-shims/dunder-proto#readme",
    "licenseFile": "/licenses/dunder-proto-1.0.1.txt"
  },
  {
    "name": "duplexer",
    "version": "0.1.2",
    "license": "MIT",
    "homepage": "https://github.com/Raynos/duplexer",
    "licenseFile": "/licenses/duplexer-0.1.2.txt"
  },
  {
    "name": "eastasianwidth",
    "version": "0.2.0",
    "license": "MIT",
    "homepage": "git://github.com/komagata/eastasianwidth.git",
    "licenseFile": null
  },
  {
    "name": "ee-first",
    "version": "1.1.1",
    "license": "MIT",
    "homepage": "jonathanong/ee-first",
    "licenseFile": "/licenses/ee-first-1.1.1.txt"
  },
  {
    "name": "ejs",
    "version": "3.1.10",
    "license": "Apache-2.0",
    "homepage": "https://github.com/mde/ejs",
    "licenseFile": "/licenses/ejs-3.1.10.txt"
  },
  {
    "name": "electron-to-chromium",
    "version": "1.5.211",
    "license": "ISC",
    "homepage": "https://github.com/kilian/electron-to-chromium/",
    "licenseFile": "/licenses/electron-to-chromium-1.5.211.txt"
  },
  {
    "name": "emittery",
    "version": "0.8.1",
    "license": "MIT",
    "homepage": "sindresorhus/emittery",
    "licenseFile": "/licenses/emittery-0.8.1.txt"
  },
  {
    "name": "emittery",
    "version": "0.10.2",
    "license": "MIT",
    "homepage": "sindresorhus/emittery",
    "licenseFile": "/licenses/emittery-0.10.2.txt"
  },
  {
    "name": "emoji-regex",
    "version": "9.2.2",
    "license": "MIT",
    "homepage": "https://mths.be/emoji-regex",
    "licenseFile": null
  },
  {
    "name": "emoji-regex",
    "version": "8.0.0",
    "license": "MIT",
    "homepage": "https://mths.be/emoji-regex",
    "licenseFile": null
  },
  {
    "name": "emojis-list",
    "version": "3.0.0",
    "license": "MIT",
    "homepage": "https://nidecoc.io/Kikobeats/emojis-list",
    "licenseFile": "/licenses/emojis-list-3.0.0.txt"
  },
  {
    "name": "encodeurl",
    "version": "2.0.0",
    "license": "MIT",
    "homepage": "pillarjs/encodeurl",
    "licenseFile": "/licenses/encodeurl-2.0.0.txt"
  },
  {
    "name": "encodeurl",
    "version": "1.0.2",
    "license": "MIT",
    "homepage": "pillarjs/encodeurl",
    "licenseFile": "/licenses/encodeurl-1.0.2.txt"
  },
  {
    "name": "enhanced-resolve",
    "version": "5.18.3",
    "license": "MIT",
    "homepage": "http://github.com/webpack/enhanced-resolve",
    "licenseFile": "/licenses/enhanced-resolve-5.18.3.txt"
  },
  {
    "name": "entities",
    "version": "2.2.0",
    "license": "BSD-2-Clause",
    "homepage": "git://github.com/fb55/entities.git",
    "licenseFile": "/licenses/entities-2.2.0.txt"
  },
  {
    "name": "error-ex",
    "version": "1.3.2",
    "license": "MIT",
    "homepage": "qix-/node-error-ex",
    "licenseFile": "/licenses/error-ex-1.3.2.txt"
  },
  {
    "name": "error-stack-parser",
    "version": "2.1.4",
    "license": "MIT",
    "homepage": "https://www.stacktracejs.com",
    "licenseFile": "/licenses/error-stack-parser-2.1.4.txt"
  },
  {
    "name": "es-abstract",
    "version": "1.24.0",
    "license": "MIT",
    "homepage": "git://github.com/ljharb/es-abstract.git",
    "licenseFile": "/licenses/es-abstract-1.24.0.txt"
  },
  {
    "name": "es-array-method-boxes-properly",
    "version": "1.0.0",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/es-array-method-boxes-properly#readme",
    "licenseFile": "/licenses/es-array-method-boxes-properly-1.0.0.txt"
  },
  {
    "name": "es-define-property",
    "version": "1.0.1",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/es-define-property#readme",
    "licenseFile": "/licenses/es-define-property-1.0.1.txt"
  },
  {
    "name": "es-errors",
    "version": "1.3.0",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/es-errors#readme",
    "licenseFile": "/licenses/es-errors-1.3.0.txt"
  },
  {
    "name": "es-iterator-helpers",
    "version": "1.2.1",
    "license": "MIT",
    "homepage": "https://github.com/es-shims/iterator-helpers#readme",
    "licenseFile": "/licenses/es-iterator-helpers-1.2.1.txt"
  },
  {
    "name": "es-module-lexer",
    "version": "1.7.0",
    "license": "MIT",
    "homepage": "https://github.com/guybedford/es-module-lexer#readme",
    "licenseFile": "/licenses/es-module-lexer-1.7.0.txt"
  },
  {
    "name": "es-object-atoms",
    "version": "1.1.1",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/es-object-atoms#readme",
    "licenseFile": "/licenses/es-object-atoms-1.1.1.txt"
  },
  {
    "name": "es-set-tostringtag",
    "version": "2.1.0",
    "license": "MIT",
    "homepage": "https://github.com/es-shims/es-set-tostringtag#readme",
    "licenseFile": "/licenses/es-set-tostringtag-2.1.0.txt"
  },
  {
    "name": "es-shim-unscopables",
    "version": "1.1.0",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/es-shim-unscopables#readme",
    "licenseFile": "/licenses/es-shim-unscopables-1.1.0.txt"
  },
  {
    "name": "es-to-primitive",
    "version": "1.3.0",
    "license": "MIT",
    "homepage": "git://github.com/ljharb/es-to-primitive.git",
    "licenseFile": "/licenses/es-to-primitive-1.3.0.txt"
  },
  {
    "name": "escalade",
    "version": "3.2.0",
    "license": "MIT",
    "homepage": "lukeed/escalade",
    "licenseFile": "/licenses/escalade-3.2.0.txt"
  },
  {
    "name": "escape-html",
    "version": "1.0.3",
    "license": "MIT",
    "homepage": "component/escape-html",
    "licenseFile": "/licenses/escape-html-1.0.3.txt"
  },
  {
    "name": "escape-string-regexp",
    "version": "1.0.5",
    "license": "MIT",
    "homepage": "sindresorhus/escape-string-regexp",
    "licenseFile": "/licenses/escape-string-regexp-1.0.5.txt"
  },
  {
    "name": "escape-string-regexp",
    "version": "4.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/escape-string-regexp",
    "licenseFile": "/licenses/escape-string-regexp-4.0.0.txt"
  },
  {
    "name": "escape-string-regexp",
    "version": "2.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/escape-string-regexp",
    "licenseFile": "/licenses/escape-string-regexp-2.0.0.txt"
  },
  {
    "name": "escodegen",
    "version": "2.1.0",
    "license": "BSD-2-Clause",
    "homepage": "http://github.com/estools/escodegen",
    "licenseFile": null
  },
  {
    "name": "escodegen",
    "version": "1.14.3",
    "license": "BSD-2-Clause",
    "homepage": "http://github.com/estools/escodegen",
    "licenseFile": null
  },
  {
    "name": "eslint",
    "version": "8.57.1",
    "license": "MIT",
    "homepage": "https://eslint.org",
    "licenseFile": "/licenses/eslint-8.57.1.txt"
  },
  {
    "name": "eslint-config-react-app",
    "version": "7.0.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/create-react-app.git",
    "licenseFile": "/licenses/eslint-config-react-app-7.0.1.txt"
  },
  {
    "name": "eslint-import-resolver-node",
    "version": "0.3.9",
    "license": "MIT",
    "homepage": "https://github.com/import-js/eslint-plugin-import",
    "licenseFile": "/licenses/eslint-import-resolver-node-0.3.9.txt"
  },
  {
    "name": "eslint-module-utils",
    "version": "2.12.1",
    "license": "MIT",
    "homepage": "https://github.com/import-js/eslint-plugin-import#readme",
    "licenseFile": "/licenses/eslint-module-utils-2.12.1.txt"
  },
  {
    "name": "eslint-plugin-flowtype",
    "version": "8.0.3",
    "license": "BSD-3-Clause",
    "homepage": "https://github.com/gajus/eslint-plugin-flowtype",
    "licenseFile": "/licenses/eslint-plugin-flowtype-8.0.3.txt"
  },
  {
    "name": "eslint-plugin-import",
    "version": "2.32.0",
    "license": "MIT",
    "homepage": "https://github.com/import-js/eslint-plugin-import",
    "licenseFile": "/licenses/eslint-plugin-import-2.32.0.txt"
  },
  {
    "name": "eslint-plugin-jest",
    "version": "25.7.0",
    "license": "MIT",
    "homepage": "jest-community/eslint-plugin-jest",
    "licenseFile": "/licenses/eslint-plugin-jest-25.7.0.txt"
  },
  {
    "name": "eslint-plugin-jsx-a11y",
    "version": "6.10.2",
    "license": "MIT",
    "homepage": "https://github.com/jsx-eslint/eslint-plugin-jsx-a11y",
    "licenseFile": "/licenses/eslint-plugin-jsx-a11y-6.10.2.txt"
  },
  {
    "name": "eslint-plugin-react",
    "version": "7.37.5",
    "license": "MIT",
    "homepage": "https://github.com/jsx-eslint/eslint-plugin-react",
    "licenseFile": "/licenses/eslint-plugin-react-7.37.5.txt"
  },
  {
    "name": "eslint-plugin-react-hooks",
    "version": "4.6.2",
    "license": "MIT",
    "homepage": "https://reactjs.org/",
    "licenseFile": "/licenses/eslint-plugin-react-hooks-4.6.2.txt"
  },
  {
    "name": "eslint-plugin-testing-library",
    "version": "5.11.1",
    "license": "MIT",
    "homepage": "https://github.com/testing-library/eslint-plugin-testing-library",
    "licenseFile": "/licenses/eslint-plugin-testing-library-5.11.1.txt"
  },
  {
    "name": "eslint-scope",
    "version": "5.1.1",
    "license": "BSD-2-Clause",
    "homepage": "http://github.com/eslint/eslint-scope",
    "licenseFile": "/licenses/eslint-scope-5.1.1.txt"
  },
  {
    "name": "eslint-scope",
    "version": "7.2.2",
    "license": "BSD-2-Clause",
    "homepage": "http://github.com/eslint/eslint-scope",
    "licenseFile": "/licenses/eslint-scope-7.2.2.txt"
  },
  {
    "name": "eslint-visitor-keys",
    "version": "2.1.0",
    "license": "Apache-2.0",
    "homepage": "https://github.com/eslint/eslint-visitor-keys#readme",
    "licenseFile": "/licenses/eslint-visitor-keys-2.1.0.txt"
  },
  {
    "name": "eslint-visitor-keys",
    "version": "3.4.3",
    "license": "Apache-2.0",
    "homepage": "https://github.com/eslint/eslint-visitor-keys#readme",
    "licenseFile": "/licenses/eslint-visitor-keys-3.4.3.txt"
  },
  {
    "name": "eslint-webpack-plugin",
    "version": "3.2.0",
    "license": "MIT",
    "homepage": "https://github.com/webpack-contrib/eslint-webpack-plugin",
    "licenseFile": "/licenses/eslint-webpack-plugin-3.2.0.txt"
  },
  {
    "name": "espree",
    "version": "9.6.1",
    "license": "BSD-2-Clause",
    "homepage": "https://github.com/eslint/espree",
    "licenseFile": "/licenses/espree-9.6.1.txt"
  },
  {
    "name": "esprima",
    "version": "4.0.1",
    "license": "BSD-2-Clause",
    "homepage": "http://esprima.org",
    "licenseFile": null
  },
  {
    "name": "esprima",
    "version": "1.2.2",
    "license": "BSD",
    "homepage": "http://esprima.org",
    "licenseFile": null
  },
  {
    "name": "esquery",
    "version": "1.6.0",
    "license": "BSD-3-Clause",
    "homepage": "https://github.com/estools/esquery/",
    "licenseFile": "/licenses/esquery-1.6.0.txt"
  },
  {
    "name": "esrecurse",
    "version": "4.3.0",
    "license": "BSD-2-Clause",
    "homepage": "https://github.com/estools/esrecurse",
    "licenseFile": null
  },
  {
    "name": "estraverse",
    "version": "4.3.0",
    "license": "BSD-2-Clause",
    "homepage": "https://github.com/estools/estraverse",
    "licenseFile": null
  },
  {
    "name": "estraverse",
    "version": "5.3.0",
    "license": "BSD-2-Clause",
    "homepage": "https://github.com/estools/estraverse",
    "licenseFile": null
  },
  {
    "name": "estree-walker",
    "version": "1.0.1",
    "license": "MIT",
    "homepage": "https://github.com/Rich-Harris/estree-walker",
    "licenseFile": null
  },
  {
    "name": "esutils",
    "version": "2.0.3",
    "license": "BSD-2-Clause",
    "homepage": "https://github.com/estools/esutils",
    "licenseFile": null
  },
  {
    "name": "etag",
    "version": "1.8.1",
    "license": "MIT",
    "homepage": "jshttp/etag",
    "licenseFile": "/licenses/etag-1.8.1.txt"
  },
  {
    "name": "eventemitter3",
    "version": "4.0.7",
    "license": "MIT",
    "homepage": "git://github.com/primus/eventemitter3.git",
    "licenseFile": "/licenses/eventemitter3-4.0.7.txt"
  },
  {
    "name": "events",
    "version": "3.3.0",
    "license": "MIT",
    "homepage": "git://github.com/Gozala/events.git",
    "licenseFile": "/licenses/events-3.3.0.txt"
  },
  {
    "name": "execa",
    "version": "5.1.1",
    "license": "MIT",
    "homepage": "sindresorhus/execa",
    "licenseFile": "/licenses/execa-5.1.1.txt"
  },
  {
    "name": "exit",
    "version": "0.1.2",
    "license": "MIT",
    "homepage": "https://github.com/cowboy/node-exit",
    "licenseFile": null
  },
  {
    "name": "expect",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/expect-27.5.1.txt"
  },
  {
    "name": "express",
    "version": "4.21.2",
    "license": "MIT",
    "homepage": "http://expressjs.com/",
    "licenseFile": "/licenses/express-4.21.2.txt"
  },
  {
    "name": "fast-deep-equal",
    "version": "3.1.3",
    "license": "MIT",
    "homepage": "https://github.com/epoberezkin/fast-deep-equal#readme",
    "licenseFile": "/licenses/fast-deep-equal-3.1.3.txt"
  },
  {
    "name": "fast-glob",
    "version": "3.3.3",
    "license": "MIT",
    "homepage": "mrmlnc/fast-glob",
    "licenseFile": "/licenses/fast-glob-3.3.3.txt"
  },
  {
    "name": "fast-json-stable-stringify",
    "version": "2.1.0",
    "license": "MIT",
    "homepage": "https://github.com/epoberezkin/fast-json-stable-stringify",
    "licenseFile": "/licenses/fast-json-stable-stringify-2.1.0.txt"
  },
  {
    "name": "fast-levenshtein",
    "version": "2.0.6",
    "license": "MIT",
    "homepage": "https://github.com/hiddentao/fast-levenshtein.git",
    "licenseFile": "/licenses/fast-levenshtein-2.0.6.txt"
  },
  {
    "name": "fast-uri",
    "version": "3.1.0",
    "license": "BSD-3-Clause",
    "homepage": "https://github.com/fastify/fast-uri",
    "licenseFile": "/licenses/fast-uri-3.1.0.txt"
  },
  {
    "name": "fastq",
    "version": "1.19.1",
    "license": "ISC",
    "homepage": "https://github.com/mcollina/fastq#readme",
    "licenseFile": "/licenses/fastq-1.19.1.txt"
  },
  {
    "name": "faye-websocket",
    "version": "0.11.4",
    "license": "Apache-2.0",
    "homepage": "https://github.com/faye/faye-websocket-node",
    "licenseFile": "/licenses/faye-websocket-0.11.4.txt"
  },
  {
    "name": "fb-watchman",
    "version": "2.0.2",
    "license": "Apache-2.0",
    "homepage": "https://facebook.github.io/watchman/",
    "licenseFile": null
  },
  {
    "name": "file-entry-cache",
    "version": "6.0.1",
    "license": "MIT",
    "homepage": "royriojas/file-entry-cache",
    "licenseFile": "/licenses/file-entry-cache-6.0.1.txt"
  },
  {
    "name": "file-loader",
    "version": "6.2.0",
    "license": "MIT",
    "homepage": "https://github.com/webpack-contrib/file-loader",
    "licenseFile": "/licenses/file-loader-6.2.0.txt"
  },
  {
    "name": "filelist",
    "version": "1.0.4",
    "license": "Apache-2.0",
    "homepage": "https://github.com/mde/filelist",
    "licenseFile": null
  },
  {
    "name": "filesize",
    "version": "8.0.7",
    "license": "BSD-3-Clause",
    "homepage": "https://filesizejs.com",
    "licenseFile": "/licenses/filesize-8.0.7.txt"
  },
  {
    "name": "fill-range",
    "version": "7.1.1",
    "license": "MIT",
    "homepage": "https://github.com/jonschlinkert/fill-range",
    "licenseFile": "/licenses/fill-range-7.1.1.txt"
  },
  {
    "name": "finalhandler",
    "version": "1.3.1",
    "license": "MIT",
    "homepage": "pillarjs/finalhandler",
    "licenseFile": "/licenses/finalhandler-1.3.1.txt"
  },
  {
    "name": "find-cache-dir",
    "version": "3.3.2",
    "license": "MIT",
    "homepage": "avajs/find-cache-dir",
    "licenseFile": "/licenses/find-cache-dir-3.3.2.txt"
  },
  {
    "name": "find-up",
    "version": "5.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/find-up",
    "licenseFile": "/licenses/find-up-5.0.0.txt"
  },
  {
    "name": "find-up",
    "version": "4.1.0",
    "license": "MIT",
    "homepage": "sindresorhus/find-up",
    "licenseFile": "/licenses/find-up-4.1.0.txt"
  },
  {
    "name": "find-up",
    "version": "3.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/find-up",
    "licenseFile": "/licenses/find-up-3.0.0.txt"
  },
  {
    "name": "flat-cache",
    "version": "3.2.0",
    "license": "MIT",
    "homepage": "jaredwray/flat-cache",
    "licenseFile": "/licenses/flat-cache-3.2.0.txt"
  },
  {
    "name": "flatted",
    "version": "3.3.3",
    "license": "ISC",
    "homepage": "https://github.com/WebReflection/flatted#readme",
    "licenseFile": "/licenses/flatted-3.3.3.txt"
  },
  {
    "name": "follow-redirects",
    "version": "1.15.11",
    "license": "MIT",
    "homepage": "https://github.com/follow-redirects/follow-redirects",
    "licenseFile": "/licenses/follow-redirects-1.15.11.txt"
  },
  {
    "name": "for-each",
    "version": "0.3.5",
    "license": "MIT",
    "homepage": "https://github.com/Raynos/for-each",
    "licenseFile": "/licenses/for-each-0.3.5.txt"
  },
  {
    "name": "foreground-child",
    "version": "3.3.1",
    "license": "ISC",
    "homepage": "https://github.com/tapjs/foreground-child.git",
    "licenseFile": "/licenses/foreground-child-3.3.1.txt"
  },
  {
    "name": "fork-ts-checker-webpack-plugin",
    "version": "6.5.3",
    "license": "MIT",
    "homepage": "https://github.com/TypeStrong/fork-ts-checker-webpack-plugin.git",
    "licenseFile": "/licenses/fork-ts-checker-webpack-plugin-6.5.3.txt"
  },
  {
    "name": "form-data",
    "version": "3.0.4",
    "license": "MIT",
    "homepage": "git://github.com/form-data/form-data.git",
    "licenseFile": "/licenses/form-data-3.0.4.txt"
  },
  {
    "name": "forwarded",
    "version": "0.2.0",
    "license": "MIT",
    "homepage": "jshttp/forwarded",
    "licenseFile": "/licenses/forwarded-0.2.0.txt"
  },
  {
    "name": "fraction.js",
    "version": "4.3.7",
    "license": "MIT",
    "homepage": "https://www.xarg.org/2014/03/rational-numbers-in-javascript/",
    "licenseFile": "/licenses/fraction.js-4.3.7.txt"
  },
  {
    "name": "framer-motion",
    "version": "12.23.12",
    "license": "MIT",
    "homepage": "https://github.com/motiondivision/motion/",
    "licenseFile": "/licenses/framer-motion-12.23.12.txt"
  },
  {
    "name": "fresh",
    "version": "0.5.2",
    "license": "MIT",
    "homepage": "jshttp/fresh",
    "licenseFile": "/licenses/fresh-0.5.2.txt"
  },
  {
    "name": "fs-extra",
    "version": "9.1.0",
    "license": "MIT",
    "homepage": "https://github.com/jprichardson/node-fs-extra",
    "licenseFile": "/licenses/fs-extra-9.1.0.txt"
  },
  {
    "name": "fs-extra",
    "version": "10.1.0",
    "license": "MIT",
    "homepage": "https://github.com/jprichardson/node-fs-extra",
    "licenseFile": "/licenses/fs-extra-10.1.0.txt"
  },
  {
    "name": "fs-monkey",
    "version": "1.1.0",
    "license": "Unlicense",
    "homepage": "https://github.com/streamich/fs-monkey.git",
    "licenseFile": "/licenses/fs-monkey-1.1.0.txt"
  },
  {
    "name": "fs.realpath",
    "version": "1.0.0",
    "license": "ISC",
    "homepage": "https://github.com/isaacs/fs.realpath.git",
    "licenseFile": "/licenses/fs.realpath-1.0.0.txt"
  },
  {
    "name": "function-bind",
    "version": "1.1.2",
    "license": "MIT",
    "homepage": "https://github.com/Raynos/function-bind",
    "licenseFile": "/licenses/function-bind-1.1.2.txt"
  },
  {
    "name": "function.prototype.name",
    "version": "1.1.8",
    "license": "MIT",
    "homepage": "git://github.com/es-shims/Function.prototype.name.git",
    "licenseFile": "/licenses/function.prototype.name-1.1.8.txt"
  },
  {
    "name": "functions-have-names",
    "version": "1.2.3",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/functions-have-names#readme",
    "licenseFile": "/licenses/functions-have-names-1.2.3.txt"
  },
  {
    "name": "gensync",
    "version": "1.0.0-beta.2",
    "license": "MIT",
    "homepage": "https://github.com/loganfsmyth/gensync",
    "licenseFile": "/licenses/gensync-1.0.0-beta.2.txt"
  },
  {
    "name": "get-caller-file",
    "version": "2.0.5",
    "license": "ISC",
    "homepage": "https://github.com/stefanpenner/get-caller-file#readme",
    "licenseFile": "/licenses/get-caller-file-2.0.5.txt"
  },
  {
    "name": "get-intrinsic",
    "version": "1.3.0",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/get-intrinsic#readme",
    "licenseFile": "/licenses/get-intrinsic-1.3.0.txt"
  },
  {
    "name": "get-own-enumerable-property-symbols",
    "version": "3.0.2",
    "license": "ISC",
    "homepage": "https://github.com/mightyiam/get-own-enumerable-property-symbols#readme",
    "licenseFile": "/licenses/get-own-enumerable-property-symbols-3.0.2.txt"
  },
  {
    "name": "get-package-type",
    "version": "0.1.0",
    "license": "MIT",
    "homepage": "https://github.com/cfware/get-package-type#readme",
    "licenseFile": "/licenses/get-package-type-0.1.0.txt"
  },
  {
    "name": "get-proto",
    "version": "1.0.1",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/get-proto#readme",
    "licenseFile": "/licenses/get-proto-1.0.1.txt"
  },
  {
    "name": "get-stream",
    "version": "6.0.1",
    "license": "MIT",
    "homepage": "sindresorhus/get-stream",
    "licenseFile": "/licenses/get-stream-6.0.1.txt"
  },
  {
    "name": "get-symbol-description",
    "version": "1.1.0",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/get-symbol-description#readme",
    "licenseFile": "/licenses/get-symbol-description-1.1.0.txt"
  },
  {
    "name": "glob",
    "version": "7.2.3",
    "license": "ISC",
    "homepage": "git://github.com/isaacs/node-glob.git",
    "licenseFile": "/licenses/glob-7.2.3.txt"
  },
  {
    "name": "glob",
    "version": "10.4.5",
    "license": "ISC",
    "homepage": "git://github.com/isaacs/node-glob.git",
    "licenseFile": "/licenses/glob-10.4.5.txt"
  },
  {
    "name": "glob-parent",
    "version": "5.1.2",
    "license": "ISC",
    "homepage": "gulpjs/glob-parent",
    "licenseFile": "/licenses/glob-parent-5.1.2.txt"
  },
  {
    "name": "glob-parent",
    "version": "6.0.2",
    "license": "ISC",
    "homepage": "gulpjs/glob-parent",
    "licenseFile": "/licenses/glob-parent-6.0.2.txt"
  },
  {
    "name": "glob-to-regexp",
    "version": "0.4.1",
    "license": "BSD-2-Clause",
    "homepage": "https://github.com/fitzgen/glob-to-regexp.git",
    "licenseFile": null
  },
  {
    "name": "global-modules",
    "version": "2.0.0",
    "license": "MIT",
    "homepage": "https://github.com/jonschlinkert/global-modules",
    "licenseFile": "/licenses/global-modules-2.0.0.txt"
  },
  {
    "name": "global-prefix",
    "version": "3.0.0",
    "license": "MIT",
    "homepage": "https://github.com/jonschlinkert/global-prefix",
    "licenseFile": "/licenses/global-prefix-3.0.0.txt"
  },
  {
    "name": "globals",
    "version": "13.24.0",
    "license": "MIT",
    "homepage": "sindresorhus/globals",
    "licenseFile": "/licenses/globals-13.24.0.txt"
  },
  {
    "name": "globalthis",
    "version": "1.0.4",
    "license": "MIT",
    "homepage": "git://github.com/ljharb/System.global.git",
    "licenseFile": "/licenses/globalthis-1.0.4.txt"
  },
  {
    "name": "globby",
    "version": "11.1.0",
    "license": "MIT",
    "homepage": "sindresorhus/globby",
    "licenseFile": "/licenses/globby-11.1.0.txt"
  },
  {
    "name": "gopd",
    "version": "1.2.0",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/gopd#readme",
    "licenseFile": "/licenses/gopd-1.2.0.txt"
  },
  {
    "name": "graceful-fs",
    "version": "4.2.11",
    "license": "ISC",
    "homepage": "https://github.com/isaacs/node-graceful-fs",
    "licenseFile": "/licenses/graceful-fs-4.2.11.txt"
  },
  {
    "name": "graphemer",
    "version": "1.4.0",
    "license": "MIT",
    "homepage": "https://github.com/flmnt/graphemer",
    "licenseFile": "/licenses/graphemer-1.4.0.txt"
  },
  {
    "name": "gzip-size",
    "version": "6.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/gzip-size",
    "licenseFile": "/licenses/gzip-size-6.0.0.txt"
  },
  {
    "name": "handle-thing",
    "version": "2.0.1",
    "license": "MIT",
    "homepage": "https://github.com/spdy-http2/handle-thing#readme",
    "licenseFile": null
  },
  {
    "name": "harmony-reflect",
    "version": "1.6.2",
    "license": "(Apache-2.0 OR MPL-1.1)",
    "homepage": "https://github.com/tvcutsem/harmony-reflect",
    "licenseFile": null
  },
  {
    "name": "has-bigints",
    "version": "1.1.0",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/has-bigints#readme",
    "licenseFile": "/licenses/has-bigints-1.1.0.txt"
  },
  {
    "name": "has-flag",
    "version": "3.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/has-flag",
    "licenseFile": "/licenses/has-flag-3.0.0.txt"
  },
  {
    "name": "has-flag",
    "version": "4.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/has-flag",
    "licenseFile": "/licenses/has-flag-4.0.0.txt"
  },
  {
    "name": "has-property-descriptors",
    "version": "1.0.2",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/has-property-descriptors#readme",
    "licenseFile": "/licenses/has-property-descriptors-1.0.2.txt"
  },
  {
    "name": "has-proto",
    "version": "1.2.0",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/has-proto#readme",
    "licenseFile": "/licenses/has-proto-1.2.0.txt"
  },
  {
    "name": "has-symbols",
    "version": "1.1.0",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/has-symbols#readme",
    "licenseFile": "/licenses/has-symbols-1.1.0.txt"
  },
  {
    "name": "has-tostringtag",
    "version": "1.0.2",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/has-tostringtag#readme",
    "licenseFile": "/licenses/has-tostringtag-1.0.2.txt"
  },
  {
    "name": "hasown",
    "version": "2.0.2",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/hasOwn#readme",
    "licenseFile": "/licenses/hasown-2.0.2.txt"
  },
  {
    "name": "he",
    "version": "1.2.0",
    "license": "MIT",
    "homepage": "https://mths.be/he",
    "licenseFile": null
  },
  {
    "name": "hoopy",
    "version": "0.1.4",
    "license": "MIT",
    "homepage": "https://gitlab.com/philbooth/hoopy#readme",
    "licenseFile": "/licenses/hoopy-0.1.4.txt"
  },
  {
    "name": "hpack.js",
    "version": "2.1.6",
    "license": "MIT",
    "homepage": "https://github.com/indutny/hpack.js#readme",
    "licenseFile": null
  },
  {
    "name": "html-encoding-sniffer",
    "version": "2.0.1",
    "license": "MIT",
    "homepage": "jsdom/html-encoding-sniffer",
    "licenseFile": "/licenses/html-encoding-sniffer-2.0.1.txt"
  },
  {
    "name": "html-entities",
    "version": "2.6.0",
    "license": "MIT",
    "homepage": "https://github.com/mdevils/html-entities.git",
    "licenseFile": "/licenses/html-entities-2.6.0.txt"
  },
  {
    "name": "html-escaper",
    "version": "2.0.2",
    "license": "MIT",
    "homepage": "https://github.com/WebReflection/html-escaper",
    "licenseFile": "/licenses/html-escaper-2.0.2.txt"
  },
  {
    "name": "html-minifier-terser",
    "version": "6.1.0",
    "license": "MIT",
    "homepage": "https://terser.org/html-minifier-terser/",
    "licenseFile": "/licenses/html-minifier-terser-6.1.0.txt"
  },
  {
    "name": "html-webpack-plugin",
    "version": "5.6.4",
    "license": "MIT",
    "homepage": "https://github.com/jantimon/html-webpack-plugin",
    "licenseFile": "/licenses/html-webpack-plugin-5.6.4.txt"
  },
  {
    "name": "htmlparser2",
    "version": "6.1.0",
    "license": "MIT",
    "homepage": "git://github.com/fb55/htmlparser2.git",
    "licenseFile": "/licenses/htmlparser2-6.1.0.txt"
  },
  {
    "name": "http-deceiver",
    "version": "1.2.7",
    "license": "MIT",
    "homepage": "https://github.com/indutny/http-deceiver#readme",
    "licenseFile": null
  },
  {
    "name": "http-errors",
    "version": "2.0.0",
    "license": "MIT",
    "homepage": "jshttp/http-errors",
    "licenseFile": "/licenses/http-errors-2.0.0.txt"
  },
  {
    "name": "http-errors",
    "version": "1.6.3",
    "license": "MIT",
    "homepage": "jshttp/http-errors",
    "licenseFile": "/licenses/http-errors-1.6.3.txt"
  },
  {
    "name": "http-parser-js",
    "version": "0.5.10",
    "license": "MIT",
    "homepage": "git://github.com/creationix/http-parser-js.git",
    "licenseFile": "/licenses/http-parser-js-0.5.10.txt"
  },
  {
    "name": "http-proxy",
    "version": "1.18.1",
    "license": "MIT",
    "homepage": "https://github.com/http-party/node-http-proxy.git",
    "licenseFile": "/licenses/http-proxy-1.18.1.txt"
  },
  {
    "name": "http-proxy-agent",
    "version": "4.0.1",
    "license": "MIT",
    "homepage": "git://github.com/TooTallNate/node-http-proxy-agent.git",
    "licenseFile": null
  },
  {
    "name": "http-proxy-middleware",
    "version": "2.0.9",
    "license": "MIT",
    "homepage": "https://github.com/chimurai/http-proxy-middleware#readme",
    "licenseFile": "/licenses/http-proxy-middleware-2.0.9.txt"
  },
  {
    "name": "https-proxy-agent",
    "version": "5.0.1",
    "license": "MIT",
    "homepage": "git://github.com/TooTallNate/node-https-proxy-agent.git",
    "licenseFile": null
  },
  {
    "name": "human-signals",
    "version": "2.1.0",
    "license": "Apache-2.0",
    "homepage": "https://git.io/JeluP",
    "licenseFile": "/licenses/human-signals-2.1.0.txt"
  },
  {
    "name": "iconv-lite",
    "version": "0.4.24",
    "license": "MIT",
    "homepage": "https://github.com/ashtuchkin/iconv-lite",
    "licenseFile": "/licenses/iconv-lite-0.4.24.txt"
  },
  {
    "name": "iconv-lite",
    "version": "0.6.3",
    "license": "MIT",
    "homepage": "https://github.com/ashtuchkin/iconv-lite",
    "licenseFile": "/licenses/iconv-lite-0.6.3.txt"
  },
  {
    "name": "icss-utils",
    "version": "5.1.0",
    "license": "ISC",
    "homepage": "https://github.com/css-modules/icss-utils#readme",
    "licenseFile": "/licenses/icss-utils-5.1.0.txt"
  },
  {
    "name": "idb",
    "version": "7.1.1",
    "license": "ISC",
    "homepage": "git://github.com/jakearchibald/idb.git",
    "licenseFile": "/licenses/idb-7.1.1.txt"
  },
  {
    "name": "identity-obj-proxy",
    "version": "3.0.0",
    "license": "MIT",
    "homepage": "https://github.com/keyanzhang/identity-obj-proxy#readme",
    "licenseFile": "/licenses/identity-obj-proxy-3.0.0.txt"
  },
  {
    "name": "ignore",
    "version": "5.3.2",
    "license": "MIT",
    "homepage": "git@github.com:kaelzhang/node-ignore.git",
    "licenseFile": null
  },
  {
    "name": "immer",
    "version": "9.0.21",
    "license": "MIT",
    "homepage": "https://github.com/immerjs/immer#readme",
    "licenseFile": "/licenses/immer-9.0.21.txt"
  },
  {
    "name": "import-fresh",
    "version": "3.3.1",
    "license": "MIT",
    "homepage": "sindresorhus/import-fresh",
    "licenseFile": "/licenses/import-fresh-3.3.1.txt"
  },
  {
    "name": "import-local",
    "version": "3.2.0",
    "license": "MIT",
    "homepage": "sindresorhus/import-local",
    "licenseFile": "/licenses/import-local-3.2.0.txt"
  },
  {
    "name": "imurmurhash",
    "version": "0.1.4",
    "license": "MIT",
    "homepage": "https://github.com/jensyt/imurmurhash-js",
    "licenseFile": null
  },
  {
    "name": "indent-string",
    "version": "4.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/indent-string",
    "licenseFile": "/licenses/indent-string-4.0.0.txt"
  },
  {
    "name": "inflight",
    "version": "1.0.6",
    "license": "ISC",
    "homepage": "https://github.com/isaacs/inflight",
    "licenseFile": "/licenses/inflight-1.0.6.txt"
  },
  {
    "name": "inherits",
    "version": "2.0.4",
    "license": "ISC",
    "homepage": "git://github.com/isaacs/inherits",
    "licenseFile": "/licenses/inherits-2.0.4.txt"
  },
  {
    "name": "inherits",
    "version": "2.0.3",
    "license": "ISC",
    "homepage": "git://github.com/isaacs/inherits",
    "licenseFile": "/licenses/inherits-2.0.3.txt"
  },
  {
    "name": "ini",
    "version": "1.3.8",
    "license": "ISC",
    "homepage": "git://github.com/isaacs/ini.git",
    "licenseFile": "/licenses/ini-1.3.8.txt"
  },
  {
    "name": "internal-slot",
    "version": "1.1.0",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/internal-slot#readme",
    "licenseFile": "/licenses/internal-slot-1.1.0.txt"
  },
  {
    "name": "ipaddr.js",
    "version": "2.2.0",
    "license": "MIT",
    "homepage": "git://github.com/whitequark/ipaddr.js",
    "licenseFile": "/licenses/ipaddr.js-2.2.0.txt"
  },
  {
    "name": "ipaddr.js",
    "version": "1.9.1",
    "license": "MIT",
    "homepage": "git://github.com/whitequark/ipaddr.js",
    "licenseFile": "/licenses/ipaddr.js-1.9.1.txt"
  },
  {
    "name": "is-array-buffer",
    "version": "3.0.5",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/is-array-buffer#readme",
    "licenseFile": "/licenses/is-array-buffer-3.0.5.txt"
  },
  {
    "name": "is-arrayish",
    "version": "0.2.1",
    "license": "MIT",
    "homepage": "https://github.com/qix-/node-is-arrayish.git",
    "licenseFile": "/licenses/is-arrayish-0.2.1.txt"
  },
  {
    "name": "is-async-function",
    "version": "2.1.1",
    "license": "MIT",
    "homepage": "git://github.com/inspect-js/is-async-function.git",
    "licenseFile": "/licenses/is-async-function-2.1.1.txt"
  },
  {
    "name": "is-bigint",
    "version": "1.1.0",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/is-bigint#readme",
    "licenseFile": "/licenses/is-bigint-1.1.0.txt"
  },
  {
    "name": "is-binary-path",
    "version": "2.1.0",
    "license": "MIT",
    "homepage": "sindresorhus/is-binary-path",
    "licenseFile": "/licenses/is-binary-path-2.1.0.txt"
  },
  {
    "name": "is-boolean-object",
    "version": "1.2.2",
    "license": "MIT",
    "homepage": "git://github.com/inspect-js/is-boolean-object.git",
    "licenseFile": "/licenses/is-boolean-object-1.2.2.txt"
  },
  {
    "name": "is-callable",
    "version": "1.2.7",
    "license": "MIT",
    "homepage": "git://github.com/inspect-js/is-callable.git",
    "licenseFile": "/licenses/is-callable-1.2.7.txt"
  },
  {
    "name": "is-core-module",
    "version": "2.16.1",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/is-core-module",
    "licenseFile": "/licenses/is-core-module-2.16.1.txt"
  },
  {
    "name": "is-data-view",
    "version": "1.0.2",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/is-data-view#readme",
    "licenseFile": "/licenses/is-data-view-1.0.2.txt"
  },
  {
    "name": "is-date-object",
    "version": "1.1.0",
    "license": "MIT",
    "homepage": "git://github.com/inspect-js/is-date-object.git",
    "licenseFile": "/licenses/is-date-object-1.1.0.txt"
  },
  {
    "name": "is-docker",
    "version": "2.2.1",
    "license": "MIT",
    "homepage": "sindresorhus/is-docker",
    "licenseFile": "/licenses/is-docker-2.2.1.txt"
  },
  {
    "name": "is-extglob",
    "version": "2.1.1",
    "license": "MIT",
    "homepage": "https://github.com/jonschlinkert/is-extglob",
    "licenseFile": "/licenses/is-extglob-2.1.1.txt"
  },
  {
    "name": "is-finalizationregistry",
    "version": "1.1.1",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/is-finalizationregistry#readme",
    "licenseFile": "/licenses/is-finalizationregistry-1.1.1.txt"
  },
  {
    "name": "is-fullwidth-code-point",
    "version": "3.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/is-fullwidth-code-point",
    "licenseFile": "/licenses/is-fullwidth-code-point-3.0.0.txt"
  },
  {
    "name": "is-generator-fn",
    "version": "2.1.0",
    "license": "MIT",
    "homepage": "sindresorhus/is-generator-fn",
    "licenseFile": "/licenses/is-generator-fn-2.1.0.txt"
  },
  {
    "name": "is-generator-function",
    "version": "1.1.0",
    "license": "MIT",
    "homepage": "git://github.com/inspect-js/is-generator-function.git",
    "licenseFile": "/licenses/is-generator-function-1.1.0.txt"
  },
  {
    "name": "is-glob",
    "version": "4.0.3",
    "license": "MIT",
    "homepage": "https://github.com/micromatch/is-glob",
    "licenseFile": "/licenses/is-glob-4.0.3.txt"
  },
  {
    "name": "is-map",
    "version": "2.0.3",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/is-map#readme",
    "licenseFile": "/licenses/is-map-2.0.3.txt"
  },
  {
    "name": "is-module",
    "version": "1.0.0",
    "license": "MIT",
    "homepage": "component/is-module",
    "licenseFile": null
  },
  {
    "name": "is-negative-zero",
    "version": "2.0.3",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/is-negative-zero",
    "licenseFile": "/licenses/is-negative-zero-2.0.3.txt"
  },
  {
    "name": "is-number",
    "version": "7.0.0",
    "license": "MIT",
    "homepage": "https://github.com/jonschlinkert/is-number",
    "licenseFile": "/licenses/is-number-7.0.0.txt"
  },
  {
    "name": "is-number-object",
    "version": "1.1.1",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/is-number-object#readme",
    "licenseFile": "/licenses/is-number-object-1.1.1.txt"
  },
  {
    "name": "is-obj",
    "version": "1.0.1",
    "license": "MIT",
    "homepage": "sindresorhus/is-obj",
    "licenseFile": "/licenses/is-obj-1.0.1.txt"
  },
  {
    "name": "is-path-inside",
    "version": "3.0.3",
    "license": "MIT",
    "homepage": "sindresorhus/is-path-inside",
    "licenseFile": "/licenses/is-path-inside-3.0.3.txt"
  },
  {
    "name": "is-plain-obj",
    "version": "3.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/is-plain-obj",
    "licenseFile": "/licenses/is-plain-obj-3.0.0.txt"
  },
  {
    "name": "is-potential-custom-element-name",
    "version": "1.0.1",
    "license": "MIT",
    "homepage": "https://github.com/mathiasbynens/is-potential-custom-element-name",
    "licenseFile": null
  },
  {
    "name": "is-regex",
    "version": "1.2.1",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/is-regex",
    "licenseFile": "/licenses/is-regex-1.2.1.txt"
  },
  {
    "name": "is-regexp",
    "version": "1.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/is-regexp",
    "licenseFile": null
  },
  {
    "name": "is-root",
    "version": "2.1.0",
    "license": "MIT",
    "homepage": "sindresorhus/is-root",
    "licenseFile": "/licenses/is-root-2.1.0.txt"
  },
  {
    "name": "is-set",
    "version": "2.0.3",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/is-set#readme",
    "licenseFile": "/licenses/is-set-2.0.3.txt"
  },
  {
    "name": "is-shared-array-buffer",
    "version": "1.0.4",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/is-shared-array-buffer#readme",
    "licenseFile": "/licenses/is-shared-array-buffer-1.0.4.txt"
  },
  {
    "name": "is-stream",
    "version": "2.0.1",
    "license": "MIT",
    "homepage": "sindresorhus/is-stream",
    "licenseFile": "/licenses/is-stream-2.0.1.txt"
  },
  {
    "name": "is-string",
    "version": "1.1.1",
    "license": "MIT",
    "homepage": "git://github.com/inspect-js/is-string.git",
    "licenseFile": "/licenses/is-string-1.1.1.txt"
  },
  {
    "name": "is-symbol",
    "version": "1.1.1",
    "license": "MIT",
    "homepage": "git://github.com/inspect-js/is-symbol.git",
    "licenseFile": "/licenses/is-symbol-1.1.1.txt"
  },
  {
    "name": "is-typed-array",
    "version": "1.1.15",
    "license": "MIT",
    "homepage": "git://github.com/inspect-js/is-typed-array.git",
    "licenseFile": "/licenses/is-typed-array-1.1.15.txt"
  },
  {
    "name": "is-typedarray",
    "version": "1.0.0",
    "license": "MIT",
    "homepage": "https://github.com/hughsk/is-typedarray",
    "licenseFile": "/licenses/is-typedarray-1.0.0.txt"
  },
  {
    "name": "is-weakmap",
    "version": "2.0.2",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/is-weakmap#readme",
    "licenseFile": "/licenses/is-weakmap-2.0.2.txt"
  },
  {
    "name": "is-weakref",
    "version": "1.1.1",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/is-weakref#readme",
    "licenseFile": "/licenses/is-weakref-1.1.1.txt"
  },
  {
    "name": "is-weakset",
    "version": "2.0.4",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/is-weakset#readme",
    "licenseFile": "/licenses/is-weakset-2.0.4.txt"
  },
  {
    "name": "is-wsl",
    "version": "2.2.0",
    "license": "MIT",
    "homepage": "sindresorhus/is-wsl",
    "licenseFile": "/licenses/is-wsl-2.2.0.txt"
  },
  {
    "name": "isarray",
    "version": "1.0.0",
    "license": "MIT",
    "homepage": "https://github.com/juliangruber/isarray",
    "licenseFile": null
  },
  {
    "name": "isarray",
    "version": "2.0.5",
    "license": "MIT",
    "homepage": "https://github.com/juliangruber/isarray",
    "licenseFile": "/licenses/isarray-2.0.5.txt"
  },
  {
    "name": "isexe",
    "version": "2.0.0",
    "license": "ISC",
    "homepage": "https://github.com/isaacs/isexe#readme",
    "licenseFile": "/licenses/isexe-2.0.0.txt"
  },
  {
    "name": "istanbul-lib-coverage",
    "version": "3.2.2",
    "license": "BSD-3-Clause",
    "homepage": "https://istanbul.js.org/",
    "licenseFile": "/licenses/istanbul-lib-coverage-3.2.2.txt"
  },
  {
    "name": "istanbul-lib-instrument",
    "version": "5.2.1",
    "license": "BSD-3-Clause",
    "homepage": "https://istanbul.js.org/",
    "licenseFile": "/licenses/istanbul-lib-instrument-5.2.1.txt"
  },
  {
    "name": "istanbul-lib-report",
    "version": "3.0.1",
    "license": "BSD-3-Clause",
    "homepage": "https://istanbul.js.org/",
    "licenseFile": "/licenses/istanbul-lib-report-3.0.1.txt"
  },
  {
    "name": "istanbul-lib-source-maps",
    "version": "4.0.1",
    "license": "BSD-3-Clause",
    "homepage": "https://istanbul.js.org/",
    "licenseFile": "/licenses/istanbul-lib-source-maps-4.0.1.txt"
  },
  {
    "name": "istanbul-reports",
    "version": "3.2.0",
    "license": "BSD-3-Clause",
    "homepage": "https://istanbul.js.org/",
    "licenseFile": "/licenses/istanbul-reports-3.2.0.txt"
  },
  {
    "name": "iterator.prototype",
    "version": "1.1.5",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/Iterator.prototype#readme",
    "licenseFile": "/licenses/iterator.prototype-1.1.5.txt"
  },
  {
    "name": "jackspeak",
    "version": "3.4.3",
    "license": "BlueOak-1.0.0",
    "homepage": "https://github.com/isaacs/jackspeak.git",
    "licenseFile": "/licenses/jackspeak-3.4.3.txt"
  },
  {
    "name": "jake",
    "version": "10.9.4",
    "license": "Apache-2.0",
    "homepage": "git://github.com/jakejs/jake.git",
    "licenseFile": null
  },
  {
    "name": "jest",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://jestjs.io/",
    "licenseFile": "/licenses/jest-27.5.1.txt"
  },
  {
    "name": "jest-changed-files",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-changed-files-27.5.1.txt"
  },
  {
    "name": "jest-circus",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-circus-27.5.1.txt"
  },
  {
    "name": "jest-cli",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://jestjs.io/",
    "licenseFile": "/licenses/jest-cli-27.5.1.txt"
  },
  {
    "name": "jest-config",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-config-27.5.1.txt"
  },
  {
    "name": "jest-diff",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-diff-27.5.1.txt"
  },
  {
    "name": "jest-docblock",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-docblock-27.5.1.txt"
  },
  {
    "name": "jest-each",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-each-27.5.1.txt"
  },
  {
    "name": "jest-environment-jsdom",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-environment-jsdom-27.5.1.txt"
  },
  {
    "name": "jest-environment-node",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-environment-node-27.5.1.txt"
  },
  {
    "name": "jest-get-type",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-get-type-27.5.1.txt"
  },
  {
    "name": "jest-haste-map",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-haste-map-27.5.1.txt"
  },
  {
    "name": "jest-jasmine2",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-jasmine2-27.5.1.txt"
  },
  {
    "name": "jest-leak-detector",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-leak-detector-27.5.1.txt"
  },
  {
    "name": "jest-matcher-utils",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-matcher-utils-27.5.1.txt"
  },
  {
    "name": "jest-message-util",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-message-util-27.5.1.txt"
  },
  {
    "name": "jest-message-util",
    "version": "28.1.3",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-message-util-28.1.3.txt"
  },
  {
    "name": "jest-mock",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-mock-27.5.1.txt"
  },
  {
    "name": "jest-pnp-resolver",
    "version": "1.2.3",
    "license": "MIT",
    "homepage": "https://github.com/arcanis/jest-pnp-resolver",
    "licenseFile": null
  },
  {
    "name": "jest-regex-util",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-regex-util-27.5.1.txt"
  },
  {
    "name": "jest-regex-util",
    "version": "28.0.2",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-regex-util-28.0.2.txt"
  },
  {
    "name": "jest-resolve",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-resolve-27.5.1.txt"
  },
  {
    "name": "jest-resolve-dependencies",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-resolve-dependencies-27.5.1.txt"
  },
  {
    "name": "jest-runner",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-runner-27.5.1.txt"
  },
  {
    "name": "jest-runtime",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-runtime-27.5.1.txt"
  },
  {
    "name": "jest-serializer",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-serializer-27.5.1.txt"
  },
  {
    "name": "jest-snapshot",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-snapshot-27.5.1.txt"
  },
  {
    "name": "jest-util",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-util-27.5.1.txt"
  },
  {
    "name": "jest-util",
    "version": "28.1.3",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-util-28.1.3.txt"
  },
  {
    "name": "jest-validate",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-validate-27.5.1.txt"
  },
  {
    "name": "jest-watch-typeahead",
    "version": "1.1.0",
    "license": "MIT",
    "homepage": "https://github.com/jest-community/jest-watch-typeahead",
    "licenseFile": "/licenses/jest-watch-typeahead-1.1.0.txt"
  },
  {
    "name": "jest-watcher",
    "version": "28.1.3",
    "license": "MIT",
    "homepage": "https://jestjs.io/",
    "licenseFile": "/licenses/jest-watcher-28.1.3.txt"
  },
  {
    "name": "jest-watcher",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://jestjs.io/",
    "licenseFile": "/licenses/jest-watcher-27.5.1.txt"
  },
  {
    "name": "jest-worker",
    "version": "28.1.3",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-worker-28.1.3.txt"
  },
  {
    "name": "jest-worker",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-worker-27.5.1.txt"
  },
  {
    "name": "jest-worker",
    "version": "26.6.2",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/jest-worker-26.6.2.txt"
  },
  {
    "name": "jiti",
    "version": "1.21.7",
    "license": "MIT",
    "homepage": "unjs/jiti",
    "licenseFile": "/licenses/jiti-1.21.7.txt"
  },
  {
    "name": "js-tokens",
    "version": "4.0.0",
    "license": "MIT",
    "homepage": "lydell/js-tokens",
    "licenseFile": "/licenses/js-tokens-4.0.0.txt"
  },
  {
    "name": "js-yaml",
    "version": "4.1.0",
    "license": "MIT",
    "homepage": "nodeca/js-yaml",
    "licenseFile": "/licenses/js-yaml-4.1.0.txt"
  },
  {
    "name": "js-yaml",
    "version": "3.14.1",
    "license": "MIT",
    "homepage": "https://github.com/nodeca/js-yaml",
    "licenseFile": "/licenses/js-yaml-3.14.1.txt"
  },
  {
    "name": "jsdom",
    "version": "16.7.0",
    "license": "MIT",
    "homepage": "jsdom/jsdom",
    "licenseFile": "/licenses/jsdom-16.7.0.txt"
  },
  {
    "name": "jsesc",
    "version": "3.1.0",
    "license": "MIT",
    "homepage": "https://mths.be/jsesc",
    "licenseFile": null
  },
  {
    "name": "jsesc",
    "version": "3.0.2",
    "license": "MIT",
    "homepage": "https://mths.be/jsesc",
    "licenseFile": null
  },
  {
    "name": "json-buffer",
    "version": "3.0.1",
    "license": "MIT",
    "homepage": "https://github.com/dominictarr/json-buffer",
    "licenseFile": "/licenses/json-buffer-3.0.1.txt"
  },
  {
    "name": "json-parse-even-better-errors",
    "version": "2.3.1",
    "license": "MIT",
    "homepage": "https://github.com/npm/json-parse-even-better-errors",
    "licenseFile": "/licenses/json-parse-even-better-errors-2.3.1.txt"
  },
  {
    "name": "json-schema",
    "version": "0.4.0",
    "license": "(AFL-2.1 OR BSD-3-Clause)",
    "homepage": "http://github.com/kriszyp/json-schema",
    "licenseFile": "/licenses/json-schema-0.4.0.txt"
  },
  {
    "name": "json-schema-traverse",
    "version": "1.0.0",
    "license": "MIT",
    "homepage": "https://github.com/epoberezkin/json-schema-traverse#readme",
    "licenseFile": "/licenses/json-schema-traverse-1.0.0.txt"
  },
  {
    "name": "json-schema-traverse",
    "version": "0.4.1",
    "license": "MIT",
    "homepage": "https://github.com/epoberezkin/json-schema-traverse#readme",
    "licenseFile": "/licenses/json-schema-traverse-0.4.1.txt"
  },
  {
    "name": "json-stable-stringify-without-jsonify",
    "version": "1.0.1",
    "license": "MIT",
    "homepage": "https://github.com/samn/json-stable-stringify",
    "licenseFile": "/licenses/json-stable-stringify-without-jsonify-1.0.1.txt"
  },
  {
    "name": "json5",
    "version": "2.2.3",
    "license": "MIT",
    "homepage": "http://json5.org/",
    "licenseFile": "/licenses/json5-2.2.3.txt"
  },
  {
    "name": "json5",
    "version": "1.0.2",
    "license": "MIT",
    "homepage": "http://json5.org/",
    "licenseFile": "/licenses/json5-1.0.2.txt"
  },
  {
    "name": "jsonfile",
    "version": "6.2.0",
    "license": "MIT",
    "homepage": "git@github.com:jprichardson/node-jsonfile.git",
    "licenseFile": "/licenses/jsonfile-6.2.0.txt"
  },
  {
    "name": "jsonpath",
    "version": "1.1.1",
    "license": "MIT",
    "homepage": "https://github.com/dchester/jsonpath",
    "licenseFile": "/licenses/jsonpath-1.1.1.txt"
  },
  {
    "name": "jsonpointer",
    "version": "5.0.1",
    "license": "MIT",
    "homepage": "https://github.com/janl/node-jsonpointer.git",
    "licenseFile": "/licenses/jsonpointer-5.0.1.txt"
  },
  {
    "name": "jsx-ast-utils",
    "version": "3.3.5",
    "license": "MIT",
    "homepage": "https://github.com/jsx-eslint/jsx-ast-utils",
    "licenseFile": "/licenses/jsx-ast-utils-3.3.5.txt"
  },
  {
    "name": "jwt-decode",
    "version": "4.0.0",
    "license": "MIT",
    "homepage": "https://github.com/auth0/jwt-decode#readme",
    "licenseFile": "/licenses/jwt-decode-4.0.0.txt"
  },
  {
    "name": "keyv",
    "version": "4.5.4",
    "license": "MIT",
    "homepage": "https://github.com/jaredwray/keyv",
    "licenseFile": null
  },
  {
    "name": "kind-of",
    "version": "6.0.3",
    "license": "MIT",
    "homepage": "https://github.com/jonschlinkert/kind-of",
    "licenseFile": "/licenses/kind-of-6.0.3.txt"
  },
  {
    "name": "kleur",
    "version": "3.0.3",
    "license": "MIT",
    "homepage": "lukeed/kleur",
    "licenseFile": "/licenses/kleur-3.0.3.txt"
  },
  {
    "name": "klona",
    "version": "2.0.6",
    "license": "MIT",
    "homepage": "lukeed/klona",
    "licenseFile": "/licenses/klona-2.0.6.txt"
  },
  {
    "name": "language-subtag-registry",
    "version": "0.3.23",
    "license": "CC0-1.0",
    "homepage": "https://github.com/mattcg/language-subtag-registry",
    "licenseFile": null
  },
  {
    "name": "language-tags",
    "version": "1.0.9",
    "license": "MIT",
    "homepage": "https://github.com/mattcg/language-tags",
    "licenseFile": null
  },
  {
    "name": "launch-editor",
    "version": "2.11.1",
    "license": "MIT",
    "homepage": "https://github.com/yyx990803/launch-editor#readme",
    "licenseFile": "/licenses/launch-editor-2.11.1.txt"
  },
  {
    "name": "leaflet",
    "version": "1.9.4",
    "license": "BSD-2-Clause",
    "homepage": "https://leafletjs.com/",
    "licenseFile": "/licenses/leaflet-1.9.4.txt"
  },
  {
    "name": "leaflet.heat",
    "version": "0.2.0",
    "license": "UNKNOWN",
    "homepage": "https://github.com/Leaflet/Leaflet.heat",
    "licenseFile": "/licenses/leaflet.heat-0.2.0.txt"
  },
  {
    "name": "leven",
    "version": "3.1.0",
    "license": "MIT",
    "homepage": "sindresorhus/leven",
    "licenseFile": "/licenses/leven-3.1.0.txt"
  },
  {
    "name": "levn",
    "version": "0.4.1",
    "license": "MIT",
    "homepage": "https://github.com/gkz/levn",
    "licenseFile": "/licenses/levn-0.4.1.txt"
  },
  {
    "name": "levn",
    "version": "0.3.0",
    "license": "MIT",
    "homepage": "https://github.com/gkz/levn",
    "licenseFile": "/licenses/levn-0.3.0.txt"
  },
  {
    "name": "lilconfig",
    "version": "2.1.0",
    "license": "MIT",
    "homepage": "https://github.com/antonk52/lilconfig",
    "licenseFile": "/licenses/lilconfig-2.1.0.txt"
  },
  {
    "name": "lilconfig",
    "version": "3.1.3",
    "license": "MIT",
    "homepage": "https://github.com/antonk52/lilconfig",
    "licenseFile": "/licenses/lilconfig-3.1.3.txt"
  },
  {
    "name": "lines-and-columns",
    "version": "1.2.4",
    "license": "MIT",
    "homepage": "https://github.com/eventualbuddha/lines-and-columns#readme",
    "licenseFile": "/licenses/lines-and-columns-1.2.4.txt"
  },
  {
    "name": "loader-runner",
    "version": "4.3.0",
    "license": "MIT",
    "homepage": "https://github.com/webpack/loader-runner#readme",
    "licenseFile": "/licenses/loader-runner-4.3.0.txt"
  },
  {
    "name": "loader-utils",
    "version": "2.0.4",
    "license": "MIT",
    "homepage": "https://github.com/webpack/loader-utils.git",
    "licenseFile": "/licenses/loader-utils-2.0.4.txt"
  },
  {
    "name": "loader-utils",
    "version": "3.3.1",
    "license": "MIT",
    "homepage": "https://github.com/webpack/loader-utils.git",
    "licenseFile": "/licenses/loader-utils-3.3.1.txt"
  },
  {
    "name": "locate-path",
    "version": "6.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/locate-path",
    "licenseFile": "/licenses/locate-path-6.0.0.txt"
  },
  {
    "name": "locate-path",
    "version": "5.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/locate-path",
    "licenseFile": "/licenses/locate-path-5.0.0.txt"
  },
  {
    "name": "locate-path",
    "version": "3.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/locate-path",
    "licenseFile": "/licenses/locate-path-3.0.0.txt"
  },
  {
    "name": "lodash",
    "version": "4.17.21",
    "license": "MIT",
    "homepage": "https://lodash.com/",
    "licenseFile": "/licenses/lodash-4.17.21.txt"
  },
  {
    "name": "lodash.debounce",
    "version": "4.0.8",
    "license": "MIT",
    "homepage": "https://lodash.com/",
    "licenseFile": "/licenses/lodash.debounce-4.0.8.txt"
  },
  {
    "name": "lodash.memoize",
    "version": "4.1.2",
    "license": "MIT",
    "homepage": "https://lodash.com/",
    "licenseFile": "/licenses/lodash.memoize-4.1.2.txt"
  },
  {
    "name": "lodash.merge",
    "version": "4.6.2",
    "license": "MIT",
    "homepage": "https://lodash.com/",
    "licenseFile": "/licenses/lodash.merge-4.6.2.txt"
  },
  {
    "name": "lodash.sortby",
    "version": "4.7.0",
    "license": "MIT",
    "homepage": "https://lodash.com/",
    "licenseFile": "/licenses/lodash.sortby-4.7.0.txt"
  },
  {
    "name": "lodash.uniq",
    "version": "4.5.0",
    "license": "MIT",
    "homepage": "https://lodash.com/",
    "licenseFile": "/licenses/lodash.uniq-4.5.0.txt"
  },
  {
    "name": "loose-envify",
    "version": "1.4.0",
    "license": "MIT",
    "homepage": "https://github.com/zertosh/loose-envify",
    "licenseFile": "/licenses/loose-envify-1.4.0.txt"
  },
  {
    "name": "lower-case",
    "version": "2.0.2",
    "license": "MIT",
    "homepage": "https://github.com/blakeembrey/change-case/tree/master/packages/lower-case#readme",
    "licenseFile": "/licenses/lower-case-2.0.2.txt"
  },
  {
    "name": "lru-cache",
    "version": "5.1.1",
    "license": "ISC",
    "homepage": "git://github.com/isaacs/node-lru-cache.git",
    "licenseFile": "/licenses/lru-cache-5.1.1.txt"
  },
  {
    "name": "lru-cache",
    "version": "10.4.3",
    "license": "ISC",
    "homepage": "git://github.com/isaacs/node-lru-cache.git",
    "licenseFile": "/licenses/lru-cache-10.4.3.txt"
  },
  {
    "name": "lz-string",
    "version": "1.5.0",
    "license": "MIT",
    "homepage": "http://pieroxy.net/blog/pages/lz-string/index.html",
    "licenseFile": "/licenses/lz-string-1.5.0.txt"
  },
  {
    "name": "magic-string",
    "version": "0.25.9",
    "license": "MIT",
    "homepage": "https://github.com/rich-harris/magic-string",
    "licenseFile": "/licenses/magic-string-0.25.9.txt"
  },
  {
    "name": "make-dir",
    "version": "4.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/make-dir",
    "licenseFile": "/licenses/make-dir-4.0.0.txt"
  },
  {
    "name": "make-dir",
    "version": "3.1.0",
    "license": "MIT",
    "homepage": "sindresorhus/make-dir",
    "licenseFile": "/licenses/make-dir-3.1.0.txt"
  },
  {
    "name": "makeerror",
    "version": "1.0.12",
    "license": "BSD-3-Clause",
    "homepage": "https://github.com/daaku/nodejs-makeerror",
    "licenseFile": "/licenses/makeerror-1.0.12.txt"
  },
  {
    "name": "math-intrinsics",
    "version": "1.1.0",
    "license": "MIT",
    "homepage": "https://github.com/es-shims/math-intrinsics#readme",
    "licenseFile": "/licenses/math-intrinsics-1.1.0.txt"
  },
  {
    "name": "mdn-data",
    "version": "2.0.14",
    "license": "CC0-1.0",
    "homepage": "https://developer.mozilla.org",
    "licenseFile": "/licenses/mdn-data-2.0.14.txt"
  },
  {
    "name": "mdn-data",
    "version": "2.0.4",
    "license": "CC0-1.0",
    "homepage": "https://developer.mozilla.org",
    "licenseFile": "/licenses/mdn-data-2.0.4.txt"
  },
  {
    "name": "media-typer",
    "version": "0.3.0",
    "license": "MIT",
    "homepage": "jshttp/media-typer",
    "licenseFile": "/licenses/media-typer-0.3.0.txt"
  },
  {
    "name": "memfs",
    "version": "3.5.3",
    "license": "Unlicense",
    "homepage": "https://github.com/streamich/memfs.git",
    "licenseFile": "/licenses/memfs-3.5.3.txt"
  },
  {
    "name": "merge-descriptors",
    "version": "1.0.3",
    "license": "MIT",
    "homepage": "sindresorhus/merge-descriptors",
    "licenseFile": "/licenses/merge-descriptors-1.0.3.txt"
  },
  {
    "name": "merge-stream",
    "version": "2.0.0",
    "license": "MIT",
    "homepage": "grncdr/merge-stream",
    "licenseFile": "/licenses/merge-stream-2.0.0.txt"
  },
  {
    "name": "merge2",
    "version": "1.4.1",
    "license": "MIT",
    "homepage": "https://github.com/teambition/merge2",
    "licenseFile": "/licenses/merge2-1.4.1.txt"
  },
  {
    "name": "methods",
    "version": "1.1.2",
    "license": "MIT",
    "homepage": "jshttp/methods",
    "licenseFile": "/licenses/methods-1.1.2.txt"
  },
  {
    "name": "micromatch",
    "version": "4.0.8",
    "license": "MIT",
    "homepage": "https://github.com/micromatch/micromatch",
    "licenseFile": "/licenses/micromatch-4.0.8.txt"
  },
  {
    "name": "mime",
    "version": "1.6.0",
    "license": "MIT",
    "homepage": "https://github.com/broofa/node-mime",
    "licenseFile": "/licenses/mime-1.6.0.txt"
  },
  {
    "name": "mime-db",
    "version": "1.52.0",
    "license": "MIT",
    "homepage": "jshttp/mime-db",
    "licenseFile": "/licenses/mime-db-1.52.0.txt"
  },
  {
    "name": "mime-types",
    "version": "2.1.35",
    "license": "MIT",
    "homepage": "jshttp/mime-types",
    "licenseFile": "/licenses/mime-types-2.1.35.txt"
  },
  {
    "name": "mimic-fn",
    "version": "2.1.0",
    "license": "MIT",
    "homepage": "sindresorhus/mimic-fn",
    "licenseFile": "/licenses/mimic-fn-2.1.0.txt"
  },
  {
    "name": "min-indent",
    "version": "1.0.1",
    "license": "MIT",
    "homepage": "https://github.com/thejameskyle/min-indent",
    "licenseFile": "/licenses/min-indent-1.0.1.txt"
  },
  {
    "name": "mini-css-extract-plugin",
    "version": "2.9.4",
    "license": "MIT",
    "homepage": "https://github.com/webpack-contrib/mini-css-extract-plugin",
    "licenseFile": "/licenses/mini-css-extract-plugin-2.9.4.txt"
  },
  {
    "name": "minimalistic-assert",
    "version": "1.0.1",
    "license": "ISC",
    "homepage": "https://github.com/calvinmetcalf/minimalistic-assert",
    "licenseFile": "/licenses/minimalistic-assert-1.0.1.txt"
  },
  {
    "name": "minimatch",
    "version": "5.1.6",
    "license": "ISC",
    "homepage": "git://github.com/isaacs/minimatch.git",
    "licenseFile": "/licenses/minimatch-5.1.6.txt"
  },
  {
    "name": "minimatch",
    "version": "3.1.2",
    "license": "ISC",
    "homepage": "git://github.com/isaacs/minimatch.git",
    "licenseFile": "/licenses/minimatch-3.1.2.txt"
  },
  {
    "name": "minimatch",
    "version": "9.0.5",
    "license": "ISC",
    "homepage": "git://github.com/isaacs/minimatch.git",
    "licenseFile": "/licenses/minimatch-9.0.5.txt"
  },
  {
    "name": "minimist",
    "version": "1.2.8",
    "license": "MIT",
    "homepage": "https://github.com/minimistjs/minimist",
    "licenseFile": "/licenses/minimist-1.2.8.txt"
  },
  {
    "name": "minipass",
    "version": "7.1.2",
    "license": "ISC",
    "homepage": "https://github.com/isaacs/minipass",
    "licenseFile": "/licenses/minipass-7.1.2.txt"
  },
  {
    "name": "mkdirp",
    "version": "0.5.6",
    "license": "MIT",
    "homepage": "https://github.com/substack/node-mkdirp.git",
    "licenseFile": "/licenses/mkdirp-0.5.6.txt"
  },
  {
    "name": "motion-dom",
    "version": "12.23.12",
    "license": "MIT",
    "homepage": "https://github.com/motiondivision/motion",
    "licenseFile": "/licenses/motion-dom-12.23.12.txt"
  },
  {
    "name": "motion-utils",
    "version": "12.23.6",
    "license": "MIT",
    "homepage": "https://github.com/motiondivision/motion",
    "licenseFile": "/licenses/motion-utils-12.23.6.txt"
  },
  {
    "name": "ms",
    "version": "2.0.0",
    "license": "MIT",
    "homepage": "zeit/ms",
    "licenseFile": "/licenses/ms-2.0.0.txt"
  },
  {
    "name": "ms",
    "version": "2.1.3",
    "license": "MIT",
    "homepage": "vercel/ms",
    "licenseFile": "/licenses/ms-2.1.3.txt"
  },
  {
    "name": "multicast-dns",
    "version": "7.2.5",
    "license": "MIT",
    "homepage": "https://github.com/mafintosh/multicast-dns",
    "licenseFile": "/licenses/multicast-dns-7.2.5.txt"
  },
  {
    "name": "mz",
    "version": "2.7.0",
    "license": "MIT",
    "homepage": "normalize/mz",
    "licenseFile": "/licenses/mz-2.7.0.txt"
  },
  {
    "name": "nanoid",
    "version": "3.3.11",
    "license": "MIT",
    "homepage": "ai/nanoid",
    "licenseFile": "/licenses/nanoid-3.3.11.txt"
  },
  {
    "name": "natural-compare",
    "version": "1.4.0",
    "license": "MIT",
    "homepage": "git://github.com/litejs/natural-compare-lite.git",
    "licenseFile": null
  },
  {
    "name": "natural-compare-lite",
    "version": "1.4.0",
    "license": "MIT",
    "homepage": "git://github.com/litejs/natural-compare-lite.git",
    "licenseFile": null
  },
  {
    "name": "negotiator",
    "version": "0.6.3",
    "license": "MIT",
    "homepage": "jshttp/negotiator",
    "licenseFile": "/licenses/negotiator-0.6.3.txt"
  },
  {
    "name": "negotiator",
    "version": "0.6.4",
    "license": "MIT",
    "homepage": "jshttp/negotiator",
    "licenseFile": "/licenses/negotiator-0.6.4.txt"
  },
  {
    "name": "neo-async",
    "version": "2.6.2",
    "license": "MIT",
    "homepage": "https://github.com/suguru03/neo-async",
    "licenseFile": "/licenses/neo-async-2.6.2.txt"
  },
  {
    "name": "no-case",
    "version": "3.0.4",
    "license": "MIT",
    "homepage": "https://github.com/blakeembrey/change-case/tree/master/packages/no-case#readme",
    "licenseFile": "/licenses/no-case-3.0.4.txt"
  },
  {
    "name": "node-forge",
    "version": "1.3.1",
    "license": "(BSD-3-Clause OR GPL-2.0)",
    "homepage": "https://github.com/digitalbazaar/forge",
    "licenseFile": "/licenses/node-forge-1.3.1.txt"
  },
  {
    "name": "node-int64",
    "version": "0.4.0",
    "license": "MIT",
    "homepage": "https://github.com/broofa/node-int64",
    "licenseFile": "/licenses/node-int64-0.4.0.txt"
  },
  {
    "name": "node-releases",
    "version": "2.0.19",
    "license": "MIT",
    "homepage": "https://github.com/chicoxyzzy/node-releases.git",
    "licenseFile": "/licenses/node-releases-2.0.19.txt"
  },
  {
    "name": "normalize-path",
    "version": "3.0.0",
    "license": "MIT",
    "homepage": "https://github.com/jonschlinkert/normalize-path",
    "licenseFile": "/licenses/normalize-path-3.0.0.txt"
  },
  {
    "name": "normalize-range",
    "version": "0.1.2",
    "license": "MIT",
    "homepage": "jamestalmage/normalize-range",
    "licenseFile": "/licenses/normalize-range-0.1.2.txt"
  },
  {
    "name": "normalize-url",
    "version": "6.1.0",
    "license": "MIT",
    "homepage": "sindresorhus/normalize-url",
    "licenseFile": "/licenses/normalize-url-6.1.0.txt"
  },
  {
    "name": "npm-run-path",
    "version": "4.0.1",
    "license": "MIT",
    "homepage": "sindresorhus/npm-run-path",
    "licenseFile": "/licenses/npm-run-path-4.0.1.txt"
  },
  {
    "name": "nth-check",
    "version": "2.1.1",
    "license": "BSD-2-Clause",
    "homepage": "https://github.com/fb55/nth-check",
    "licenseFile": "/licenses/nth-check-2.1.1.txt"
  },
  {
    "name": "nth-check",
    "version": "1.0.2",
    "license": "BSD-2-Clause",
    "homepage": "https://github.com/fb55/nth-check",
    "licenseFile": "/licenses/nth-check-1.0.2.txt"
  },
  {
    "name": "nwsapi",
    "version": "2.2.21",
    "license": "MIT",
    "homepage": "https://javascript.nwbox.com/nwsapi/",
    "licenseFile": "/licenses/nwsapi-2.2.21.txt"
  },
  {
    "name": "object-assign",
    "version": "4.1.1",
    "license": "MIT",
    "homepage": "sindresorhus/object-assign",
    "licenseFile": "/licenses/object-assign-4.1.1.txt"
  },
  {
    "name": "object-hash",
    "version": "3.0.0",
    "license": "MIT",
    "homepage": "https://github.com/puleos/object-hash",
    "licenseFile": "/licenses/object-hash-3.0.0.txt"
  },
  {
    "name": "object-inspect",
    "version": "1.13.4",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/object-inspect",
    "licenseFile": "/licenses/object-inspect-1.13.4.txt"
  },
  {
    "name": "object-keys",
    "version": "1.1.1",
    "license": "MIT",
    "homepage": "git://github.com/ljharb/object-keys.git",
    "licenseFile": "/licenses/object-keys-1.1.1.txt"
  },
  {
    "name": "object.assign",
    "version": "4.1.7",
    "license": "MIT",
    "homepage": "git://github.com/ljharb/object.assign.git",
    "licenseFile": "/licenses/object.assign-4.1.7.txt"
  },
  {
    "name": "object.entries",
    "version": "1.1.9",
    "license": "MIT",
    "homepage": "git://github.com/es-shims/Object.entries.git",
    "licenseFile": "/licenses/object.entries-1.1.9.txt"
  },
  {
    "name": "object.fromentries",
    "version": "2.0.8",
    "license": "MIT",
    "homepage": "git://github.com/es-shims/Object.fromEntries.git",
    "licenseFile": "/licenses/object.fromentries-2.0.8.txt"
  },
  {
    "name": "object.getownpropertydescriptors",
    "version": "2.1.8",
    "license": "MIT",
    "homepage": "git://github.com/es-shims/object.getownpropertydescriptors.git",
    "licenseFile": "/licenses/object.getownpropertydescriptors-2.1.8.txt"
  },
  {
    "name": "object.groupby",
    "version": "1.0.3",
    "license": "MIT",
    "homepage": "https://github.com/es-shims/Object.groupBy#readme",
    "licenseFile": "/licenses/object.groupby-1.0.3.txt"
  },
  {
    "name": "object.values",
    "version": "1.2.1",
    "license": "MIT",
    "homepage": "git://github.com/es-shims/Object.values.git",
    "licenseFile": "/licenses/object.values-1.2.1.txt"
  },
  {
    "name": "obuf",
    "version": "1.1.2",
    "license": "MIT",
    "homepage": "https://github.com/indutny/offset-buffer",
    "licenseFile": "/licenses/obuf-1.1.2.txt"
  },
  {
    "name": "on-finished",
    "version": "2.4.1",
    "license": "MIT",
    "homepage": "jshttp/on-finished",
    "licenseFile": "/licenses/on-finished-2.4.1.txt"
  },
  {
    "name": "on-headers",
    "version": "1.1.0",
    "license": "MIT",
    "homepage": "jshttp/on-headers",
    "licenseFile": "/licenses/on-headers-1.1.0.txt"
  },
  {
    "name": "once",
    "version": "1.4.0",
    "license": "ISC",
    "homepage": "git://github.com/isaacs/once",
    "licenseFile": "/licenses/once-1.4.0.txt"
  },
  {
    "name": "onetime",
    "version": "5.1.2",
    "license": "MIT",
    "homepage": "sindresorhus/onetime",
    "licenseFile": "/licenses/onetime-5.1.2.txt"
  },
  {
    "name": "open",
    "version": "8.4.2",
    "license": "MIT",
    "homepage": "sindresorhus/open",
    "licenseFile": "/licenses/open-8.4.2.txt"
  },
  {
    "name": "optionator",
    "version": "0.9.4",
    "license": "MIT",
    "homepage": "https://github.com/gkz/optionator",
    "licenseFile": "/licenses/optionator-0.9.4.txt"
  },
  {
    "name": "optionator",
    "version": "0.8.3",
    "license": "MIT",
    "homepage": "https://github.com/gkz/optionator",
    "licenseFile": "/licenses/optionator-0.8.3.txt"
  },
  {
    "name": "own-keys",
    "version": "1.0.1",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/own-keys#readme",
    "licenseFile": "/licenses/own-keys-1.0.1.txt"
  },
  {
    "name": "p-limit",
    "version": "3.1.0",
    "license": "MIT",
    "homepage": "sindresorhus/p-limit",
    "licenseFile": "/licenses/p-limit-3.1.0.txt"
  },
  {
    "name": "p-limit",
    "version": "2.3.0",
    "license": "MIT",
    "homepage": "sindresorhus/p-limit",
    "licenseFile": "/licenses/p-limit-2.3.0.txt"
  },
  {
    "name": "p-locate",
    "version": "5.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/p-locate",
    "licenseFile": "/licenses/p-locate-5.0.0.txt"
  },
  {
    "name": "p-locate",
    "version": "4.1.0",
    "license": "MIT",
    "homepage": "sindresorhus/p-locate",
    "licenseFile": "/licenses/p-locate-4.1.0.txt"
  },
  {
    "name": "p-locate",
    "version": "3.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/p-locate",
    "licenseFile": "/licenses/p-locate-3.0.0.txt"
  },
  {
    "name": "p-retry",
    "version": "4.6.2",
    "license": "MIT",
    "homepage": "sindresorhus/p-retry",
    "licenseFile": "/licenses/p-retry-4.6.2.txt"
  },
  {
    "name": "p-try",
    "version": "2.2.0",
    "license": "MIT",
    "homepage": "sindresorhus/p-try",
    "licenseFile": "/licenses/p-try-2.2.0.txt"
  },
  {
    "name": "package-json-from-dist",
    "version": "1.0.1",
    "license": "BlueOak-1.0.0",
    "homepage": "https://github.com/isaacs/package-json-from-dist.git",
    "licenseFile": "/licenses/package-json-from-dist-1.0.1.txt"
  },
  {
    "name": "param-case",
    "version": "3.0.4",
    "license": "MIT",
    "homepage": "https://github.com/blakeembrey/change-case/tree/master/packages/param-case#readme",
    "licenseFile": "/licenses/param-case-3.0.4.txt"
  },
  {
    "name": "parent-module",
    "version": "1.0.1",
    "license": "MIT",
    "homepage": "sindresorhus/parent-module",
    "licenseFile": "/licenses/parent-module-1.0.1.txt"
  },
  {
    "name": "parse-json",
    "version": "5.2.0",
    "license": "MIT",
    "homepage": "sindresorhus/parse-json",
    "licenseFile": "/licenses/parse-json-5.2.0.txt"
  },
  {
    "name": "parse5",
    "version": "6.0.1",
    "license": "MIT",
    "homepage": "https://github.com/inikulin/parse5",
    "licenseFile": "/licenses/parse5-6.0.1.txt"
  },
  {
    "name": "parseurl",
    "version": "1.3.3",
    "license": "MIT",
    "homepage": "pillarjs/parseurl",
    "licenseFile": "/licenses/parseurl-1.3.3.txt"
  },
  {
    "name": "pascal-case",
    "version": "3.1.2",
    "license": "MIT",
    "homepage": "https://github.com/blakeembrey/change-case/tree/master/packages/pascal-case#readme",
    "licenseFile": "/licenses/pascal-case-3.1.2.txt"
  },
  {
    "name": "path-exists",
    "version": "4.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/path-exists",
    "licenseFile": "/licenses/path-exists-4.0.0.txt"
  },
  {
    "name": "path-exists",
    "version": "3.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/path-exists",
    "licenseFile": "/licenses/path-exists-3.0.0.txt"
  },
  {
    "name": "path-is-absolute",
    "version": "1.0.1",
    "license": "MIT",
    "homepage": "sindresorhus/path-is-absolute",
    "licenseFile": "/licenses/path-is-absolute-1.0.1.txt"
  },
  {
    "name": "path-key",
    "version": "3.1.1",
    "license": "MIT",
    "homepage": "sindresorhus/path-key",
    "licenseFile": "/licenses/path-key-3.1.1.txt"
  },
  {
    "name": "path-parse",
    "version": "1.0.7",
    "license": "MIT",
    "homepage": "https://github.com/jbgutierrez/path-parse#readme",
    "licenseFile": "/licenses/path-parse-1.0.7.txt"
  },
  {
    "name": "path-scurry",
    "version": "1.11.1",
    "license": "BlueOak-1.0.0",
    "homepage": "https://github.com/isaacs/path-scurry",
    "licenseFile": "/licenses/path-scurry-1.11.1.txt"
  },
  {
    "name": "path-to-regexp",
    "version": "0.1.12",
    "license": "MIT",
    "homepage": "https://github.com/pillarjs/path-to-regexp.git",
    "licenseFile": "/licenses/path-to-regexp-0.1.12.txt"
  },
  {
    "name": "path-type",
    "version": "4.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/path-type",
    "licenseFile": "/licenses/path-type-4.0.0.txt"
  },
  {
    "name": "performance-now",
    "version": "2.1.0",
    "license": "MIT",
    "homepage": "https://github.com/braveg1rl/performance-now",
    "licenseFile": "/licenses/performance-now-2.1.0.txt"
  },
  {
    "name": "picocolors",
    "version": "1.1.1",
    "license": "ISC",
    "homepage": "alexeyraspopov/picocolors",
    "licenseFile": "/licenses/picocolors-1.1.1.txt"
  },
  {
    "name": "picocolors",
    "version": "0.2.1",
    "license": "ISC",
    "homepage": "alexeyraspopov/picocolors",
    "licenseFile": "/licenses/picocolors-0.2.1.txt"
  },
  {
    "name": "picomatch",
    "version": "2.3.1",
    "license": "MIT",
    "homepage": "https://github.com/micromatch/picomatch",
    "licenseFile": "/licenses/picomatch-2.3.1.txt"
  },
  {
    "name": "pify",
    "version": "2.3.0",
    "license": "MIT",
    "homepage": "sindresorhus/pify",
    "licenseFile": "/licenses/pify-2.3.0.txt"
  },
  {
    "name": "pirates",
    "version": "4.0.7",
    "license": "MIT",
    "homepage": "https://github.com/danez/pirates#readme",
    "licenseFile": "/licenses/pirates-4.0.7.txt"
  },
  {
    "name": "pkg-dir",
    "version": "4.2.0",
    "license": "MIT",
    "homepage": "sindresorhus/pkg-dir",
    "licenseFile": "/licenses/pkg-dir-4.2.0.txt"
  },
  {
    "name": "pkg-up",
    "version": "3.1.0",
    "license": "MIT",
    "homepage": "sindresorhus/pkg-up",
    "licenseFile": "/licenses/pkg-up-3.1.0.txt"
  },
  {
    "name": "possible-typed-array-names",
    "version": "1.1.0",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/possible-typed-array-names#readme",
    "licenseFile": "/licenses/possible-typed-array-names-1.1.0.txt"
  },
  {
    "name": "postcss",
    "version": "8.5.6",
    "license": "MIT",
    "homepage": "https://postcss.org/",
    "licenseFile": "/licenses/postcss-8.5.6.txt"
  },
  {
    "name": "postcss",
    "version": "7.0.39",
    "license": "MIT",
    "homepage": "https://postcss.org/",
    "licenseFile": "/licenses/postcss-7.0.39.txt"
  },
  {
    "name": "postcss-attribute-case-insensitive",
    "version": "5.0.2",
    "license": "MIT",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-attribute-case-insensitive#readme",
    "licenseFile": "/licenses/postcss-attribute-case-insensitive-5.0.2.txt"
  },
  {
    "name": "postcss-browser-comments",
    "version": "4.0.0",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-browser-comments#readme",
    "licenseFile": "/licenses/postcss-browser-comments-4.0.0.txt"
  },
  {
    "name": "postcss-calc",
    "version": "8.2.4",
    "license": "MIT",
    "homepage": "https://github.com/postcss/postcss-calc.git",
    "licenseFile": "/licenses/postcss-calc-8.2.4.txt"
  },
  {
    "name": "postcss-clamp",
    "version": "4.1.0",
    "license": "MIT",
    "homepage": "polemius/postcss-clamp",
    "licenseFile": "/licenses/postcss-clamp-4.1.0.txt"
  },
  {
    "name": "postcss-color-functional-notation",
    "version": "4.2.4",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-color-functional-notation#readme",
    "licenseFile": "/licenses/postcss-color-functional-notation-4.2.4.txt"
  },
  {
    "name": "postcss-color-hex-alpha",
    "version": "8.0.4",
    "license": "MIT",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-color-hex-alpha#readme",
    "licenseFile": "/licenses/postcss-color-hex-alpha-8.0.4.txt"
  },
  {
    "name": "postcss-color-rebeccapurple",
    "version": "7.1.1",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-color-rebeccapurple#readme",
    "licenseFile": "/licenses/postcss-color-rebeccapurple-7.1.1.txt"
  },
  {
    "name": "postcss-colormin",
    "version": "5.3.1",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "postcss-convert-values",
    "version": "5.1.3",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "postcss-custom-media",
    "version": "8.0.2",
    "license": "MIT",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-custom-media#readme",
    "licenseFile": "/licenses/postcss-custom-media-8.0.2.txt"
  },
  {
    "name": "postcss-custom-properties",
    "version": "12.1.11",
    "license": "MIT",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-custom-properties#readme",
    "licenseFile": "/licenses/postcss-custom-properties-12.1.11.txt"
  },
  {
    "name": "postcss-custom-selectors",
    "version": "6.0.3",
    "license": "MIT",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-custom-selectors#readme",
    "licenseFile": "/licenses/postcss-custom-selectors-6.0.3.txt"
  },
  {
    "name": "postcss-dir-pseudo-class",
    "version": "6.0.5",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-dir-pseudo-class#readme",
    "licenseFile": "/licenses/postcss-dir-pseudo-class-6.0.5.txt"
  },
  {
    "name": "postcss-discard-comments",
    "version": "5.1.2",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "postcss-discard-duplicates",
    "version": "5.1.0",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "postcss-discard-empty",
    "version": "5.1.1",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "postcss-discard-overridden",
    "version": "5.1.0",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": "/licenses/postcss-discard-overridden-5.1.0.txt"
  },
  {
    "name": "postcss-double-position-gradients",
    "version": "3.1.2",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-double-position-gradients#readme",
    "licenseFile": "/licenses/postcss-double-position-gradients-3.1.2.txt"
  },
  {
    "name": "postcss-env-function",
    "version": "4.0.6",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-env-function#readme",
    "licenseFile": "/licenses/postcss-env-function-4.0.6.txt"
  },
  {
    "name": "postcss-flexbugs-fixes",
    "version": "5.0.2",
    "license": "MIT",
    "homepage": "https://github.com/luisrudge/postcss-flexbugs-fixes.git",
    "licenseFile": "/licenses/postcss-flexbugs-fixes-5.0.2.txt"
  },
  {
    "name": "postcss-focus-visible",
    "version": "6.0.4",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-focus-visible#readme",
    "licenseFile": "/licenses/postcss-focus-visible-6.0.4.txt"
  },
  {
    "name": "postcss-focus-within",
    "version": "5.0.4",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-focus-within#readme",
    "licenseFile": "/licenses/postcss-focus-within-5.0.4.txt"
  },
  {
    "name": "postcss-font-variant",
    "version": "5.0.0",
    "license": "MIT",
    "homepage": "https://github.com/postcss/postcss-font-variant.git",
    "licenseFile": "/licenses/postcss-font-variant-5.0.0.txt"
  },
  {
    "name": "postcss-gap-properties",
    "version": "3.0.5",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-gap-properties#readme",
    "licenseFile": "/licenses/postcss-gap-properties-3.0.5.txt"
  },
  {
    "name": "postcss-image-set-function",
    "version": "4.0.7",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-image-set-function#readme",
    "licenseFile": "/licenses/postcss-image-set-function-4.0.7.txt"
  },
  {
    "name": "postcss-import",
    "version": "15.1.0",
    "license": "MIT",
    "homepage": "https://github.com/postcss/postcss-import.git",
    "licenseFile": "/licenses/postcss-import-15.1.0.txt"
  },
  {
    "name": "postcss-initial",
    "version": "4.0.1",
    "license": "MIT",
    "homepage": "https://github.com/maximkoretskiy/postcss-initial.git",
    "licenseFile": "/licenses/postcss-initial-4.0.1.txt"
  },
  {
    "name": "postcss-js",
    "version": "4.0.1",
    "license": "MIT",
    "homepage": "postcss/postcss-js",
    "licenseFile": "/licenses/postcss-js-4.0.1.txt"
  },
  {
    "name": "postcss-lab-function",
    "version": "4.2.1",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-lab-function#readme",
    "licenseFile": "/licenses/postcss-lab-function-4.2.1.txt"
  },
  {
    "name": "postcss-load-config",
    "version": "4.0.2",
    "license": "MIT",
    "homepage": "postcss/postcss-load-config",
    "licenseFile": "/licenses/postcss-load-config-4.0.2.txt"
  },
  {
    "name": "postcss-loader",
    "version": "6.2.1",
    "license": "MIT",
    "homepage": "https://github.com/webpack-contrib/postcss-loader",
    "licenseFile": "/licenses/postcss-loader-6.2.1.txt"
  },
  {
    "name": "postcss-logical",
    "version": "5.0.4",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-logical#readme",
    "licenseFile": "/licenses/postcss-logical-5.0.4.txt"
  },
  {
    "name": "postcss-media-minmax",
    "version": "5.0.0",
    "license": "MIT",
    "homepage": "https://github.com/postcss/postcss-media-minmax.git",
    "licenseFile": "/licenses/postcss-media-minmax-5.0.0.txt"
  },
  {
    "name": "postcss-merge-longhand",
    "version": "5.1.7",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "postcss-merge-rules",
    "version": "5.1.4",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "postcss-minify-font-values",
    "version": "5.1.0",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": "/licenses/postcss-minify-font-values-5.1.0.txt"
  },
  {
    "name": "postcss-minify-gradients",
    "version": "5.1.1",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "postcss-minify-params",
    "version": "5.1.4",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": "/licenses/postcss-minify-params-5.1.4.txt"
  },
  {
    "name": "postcss-minify-selectors",
    "version": "5.2.1",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "postcss-modules-extract-imports",
    "version": "3.1.0",
    "license": "ISC",
    "homepage": "https://github.com/css-modules/postcss-modules-extract-imports",
    "licenseFile": "/licenses/postcss-modules-extract-imports-3.1.0.txt"
  },
  {
    "name": "postcss-modules-local-by-default",
    "version": "4.2.0",
    "license": "MIT",
    "homepage": "https://github.com/css-modules/postcss-modules-local-by-default.git",
    "licenseFile": "/licenses/postcss-modules-local-by-default-4.2.0.txt"
  },
  {
    "name": "postcss-modules-scope",
    "version": "3.2.1",
    "license": "ISC",
    "homepage": "https://github.com/css-modules/postcss-modules-scope",
    "licenseFile": "/licenses/postcss-modules-scope-3.2.1.txt"
  },
  {
    "name": "postcss-modules-values",
    "version": "4.0.0",
    "license": "ISC",
    "homepage": "https://github.com/css-modules/postcss-modules-values#readme",
    "licenseFile": "/licenses/postcss-modules-values-4.0.0.txt"
  },
  {
    "name": "postcss-nested",
    "version": "6.2.0",
    "license": "MIT",
    "homepage": "postcss/postcss-nested",
    "licenseFile": "/licenses/postcss-nested-6.2.0.txt"
  },
  {
    "name": "postcss-nesting",
    "version": "10.2.0",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-nesting#readme",
    "licenseFile": "/licenses/postcss-nesting-10.2.0.txt"
  },
  {
    "name": "postcss-normalize",
    "version": "10.0.1",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-normalize#readme",
    "licenseFile": "/licenses/postcss-normalize-10.0.1.txt"
  },
  {
    "name": "postcss-normalize-charset",
    "version": "5.1.0",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": "/licenses/postcss-normalize-charset-5.1.0.txt"
  },
  {
    "name": "postcss-normalize-display-values",
    "version": "5.1.0",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "postcss-normalize-positions",
    "version": "5.1.1",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "postcss-normalize-repeat-style",
    "version": "5.1.1",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "postcss-normalize-string",
    "version": "5.1.0",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "postcss-normalize-timing-functions",
    "version": "5.1.0",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "postcss-normalize-unicode",
    "version": "5.1.1",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "postcss-normalize-url",
    "version": "5.1.0",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "postcss-normalize-whitespace",
    "version": "5.1.1",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "postcss-opacity-percentage",
    "version": "1.1.3",
    "license": "MIT",
    "homepage": "github:mrcgrtz/postcss-opacity-percentage",
    "licenseFile": "/licenses/postcss-opacity-percentage-1.1.3.txt"
  },
  {
    "name": "postcss-ordered-values",
    "version": "5.1.3",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "postcss-overflow-shorthand",
    "version": "3.0.4",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-overflow-shorthand#readme",
    "licenseFile": "/licenses/postcss-overflow-shorthand-3.0.4.txt"
  },
  {
    "name": "postcss-page-break",
    "version": "3.0.4",
    "license": "MIT",
    "homepage": "https://github.com/shrpne/postcss-page-break",
    "licenseFile": "/licenses/postcss-page-break-3.0.4.txt"
  },
  {
    "name": "postcss-place",
    "version": "7.0.5",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-place#readme",
    "licenseFile": "/licenses/postcss-place-7.0.5.txt"
  },
  {
    "name": "postcss-preset-env",
    "version": "7.8.3",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugin-packs/postcss-preset-env#readme",
    "licenseFile": "/licenses/postcss-preset-env-7.8.3.txt"
  },
  {
    "name": "postcss-pseudo-class-any-link",
    "version": "7.1.6",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-pseudo-class-any-link#readme",
    "licenseFile": "/licenses/postcss-pseudo-class-any-link-7.1.6.txt"
  },
  {
    "name": "postcss-reduce-initial",
    "version": "5.1.2",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "postcss-reduce-transforms",
    "version": "5.1.0",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "postcss-replace-overflow-wrap",
    "version": "4.0.0",
    "license": "MIT",
    "homepage": "https://github.com/MattDiMu/postcss-replace-overflow-wrap",
    "licenseFile": "/licenses/postcss-replace-overflow-wrap-4.0.0.txt"
  },
  {
    "name": "postcss-selector-not",
    "version": "6.0.1",
    "license": "MIT",
    "homepage": "https://github.com/csstools/postcss-plugins/tree/main/plugins/postcss-selector-not#readme",
    "licenseFile": "/licenses/postcss-selector-not-6.0.1.txt"
  },
  {
    "name": "postcss-selector-parser",
    "version": "7.1.0",
    "license": "MIT",
    "homepage": "https://github.com/postcss/postcss-selector-parser",
    "licenseFile": null
  },
  {
    "name": "postcss-selector-parser",
    "version": "6.1.2",
    "license": "MIT",
    "homepage": "https://github.com/postcss/postcss-selector-parser",
    "licenseFile": null
  },
  {
    "name": "postcss-svgo",
    "version": "5.1.0",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "postcss-unique-selectors",
    "version": "5.1.1",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "postcss-value-parser",
    "version": "4.2.0",
    "license": "MIT",
    "homepage": "https://github.com/TrySound/postcss-value-parser",
    "licenseFile": "/licenses/postcss-value-parser-4.2.0.txt"
  },
  {
    "name": "prelude-ls",
    "version": "1.2.1",
    "license": "MIT",
    "homepage": "http://preludels.com",
    "licenseFile": "/licenses/prelude-ls-1.2.1.txt"
  },
  {
    "name": "prelude-ls",
    "version": "1.1.2",
    "license": "MIT",
    "homepage": "http://preludels.com",
    "licenseFile": "/licenses/prelude-ls-1.1.2.txt"
  },
  {
    "name": "pretty-bytes",
    "version": "5.6.0",
    "license": "MIT",
    "homepage": "sindresorhus/pretty-bytes",
    "licenseFile": "/licenses/pretty-bytes-5.6.0.txt"
  },
  {
    "name": "pretty-error",
    "version": "4.0.0",
    "license": "MIT",
    "homepage": "https://github.com/AriaMinaei/pretty-error.git",
    "licenseFile": "/licenses/pretty-error-4.0.0.txt"
  },
  {
    "name": "pretty-format",
    "version": "28.1.3",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/pretty-format-28.1.3.txt"
  },
  {
    "name": "pretty-format",
    "version": "27.5.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/jest.git",
    "licenseFile": "/licenses/pretty-format-27.5.1.txt"
  },
  {
    "name": "process-nextick-args",
    "version": "2.0.1",
    "license": "MIT",
    "homepage": "https://github.com/calvinmetcalf/process-nextick-args",
    "licenseFile": "/licenses/process-nextick-args-2.0.1.txt"
  },
  {
    "name": "promise",
    "version": "8.3.0",
    "license": "MIT",
    "homepage": "https://github.com/then/promise.git",
    "licenseFile": "/licenses/promise-8.3.0.txt"
  },
  {
    "name": "prompts",
    "version": "2.4.2",
    "license": "MIT",
    "homepage": "terkelg/prompts",
    "licenseFile": "/licenses/prompts-2.4.2.txt"
  },
  {
    "name": "prop-types",
    "version": "15.8.1",
    "license": "MIT",
    "homepage": "https://facebook.github.io/react/",
    "licenseFile": "/licenses/prop-types-15.8.1.txt"
  },
  {
    "name": "proxy-addr",
    "version": "2.0.7",
    "license": "MIT",
    "homepage": "jshttp/proxy-addr",
    "licenseFile": "/licenses/proxy-addr-2.0.7.txt"
  },
  {
    "name": "psl",
    "version": "1.15.0",
    "license": "MIT",
    "homepage": "git@github.com:lupomontero/psl.git",
    "licenseFile": "/licenses/psl-1.15.0.txt"
  },
  {
    "name": "punycode",
    "version": "2.3.1",
    "license": "MIT",
    "homepage": "https://mths.be/punycode",
    "licenseFile": null
  },
  {
    "name": "q",
    "version": "1.5.1",
    "license": "MIT",
    "homepage": "https://github.com/kriskowal/q",
    "licenseFile": "/licenses/q-1.5.1.txt"
  },
  {
    "name": "qs",
    "version": "6.13.0",
    "license": "BSD-3-Clause",
    "homepage": "https://github.com/ljharb/qs",
    "licenseFile": "/licenses/qs-6.13.0.txt"
  },
  {
    "name": "querystringify",
    "version": "2.2.0",
    "license": "MIT",
    "homepage": "https://github.com/unshiftio/querystringify",
    "licenseFile": "/licenses/querystringify-2.2.0.txt"
  },
  {
    "name": "queue-microtask",
    "version": "1.2.3",
    "license": "MIT",
    "homepage": "https://github.com/feross/queue-microtask",
    "licenseFile": "/licenses/queue-microtask-1.2.3.txt"
  },
  {
    "name": "raf",
    "version": "3.4.1",
    "license": "MIT",
    "homepage": "git://github.com/chrisdickinson/raf.git",
    "licenseFile": "/licenses/raf-3.4.1.txt"
  },
  {
    "name": "randombytes",
    "version": "2.1.0",
    "license": "MIT",
    "homepage": "https://github.com/crypto-browserify/randombytes",
    "licenseFile": "/licenses/randombytes-2.1.0.txt"
  },
  {
    "name": "range-parser",
    "version": "1.2.1",
    "license": "MIT",
    "homepage": "jshttp/range-parser",
    "licenseFile": "/licenses/range-parser-1.2.1.txt"
  },
  {
    "name": "raw-body",
    "version": "2.5.2",
    "license": "MIT",
    "homepage": "stream-utils/raw-body",
    "licenseFile": "/licenses/raw-body-2.5.2.txt"
  },
  {
    "name": "react",
    "version": "19.1.1",
    "license": "MIT",
    "homepage": "https://react.dev/",
    "licenseFile": "/licenses/react-19.1.1.txt"
  },
  {
    "name": "react-app-polyfill",
    "version": "3.0.0",
    "license": "MIT",
    "homepage": "https://github.com/facebook/create-react-app.git",
    "licenseFile": "/licenses/react-app-polyfill-3.0.0.txt"
  },
  {
    "name": "react-chartjs-2",
    "version": "5.3.0",
    "license": "MIT",
    "homepage": "https://github.com/reactchartjs/react-chartjs-2",
    "licenseFile": "/licenses/react-chartjs-2-5.3.0.txt"
  },
  {
    "name": "react-dev-utils",
    "version": "12.0.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/create-react-app.git",
    "licenseFile": "/licenses/react-dev-utils-12.0.1.txt"
  },
  {
    "name": "react-dom",
    "version": "19.1.1",
    "license": "MIT",
    "homepage": "https://react.dev/",
    "licenseFile": "/licenses/react-dom-19.1.1.txt"
  },
  {
    "name": "react-error-overlay",
    "version": "6.1.0",
    "license": "MIT",
    "homepage": "https://github.com/facebook/create-react-app.git",
    "licenseFile": "/licenses/react-error-overlay-6.1.0.txt"
  },
  {
    "name": "react-is",
    "version": "18.3.1",
    "license": "MIT",
    "homepage": "https://reactjs.org/",
    "licenseFile": "/licenses/react-is-18.3.1.txt"
  },
  {
    "name": "react-is",
    "version": "16.13.1",
    "license": "MIT",
    "homepage": "https://reactjs.org/",
    "licenseFile": "/licenses/react-is-16.13.1.txt"
  },
  {
    "name": "react-is",
    "version": "17.0.2",
    "license": "MIT",
    "homepage": "https://reactjs.org/",
    "licenseFile": "/licenses/react-is-17.0.2.txt"
  },
  {
    "name": "react-leaflet",
    "version": "5.0.0",
    "license": "Hippocratic-2.1",
    "homepage": "https://react-leaflet.js.org",
    "licenseFile": "/licenses/react-leaflet-5.0.0.txt"
  },
  {
    "name": "react-refresh",
    "version": "0.11.0",
    "license": "MIT",
    "homepage": "https://reactjs.org/",
    "licenseFile": "/licenses/react-refresh-0.11.0.txt"
  },
  {
    "name": "react-router",
    "version": "7.8.2",
    "license": "MIT",
    "homepage": "https://github.com/remix-run/react-router",
    "licenseFile": "/licenses/react-router-7.8.2.txt"
  },
  {
    "name": "react-router-dom",
    "version": "7.8.2",
    "license": "MIT",
    "homepage": "https://github.com/remix-run/react-router",
    "licenseFile": "/licenses/react-router-dom-7.8.2.txt"
  },
  {
    "name": "react-scripts",
    "version": "5.0.1",
    "license": "MIT",
    "homepage": "https://github.com/facebook/create-react-app.git",
    "licenseFile": "/licenses/react-scripts-5.0.1.txt"
  },
  {
    "name": "read-cache",
    "version": "1.0.0",
    "license": "MIT",
    "homepage": "https://github.com/TrySound/read-cache#readme",
    "licenseFile": "/licenses/read-cache-1.0.0.txt"
  },
  {
    "name": "readable-stream",
    "version": "2.3.8",
    "license": "MIT",
    "homepage": "git://github.com/nodejs/readable-stream",
    "licenseFile": "/licenses/readable-stream-2.3.8.txt"
  },
  {
    "name": "readable-stream",
    "version": "3.6.2",
    "license": "MIT",
    "homepage": "git://github.com/nodejs/readable-stream",
    "licenseFile": "/licenses/readable-stream-3.6.2.txt"
  },
  {
    "name": "readdirp",
    "version": "3.6.0",
    "license": "MIT",
    "homepage": "https://github.com/paulmillr/readdirp",
    "licenseFile": "/licenses/readdirp-3.6.0.txt"
  },
  {
    "name": "recursive-readdir",
    "version": "2.2.3",
    "license": "MIT",
    "homepage": "git://github.com/jergason/recursive-readdir.git",
    "licenseFile": "/licenses/recursive-readdir-2.2.3.txt"
  },
  {
    "name": "redent",
    "version": "3.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/redent",
    "licenseFile": "/licenses/redent-3.0.0.txt"
  },
  {
    "name": "reflect.getprototypeof",
    "version": "1.0.10",
    "license": "MIT",
    "homepage": "https://github.com/es-shims/Reflect.getPrototypeOf",
    "licenseFile": "/licenses/reflect.getprototypeof-1.0.10.txt"
  },
  {
    "name": "regenerate",
    "version": "1.4.2",
    "license": "MIT",
    "homepage": "https://mths.be/regenerate",
    "licenseFile": null
  },
  {
    "name": "regenerate-unicode-properties",
    "version": "10.2.0",
    "license": "MIT",
    "homepage": "https://github.com/mathiasbynens/regenerate-unicode-properties",
    "licenseFile": null
  },
  {
    "name": "regenerator-runtime",
    "version": "0.13.11",
    "license": "MIT",
    "homepage": "https://github.com/facebook/regenerator/tree/main/packages/runtime",
    "licenseFile": "/licenses/regenerator-runtime-0.13.11.txt"
  },
  {
    "name": "regex-parser",
    "version": "2.3.1",
    "license": "MIT",
    "homepage": "https://github.com/IonicaBizau/regex-parser.js",
    "licenseFile": "/licenses/regex-parser-2.3.1.txt"
  },
  {
    "name": "regexp.prototype.flags",
    "version": "1.5.4",
    "license": "MIT",
    "homepage": "git://github.com/es-shims/RegExp.prototype.flags.git",
    "licenseFile": "/licenses/regexp.prototype.flags-1.5.4.txt"
  },
  {
    "name": "regexpu-core",
    "version": "6.2.0",
    "license": "MIT",
    "homepage": "https://mths.be/regexpu",
    "licenseFile": null
  },
  {
    "name": "regjsgen",
    "version": "0.8.0",
    "license": "MIT",
    "homepage": "https://github.com/bnjmnt4n/regjsgen",
    "licenseFile": null
  },
  {
    "name": "regjsparser",
    "version": "0.12.0",
    "license": "BSD-2-Clause",
    "homepage": "https://github.com/jviereck/regjsparser",
    "licenseFile": null
  },
  {
    "name": "relateurl",
    "version": "0.2.7",
    "license": "MIT",
    "homepage": "https://github.com/stevenvachon/relateurl",
    "licenseFile": "/licenses/relateurl-0.2.7.txt"
  },
  {
    "name": "renderkid",
    "version": "3.0.0",
    "license": "MIT",
    "homepage": "https://github.com/AriaMinaei/RenderKid.git",
    "licenseFile": "/licenses/renderkid-3.0.0.txt"
  },
  {
    "name": "require-directory",
    "version": "2.1.1",
    "license": "MIT",
    "homepage": "https://github.com/troygoode/node-require-directory/",
    "licenseFile": "/licenses/require-directory-2.1.1.txt"
  },
  {
    "name": "require-from-string",
    "version": "2.0.2",
    "license": "MIT",
    "homepage": "floatdrop/require-from-string",
    "licenseFile": "/licenses/require-from-string-2.0.2.txt"
  },
  {
    "name": "requires-port",
    "version": "1.0.0",
    "license": "MIT",
    "homepage": "https://github.com/unshiftio/requires-port",
    "licenseFile": "/licenses/requires-port-1.0.0.txt"
  },
  {
    "name": "resolve",
    "version": "2.0.0-next.5",
    "license": "MIT",
    "homepage": "git://github.com/browserify/resolve.git",
    "licenseFile": "/licenses/resolve-2.0.0-next.5.txt"
  },
  {
    "name": "resolve",
    "version": "1.22.10",
    "license": "MIT",
    "homepage": "git://github.com/browserify/resolve.git",
    "licenseFile": "/licenses/resolve-1.22.10.txt"
  },
  {
    "name": "resolve-cwd",
    "version": "3.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/resolve-cwd",
    "licenseFile": "/licenses/resolve-cwd-3.0.0.txt"
  },
  {
    "name": "resolve-from",
    "version": "4.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/resolve-from",
    "licenseFile": "/licenses/resolve-from-4.0.0.txt"
  },
  {
    "name": "resolve-from",
    "version": "5.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/resolve-from",
    "licenseFile": "/licenses/resolve-from-5.0.0.txt"
  },
  {
    "name": "resolve-url-loader",
    "version": "4.0.0",
    "license": "MIT",
    "homepage": "https://github.com/bholloway/resolve-url-loader/tree/v4-maintenance/packages/resolve-url-loader",
    "licenseFile": "/licenses/resolve-url-loader-4.0.0.txt"
  },
  {
    "name": "resolve.exports",
    "version": "1.1.1",
    "license": "MIT",
    "homepage": "lukeed/resolve.exports",
    "licenseFile": "/licenses/resolve.exports-1.1.1.txt"
  },
  {
    "name": "retry",
    "version": "0.13.1",
    "license": "MIT",
    "homepage": "https://github.com/tim-kos/node-retry",
    "licenseFile": "/licenses/retry-0.13.1.txt"
  },
  {
    "name": "reusify",
    "version": "1.1.0",
    "license": "MIT",
    "homepage": "https://github.com/mcollina/reusify#readme",
    "licenseFile": "/licenses/reusify-1.1.0.txt"
  },
  {
    "name": "rimraf",
    "version": "3.0.2",
    "license": "ISC",
    "homepage": "git://github.com/isaacs/rimraf.git",
    "licenseFile": "/licenses/rimraf-3.0.2.txt"
  },
  {
    "name": "rollup",
    "version": "2.79.2",
    "license": "MIT",
    "homepage": "https://rollupjs.org/",
    "licenseFile": "/licenses/rollup-2.79.2.txt"
  },
  {
    "name": "rollup-plugin-terser",
    "version": "7.0.2",
    "license": "MIT",
    "homepage": "https://github.com/TrySound/rollup-plugin-terser.git",
    "licenseFile": "/licenses/rollup-plugin-terser-7.0.2.txt"
  },
  {
    "name": "run-parallel",
    "version": "1.2.0",
    "license": "MIT",
    "homepage": "https://github.com/feross/run-parallel",
    "licenseFile": "/licenses/run-parallel-1.2.0.txt"
  },
  {
    "name": "safe-array-concat",
    "version": "1.1.3",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/safe-array-concat#readme",
    "licenseFile": "/licenses/safe-array-concat-1.1.3.txt"
  },
  {
    "name": "safe-buffer",
    "version": "5.1.2",
    "license": "MIT",
    "homepage": "https://github.com/feross/safe-buffer",
    "licenseFile": "/licenses/safe-buffer-5.1.2.txt"
  },
  {
    "name": "safe-buffer",
    "version": "5.2.1",
    "license": "MIT",
    "homepage": "https://github.com/feross/safe-buffer",
    "licenseFile": "/licenses/safe-buffer-5.2.1.txt"
  },
  {
    "name": "safe-push-apply",
    "version": "1.0.0",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/safe-push-apply#readme",
    "licenseFile": "/licenses/safe-push-apply-1.0.0.txt"
  },
  {
    "name": "safe-regex-test",
    "version": "1.1.0",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/safe-regex-test#readme",
    "licenseFile": "/licenses/safe-regex-test-1.1.0.txt"
  },
  {
    "name": "safer-buffer",
    "version": "2.1.2",
    "license": "MIT",
    "homepage": "https://github.com/ChALkeR/safer-buffer.git",
    "licenseFile": "/licenses/safer-buffer-2.1.2.txt"
  },
  {
    "name": "sanitize.css",
    "version": "13.0.0",
    "license": "CC0-1.0",
    "homepage": "https://github.com/csstools/sanitize.css#readme",
    "licenseFile": "/licenses/sanitize.css-13.0.0.txt"
  },
  {
    "name": "sass-loader",
    "version": "12.6.0",
    "license": "MIT",
    "homepage": "https://github.com/webpack-contrib/sass-loader",
    "licenseFile": "/licenses/sass-loader-12.6.0.txt"
  },
  {
    "name": "sax",
    "version": "1.2.4",
    "license": "ISC",
    "homepage": "git://github.com/isaacs/sax-js.git",
    "licenseFile": "/licenses/sax-1.2.4.txt"
  },
  {
    "name": "saxes",
    "version": "5.0.1",
    "license": "ISC",
    "homepage": "https://github.com/lddubeau/saxes.git",
    "licenseFile": null
  },
  {
    "name": "scheduler",
    "version": "0.26.0",
    "license": "MIT",
    "homepage": "https://react.dev/",
    "licenseFile": "/licenses/scheduler-0.26.0.txt"
  },
  {
    "name": "schema-utils",
    "version": "2.7.1",
    "license": "MIT",
    "homepage": "https://github.com/webpack/schema-utils",
    "licenseFile": "/licenses/schema-utils-2.7.1.txt"
  },
  {
    "name": "schema-utils",
    "version": "3.3.0",
    "license": "MIT",
    "homepage": "https://github.com/webpack/schema-utils",
    "licenseFile": "/licenses/schema-utils-3.3.0.txt"
  },
  {
    "name": "schema-utils",
    "version": "2.7.0",
    "license": "MIT",
    "homepage": "https://github.com/webpack/schema-utils",
    "licenseFile": "/licenses/schema-utils-2.7.0.txt"
  },
  {
    "name": "schema-utils",
    "version": "4.3.2",
    "license": "MIT",
    "homepage": "https://github.com/webpack/schema-utils",
    "licenseFile": "/licenses/schema-utils-4.3.2.txt"
  },
  {
    "name": "select-hose",
    "version": "2.0.0",
    "license": "MIT",
    "homepage": "https://github.com/indutny/select-hose#readme",
    "licenseFile": null
  },
  {
    "name": "selfsigned",
    "version": "2.4.1",
    "license": "MIT",
    "homepage": "git://github.com/jfromaniello/selfsigned.git",
    "licenseFile": "/licenses/selfsigned-2.4.1.txt"
  },
  {
    "name": "semver",
    "version": "6.3.1",
    "license": "ISC",
    "homepage": "https://github.com/npm/node-semver.git",
    "licenseFile": "/licenses/semver-6.3.1.txt"
  },
  {
    "name": "semver",
    "version": "7.7.2",
    "license": "ISC",
    "homepage": "https://github.com/npm/node-semver.git",
    "licenseFile": "/licenses/semver-7.7.2.txt"
  },
  {
    "name": "send",
    "version": "0.19.0",
    "license": "MIT",
    "homepage": "pillarjs/send",
    "licenseFile": "/licenses/send-0.19.0.txt"
  },
  {
    "name": "serialize-javascript",
    "version": "4.0.0",
    "license": "BSD-3-Clause",
    "homepage": "https://github.com/yahoo/serialize-javascript",
    "licenseFile": "/licenses/serialize-javascript-4.0.0.txt"
  },
  {
    "name": "serialize-javascript",
    "version": "6.0.2",
    "license": "BSD-3-Clause",
    "homepage": "https://github.com/yahoo/serialize-javascript",
    "licenseFile": "/licenses/serialize-javascript-6.0.2.txt"
  },
  {
    "name": "serve-index",
    "version": "1.9.1",
    "license": "MIT",
    "homepage": "expressjs/serve-index",
    "licenseFile": "/licenses/serve-index-1.9.1.txt"
  },
  {
    "name": "serve-static",
    "version": "1.16.2",
    "license": "MIT",
    "homepage": "expressjs/serve-static",
    "licenseFile": "/licenses/serve-static-1.16.2.txt"
  },
  {
    "name": "set-cookie-parser",
    "version": "2.7.1",
    "license": "MIT",
    "homepage": "https://github.com/nfriedly/set-cookie-parser",
    "licenseFile": "/licenses/set-cookie-parser-2.7.1.txt"
  },
  {
    "name": "set-function-length",
    "version": "1.2.2",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/set-function-length#readme",
    "licenseFile": "/licenses/set-function-length-1.2.2.txt"
  },
  {
    "name": "set-function-name",
    "version": "2.0.2",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/set-function-name#readme",
    "licenseFile": "/licenses/set-function-name-2.0.2.txt"
  },
  {
    "name": "set-proto",
    "version": "1.0.0",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/set-proto#readme",
    "licenseFile": "/licenses/set-proto-1.0.0.txt"
  },
  {
    "name": "setprototypeof",
    "version": "1.1.0",
    "license": "ISC",
    "homepage": "https://github.com/wesleytodd/setprototypeof",
    "licenseFile": "/licenses/setprototypeof-1.1.0.txt"
  },
  {
    "name": "setprototypeof",
    "version": "1.2.0",
    "license": "ISC",
    "homepage": "https://github.com/wesleytodd/setprototypeof",
    "licenseFile": "/licenses/setprototypeof-1.2.0.txt"
  },
  {
    "name": "shebang-command",
    "version": "2.0.0",
    "license": "MIT",
    "homepage": "kevva/shebang-command",
    "licenseFile": "/licenses/shebang-command-2.0.0.txt"
  },
  {
    "name": "shebang-regex",
    "version": "3.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/shebang-regex",
    "licenseFile": "/licenses/shebang-regex-3.0.0.txt"
  },
  {
    "name": "shell-quote",
    "version": "1.8.3",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/shell-quote",
    "licenseFile": "/licenses/shell-quote-1.8.3.txt"
  },
  {
    "name": "side-channel",
    "version": "1.1.0",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/side-channel#readme",
    "licenseFile": "/licenses/side-channel-1.1.0.txt"
  },
  {
    "name": "side-channel-list",
    "version": "1.0.0",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/side-channel-list#readme",
    "licenseFile": "/licenses/side-channel-list-1.0.0.txt"
  },
  {
    "name": "side-channel-map",
    "version": "1.0.1",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/side-channel-map#readme",
    "licenseFile": "/licenses/side-channel-map-1.0.1.txt"
  },
  {
    "name": "side-channel-weakmap",
    "version": "1.0.2",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/side-channel-weakmap#readme",
    "licenseFile": "/licenses/side-channel-weakmap-1.0.2.txt"
  },
  {
    "name": "signal-exit",
    "version": "4.1.0",
    "license": "ISC",
    "homepage": "https://github.com/tapjs/signal-exit.git",
    "licenseFile": "/licenses/signal-exit-4.1.0.txt"
  },
  {
    "name": "signal-exit",
    "version": "3.0.7",
    "license": "ISC",
    "homepage": "https://github.com/tapjs/signal-exit",
    "licenseFile": "/licenses/signal-exit-3.0.7.txt"
  },
  {
    "name": "sisteransi",
    "version": "1.0.5",
    "license": "MIT",
    "homepage": "https://github.com/terkelg/sisteransi",
    "licenseFile": "/licenses/sisteransi-1.0.5.txt"
  },
  {
    "name": "slash",
    "version": "3.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/slash",
    "licenseFile": "/licenses/slash-3.0.0.txt"
  },
  {
    "name": "slash",
    "version": "4.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/slash",
    "licenseFile": "/licenses/slash-4.0.0.txt"
  },
  {
    "name": "sockjs",
    "version": "0.3.24",
    "license": "MIT",
    "homepage": "https://github.com/sockjs/sockjs-node",
    "licenseFile": "/licenses/sockjs-0.3.24.txt"
  },
  {
    "name": "source-list-map",
    "version": "2.0.1",
    "license": "MIT",
    "homepage": "https://github.com/webpack/source-list-map",
    "licenseFile": "/licenses/source-list-map-2.0.1.txt"
  },
  {
    "name": "source-map",
    "version": "0.6.1",
    "license": "BSD-3-Clause",
    "homepage": "https://github.com/mozilla/source-map",
    "licenseFile": "/licenses/source-map-0.6.1.txt"
  },
  {
    "name": "source-map",
    "version": "0.7.6",
    "license": "BSD-3-Clause",
    "homepage": "https://github.com/mozilla/source-map",
    "licenseFile": "/licenses/source-map-0.7.6.txt"
  },
  {
    "name": "source-map",
    "version": "0.8.0-beta.0",
    "license": "BSD-3-Clause",
    "homepage": "https://github.com/mozilla/source-map",
    "licenseFile": "/licenses/source-map-0.8.0-beta.0.txt"
  },
  {
    "name": "source-map-js",
    "version": "1.2.1",
    "license": "BSD-3-Clause",
    "homepage": "https://github.com/7rulnik/source-map-js",
    "licenseFile": "/licenses/source-map-js-1.2.1.txt"
  },
  {
    "name": "source-map-loader",
    "version": "3.0.2",
    "license": "MIT",
    "homepage": "https://github.com/webpack-contrib/source-map-loader",
    "licenseFile": "/licenses/source-map-loader-3.0.2.txt"
  },
  {
    "name": "source-map-support",
    "version": "0.5.21",
    "license": "MIT",
    "homepage": "https://github.com/evanw/node-source-map-support",
    "licenseFile": "/licenses/source-map-support-0.5.21.txt"
  },
  {
    "name": "sourcemap-codec",
    "version": "1.4.8",
    "license": "MIT",
    "homepage": "https://github.com/Rich-Harris/sourcemap-codec",
    "licenseFile": "/licenses/sourcemap-codec-1.4.8.txt"
  },
  {
    "name": "spdy",
    "version": "4.0.2",
    "license": "MIT",
    "homepage": "https://github.com/indutny/node-spdy",
    "licenseFile": null
  },
  {
    "name": "spdy-transport",
    "version": "3.0.0",
    "license": "MIT",
    "homepage": "https://github.com/spdy-http2/spdy-transport",
    "licenseFile": null
  },
  {
    "name": "sprintf-js",
    "version": "1.0.3",
    "license": "BSD-3-Clause",
    "homepage": "https://github.com/alexei/sprintf.js.git",
    "licenseFile": "/licenses/sprintf-js-1.0.3.txt"
  },
  {
    "name": "stable",
    "version": "0.1.8",
    "license": "MIT",
    "homepage": "https://github.com/Two-Screen/stable.git",
    "licenseFile": null
  },
  {
    "name": "stack-utils",
    "version": "2.0.6",
    "license": "MIT",
    "homepage": "tapjs/stack-utils",
    "licenseFile": "/licenses/stack-utils-2.0.6.txt"
  },
  {
    "name": "stackframe",
    "version": "1.3.4",
    "license": "MIT",
    "homepage": "https://www.stacktracejs.com",
    "licenseFile": "/licenses/stackframe-1.3.4.txt"
  },
  {
    "name": "static-eval",
    "version": "2.0.2",
    "license": "MIT",
    "homepage": "https://github.com/substack/static-eval",
    "licenseFile": "/licenses/static-eval-2.0.2.txt"
  },
  {
    "name": "statuses",
    "version": "1.5.0",
    "license": "MIT",
    "homepage": "jshttp/statuses",
    "licenseFile": "/licenses/statuses-1.5.0.txt"
  },
  {
    "name": "statuses",
    "version": "2.0.1",
    "license": "MIT",
    "homepage": "jshttp/statuses",
    "licenseFile": "/licenses/statuses-2.0.1.txt"
  },
  {
    "name": "stop-iteration-iterator",
    "version": "1.1.0",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/stop-iteration-iterator#readme",
    "licenseFile": "/licenses/stop-iteration-iterator-1.1.0.txt"
  },
  {
    "name": "string_decoder",
    "version": "1.1.1",
    "license": "MIT",
    "homepage": "https://github.com/nodejs/string_decoder",
    "licenseFile": "/licenses/string_decoder-1.1.1.txt"
  },
  {
    "name": "string_decoder",
    "version": "1.3.0",
    "license": "MIT",
    "homepage": "https://github.com/nodejs/string_decoder",
    "licenseFile": "/licenses/string_decoder-1.3.0.txt"
  },
  {
    "name": "string-length",
    "version": "4.0.2",
    "license": "MIT",
    "homepage": "sindresorhus/string-length",
    "licenseFile": "/licenses/string-length-4.0.2.txt"
  },
  {
    "name": "string-length",
    "version": "5.0.1",
    "license": "MIT",
    "homepage": "sindresorhus/string-length",
    "licenseFile": "/licenses/string-length-5.0.1.txt"
  },
  {
    "name": "string-natural-compare",
    "version": "3.0.1",
    "license": "MIT",
    "homepage": "https://github.com/nwoltman/string-natural-compare",
    "licenseFile": "/licenses/string-natural-compare-3.0.1.txt"
  },
  {
    "name": "string-width",
    "version": "5.1.2",
    "license": "MIT",
    "homepage": "sindresorhus/string-width",
    "licenseFile": "/licenses/string-width-5.1.2.txt"
  },
  {
    "name": "string-width",
    "version": "4.2.3",
    "license": "MIT",
    "homepage": "sindresorhus/string-width",
    "licenseFile": "/licenses/string-width-4.2.3.txt"
  },
  {
    "name": "string.prototype.includes",
    "version": "2.0.1",
    "license": "MIT",
    "homepage": "https://mths.be/includes",
    "licenseFile": "/licenses/string.prototype.includes-2.0.1.txt"
  },
  {
    "name": "string.prototype.matchall",
    "version": "4.0.12",
    "license": "MIT",
    "homepage": "https://github.com/es-shims/String.prototype.matchAll#readme",
    "licenseFile": "/licenses/string.prototype.matchall-4.0.12.txt"
  },
  {
    "name": "string.prototype.repeat",
    "version": "1.0.0",
    "license": "MIT",
    "homepage": "https://mths.be/repeat",
    "licenseFile": null
  },
  {
    "name": "string.prototype.trim",
    "version": "1.2.10",
    "license": "MIT",
    "homepage": "git://github.com/es-shims/String.prototype.trim.git",
    "licenseFile": "/licenses/string.prototype.trim-1.2.10.txt"
  },
  {
    "name": "string.prototype.trimend",
    "version": "1.0.9",
    "license": "MIT",
    "homepage": "git://github.com/es-shims/String.prototype.trimEnd.git",
    "licenseFile": "/licenses/string.prototype.trimend-1.0.9.txt"
  },
  {
    "name": "string.prototype.trimstart",
    "version": "1.0.8",
    "license": "MIT",
    "homepage": "git://github.com/es-shims/String.prototype.trimStart.git",
    "licenseFile": "/licenses/string.prototype.trimstart-1.0.8.txt"
  },
  {
    "name": "stringify-object",
    "version": "3.3.0",
    "license": "BSD-2-Clause",
    "homepage": "yeoman/stringify-object",
    "licenseFile": "/licenses/stringify-object-3.3.0.txt"
  },
  {
    "name": "strip-ansi",
    "version": "7.1.0",
    "license": "MIT",
    "homepage": "chalk/strip-ansi",
    "licenseFile": "/licenses/strip-ansi-7.1.0.txt"
  },
  {
    "name": "strip-ansi",
    "version": "6.0.1",
    "license": "MIT",
    "homepage": "chalk/strip-ansi",
    "licenseFile": "/licenses/strip-ansi-6.0.1.txt"
  },
  {
    "name": "strip-bom",
    "version": "4.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/strip-bom",
    "licenseFile": "/licenses/strip-bom-4.0.0.txt"
  },
  {
    "name": "strip-bom",
    "version": "3.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/strip-bom",
    "licenseFile": "/licenses/strip-bom-3.0.0.txt"
  },
  {
    "name": "strip-comments",
    "version": "2.0.1",
    "license": "MIT",
    "homepage": "https://github.com/jonschlinkert/strip-comments",
    "licenseFile": "/licenses/strip-comments-2.0.1.txt"
  },
  {
    "name": "strip-final-newline",
    "version": "2.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/strip-final-newline",
    "licenseFile": "/licenses/strip-final-newline-2.0.0.txt"
  },
  {
    "name": "strip-indent",
    "version": "3.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/strip-indent",
    "licenseFile": "/licenses/strip-indent-3.0.0.txt"
  },
  {
    "name": "strip-json-comments",
    "version": "3.1.1",
    "license": "MIT",
    "homepage": "sindresorhus/strip-json-comments",
    "licenseFile": "/licenses/strip-json-comments-3.1.1.txt"
  },
  {
    "name": "style-loader",
    "version": "3.3.4",
    "license": "MIT",
    "homepage": "https://github.com/webpack-contrib/style-loader",
    "licenseFile": "/licenses/style-loader-3.3.4.txt"
  },
  {
    "name": "stylehacks",
    "version": "5.1.1",
    "license": "MIT",
    "homepage": "https://github.com/cssnano/cssnano",
    "licenseFile": null
  },
  {
    "name": "sucrase",
    "version": "3.35.0",
    "license": "MIT",
    "homepage": "https://github.com/alangpierce/sucrase.git",
    "licenseFile": "/licenses/sucrase-3.35.0.txt"
  },
  {
    "name": "supports-color",
    "version": "5.5.0",
    "license": "MIT",
    "homepage": "chalk/supports-color",
    "licenseFile": "/licenses/supports-color-5.5.0.txt"
  },
  {
    "name": "supports-color",
    "version": "8.1.1",
    "license": "MIT",
    "homepage": "chalk/supports-color",
    "licenseFile": "/licenses/supports-color-8.1.1.txt"
  },
  {
    "name": "supports-color",
    "version": "7.2.0",
    "license": "MIT",
    "homepage": "chalk/supports-color",
    "licenseFile": "/licenses/supports-color-7.2.0.txt"
  },
  {
    "name": "supports-hyperlinks",
    "version": "2.3.0",
    "license": "MIT",
    "homepage": "jamestalmage/supports-hyperlinks",
    "licenseFile": "/licenses/supports-hyperlinks-2.3.0.txt"
  },
  {
    "name": "supports-preserve-symlinks-flag",
    "version": "1.0.0",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/node-supports-preserve-symlinks-flag#readme",
    "licenseFile": "/licenses/supports-preserve-symlinks-flag-1.0.0.txt"
  },
  {
    "name": "svg-parser",
    "version": "2.0.4",
    "license": "MIT",
    "homepage": "https://github.com/Rich-Harris/svg-parser#README",
    "licenseFile": null
  },
  {
    "name": "svgo",
    "version": "2.8.0",
    "license": "MIT",
    "homepage": "https://github.com/svg/svgo",
    "licenseFile": "/licenses/svgo-2.8.0.txt"
  },
  {
    "name": "svgo",
    "version": "1.3.2",
    "license": "MIT",
    "homepage": "https://github.com/svg/svgo",
    "licenseFile": "/licenses/svgo-1.3.2.txt"
  },
  {
    "name": "symbol-tree",
    "version": "3.2.4",
    "license": "MIT",
    "homepage": "https://github.com/jsdom/js-symbol-tree#symbol-tree",
    "licenseFile": "/licenses/symbol-tree-3.2.4.txt"
  },
  {
    "name": "tailwindcss",
    "version": "3.4.17",
    "license": "MIT",
    "homepage": "https://tailwindcss.com",
    "licenseFile": "/licenses/tailwindcss-3.4.17.txt"
  },
  {
    "name": "tapable",
    "version": "1.1.3",
    "license": "MIT",
    "homepage": "https://github.com/webpack/tapable",
    "licenseFile": "/licenses/tapable-1.1.3.txt"
  },
  {
    "name": "tapable",
    "version": "2.2.3",
    "license": "MIT",
    "homepage": "https://github.com/webpack/tapable",
    "licenseFile": "/licenses/tapable-2.2.3.txt"
  },
  {
    "name": "temp-dir",
    "version": "2.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/temp-dir",
    "licenseFile": "/licenses/temp-dir-2.0.0.txt"
  },
  {
    "name": "tempy",
    "version": "0.6.0",
    "license": "MIT",
    "homepage": "sindresorhus/tempy",
    "licenseFile": "/licenses/tempy-0.6.0.txt"
  },
  {
    "name": "terminal-link",
    "version": "2.1.1",
    "license": "MIT",
    "homepage": "sindresorhus/terminal-link",
    "licenseFile": "/licenses/terminal-link-2.1.1.txt"
  },
  {
    "name": "terser",
    "version": "5.43.1",
    "license": "BSD-2-Clause",
    "homepage": "https://terser.org",
    "licenseFile": "/licenses/terser-5.43.1.txt"
  },
  {
    "name": "terser-webpack-plugin",
    "version": "5.3.14",
    "license": "MIT",
    "homepage": "https://github.com/webpack-contrib/terser-webpack-plugin",
    "licenseFile": "/licenses/terser-webpack-plugin-5.3.14.txt"
  },
  {
    "name": "test-exclude",
    "version": "6.0.0",
    "license": "ISC",
    "homepage": "https://istanbul.js.org/",
    "licenseFile": "/licenses/test-exclude-6.0.0.txt"
  },
  {
    "name": "text-table",
    "version": "0.2.0",
    "license": "MIT",
    "homepage": "https://github.com/substack/text-table",
    "licenseFile": "/licenses/text-table-0.2.0.txt"
  },
  {
    "name": "thenify",
    "version": "3.3.1",
    "license": "MIT",
    "homepage": "thenables/thenify",
    "licenseFile": "/licenses/thenify-3.3.1.txt"
  },
  {
    "name": "thenify-all",
    "version": "1.6.0",
    "license": "MIT",
    "homepage": "thenables/thenify-all",
    "licenseFile": "/licenses/thenify-all-1.6.0.txt"
  },
  {
    "name": "throat",
    "version": "6.0.2",
    "license": "MIT",
    "homepage": "https://github.com/ForbesLindesay/throat.git",
    "licenseFile": "/licenses/throat-6.0.2.txt"
  },
  {
    "name": "thunky",
    "version": "1.1.0",
    "license": "MIT",
    "homepage": "https://github.com/mafintosh/thunky#readme",
    "licenseFile": "/licenses/thunky-1.1.0.txt"
  },
  {
    "name": "tmpl",
    "version": "1.0.5",
    "license": "BSD-3-Clause",
    "homepage": "https://github.com/daaku/nodejs-tmpl",
    "licenseFile": "/licenses/tmpl-1.0.5.txt"
  },
  {
    "name": "to-regex-range",
    "version": "5.0.1",
    "license": "MIT",
    "homepage": "https://github.com/micromatch/to-regex-range",
    "licenseFile": "/licenses/to-regex-range-5.0.1.txt"
  },
  {
    "name": "toidentifier",
    "version": "1.0.1",
    "license": "MIT",
    "homepage": "component/toidentifier",
    "licenseFile": "/licenses/toidentifier-1.0.1.txt"
  },
  {
    "name": "tough-cookie",
    "version": "4.1.4",
    "license": "BSD-3-Clause",
    "homepage": "https://github.com/salesforce/tough-cookie",
    "licenseFile": "/licenses/tough-cookie-4.1.4.txt"
  },
  {
    "name": "tr46",
    "version": "2.1.0",
    "license": "MIT",
    "homepage": "https://github.com/jsdom/tr46",
    "licenseFile": "/licenses/tr46-2.1.0.txt"
  },
  {
    "name": "tr46",
    "version": "1.0.1",
    "license": "MIT",
    "homepage": "Sebmaster/tr46.js",
    "licenseFile": "/licenses/tr46-1.0.1.txt"
  },
  {
    "name": "tryer",
    "version": "1.0.1",
    "license": "MIT",
    "homepage": "https://gitlab.com/philbooth/tryer",
    "licenseFile": "/licenses/tryer-1.0.1.txt"
  },
  {
    "name": "ts-interface-checker",
    "version": "0.1.13",
    "license": "Apache-2.0",
    "homepage": "https://github.com/gristlabs/ts-interface-checker",
    "licenseFile": "/licenses/ts-interface-checker-0.1.13.txt"
  },
  {
    "name": "tsconfig-paths",
    "version": "3.15.0",
    "license": "MIT",
    "homepage": "https://github.com/dividab/tsconfig-paths",
    "licenseFile": "/licenses/tsconfig-paths-3.15.0.txt"
  },
  {
    "name": "tslib",
    "version": "2.8.1",
    "license": "0BSD",
    "homepage": "https://www.typescriptlang.org/",
    "licenseFile": "/licenses/tslib-2.8.1.txt"
  },
  {
    "name": "tslib",
    "version": "1.14.1",
    "license": "0BSD",
    "homepage": "https://www.typescriptlang.org/",
    "licenseFile": "/licenses/tslib-1.14.1.txt"
  },
  {
    "name": "tsutils",
    "version": "3.21.0",
    "license": "MIT",
    "homepage": "https://github.com/ajafff/tsutils",
    "licenseFile": "/licenses/tsutils-3.21.0.txt"
  },
  {
    "name": "type-check",
    "version": "0.3.2",
    "license": "MIT",
    "homepage": "https://github.com/gkz/type-check",
    "licenseFile": "/licenses/type-check-0.3.2.txt"
  },
  {
    "name": "type-check",
    "version": "0.4.0",
    "license": "MIT",
    "homepage": "https://github.com/gkz/type-check",
    "licenseFile": "/licenses/type-check-0.4.0.txt"
  },
  {
    "name": "type-detect",
    "version": "4.0.8",
    "license": "MIT",
    "homepage": "ssh://git@github.com/chaijs/type-detect.git",
    "licenseFile": "/licenses/type-detect-4.0.8.txt"
  },
  {
    "name": "type-fest",
    "version": "0.21.3",
    "license": "(MIT OR CC0-1.0)",
    "homepage": "sindresorhus/type-fest",
    "licenseFile": "/licenses/type-fest-0.21.3.txt"
  },
  {
    "name": "type-fest",
    "version": "0.16.0",
    "license": "(MIT OR CC0-1.0)",
    "homepage": "sindresorhus/type-fest",
    "licenseFile": "/licenses/type-fest-0.16.0.txt"
  },
  {
    "name": "type-fest",
    "version": "0.20.2",
    "license": "(MIT OR CC0-1.0)",
    "homepage": "sindresorhus/type-fest",
    "licenseFile": "/licenses/type-fest-0.20.2.txt"
  },
  {
    "name": "type-is",
    "version": "1.6.18",
    "license": "MIT",
    "homepage": "jshttp/type-is",
    "licenseFile": "/licenses/type-is-1.6.18.txt"
  },
  {
    "name": "typed-array-buffer",
    "version": "1.0.3",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/typed-array-buffer#readme",
    "licenseFile": "/licenses/typed-array-buffer-1.0.3.txt"
  },
  {
    "name": "typed-array-byte-length",
    "version": "1.0.3",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/typed-array-byte-length#readme",
    "licenseFile": "/licenses/typed-array-byte-length-1.0.3.txt"
  },
  {
    "name": "typed-array-byte-offset",
    "version": "1.0.4",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/typed-array-byte-offset#readme",
    "licenseFile": "/licenses/typed-array-byte-offset-1.0.4.txt"
  },
  {
    "name": "typed-array-length",
    "version": "1.0.7",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/typed-array-length#readme",
    "licenseFile": "/licenses/typed-array-length-1.0.7.txt"
  },
  {
    "name": "typedarray-to-buffer",
    "version": "3.1.5",
    "license": "MIT",
    "homepage": "http://feross.org",
    "licenseFile": "/licenses/typedarray-to-buffer-3.1.5.txt"
  },
  {
    "name": "typescript",
    "version": "4.9.5",
    "license": "Apache-2.0",
    "homepage": "https://www.typescriptlang.org/",
    "licenseFile": "/licenses/typescript-4.9.5.txt"
  },
  {
    "name": "unbox-primitive",
    "version": "1.1.0",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/unbox-primitive#readme",
    "licenseFile": "/licenses/unbox-primitive-1.1.0.txt"
  },
  {
    "name": "underscore",
    "version": "1.12.1",
    "license": "MIT",
    "homepage": "https://underscorejs.org",
    "licenseFile": "/licenses/underscore-1.12.1.txt"
  },
  {
    "name": "undici-types",
    "version": "7.10.0",
    "license": "MIT",
    "homepage": "https://undici.nodejs.org",
    "licenseFile": "/licenses/undici-types-7.10.0.txt"
  },
  {
    "name": "unicode-canonical-property-names-ecmascript",
    "version": "2.0.1",
    "license": "MIT",
    "homepage": "https://github.com/mathiasbynens/unicode-canonical-property-names-ecmascript",
    "licenseFile": null
  },
  {
    "name": "unicode-match-property-ecmascript",
    "version": "2.0.0",
    "license": "MIT",
    "homepage": "https://github.com/mathiasbynens/unicode-match-property-ecmascript",
    "licenseFile": null
  },
  {
    "name": "unicode-match-property-value-ecmascript",
    "version": "2.2.0",
    "license": "MIT",
    "homepage": "https://github.com/mathiasbynens/unicode-match-property-value-ecmascript",
    "licenseFile": null
  },
  {
    "name": "unicode-property-aliases-ecmascript",
    "version": "2.1.0",
    "license": "MIT",
    "homepage": "https://github.com/mathiasbynens/unicode-property-aliases-ecmascript",
    "licenseFile": null
  },
  {
    "name": "unique-string",
    "version": "2.0.0",
    "license": "MIT",
    "homepage": "sindresorhus/unique-string",
    "licenseFile": "/licenses/unique-string-2.0.0.txt"
  },
  {
    "name": "universalify",
    "version": "0.2.0",
    "license": "MIT",
    "homepage": "https://github.com/RyanZim/universalify#readme",
    "licenseFile": "/licenses/universalify-0.2.0.txt"
  },
  {
    "name": "universalify",
    "version": "2.0.1",
    "license": "MIT",
    "homepage": "https://github.com/RyanZim/universalify#readme",
    "licenseFile": "/licenses/universalify-2.0.1.txt"
  },
  {
    "name": "unpipe",
    "version": "1.0.0",
    "license": "MIT",
    "homepage": "stream-utils/unpipe",
    "licenseFile": "/licenses/unpipe-1.0.0.txt"
  },
  {
    "name": "unquote",
    "version": "1.1.1",
    "license": "MIT",
    "homepage": "https://github.com/lakenen/node-unquote",
    "licenseFile": "/licenses/unquote-1.1.1.txt"
  },
  {
    "name": "upath",
    "version": "1.2.0",
    "license": "MIT",
    "homepage": "http://github.com/anodynos/upath/",
    "licenseFile": "/licenses/upath-1.2.0.txt"
  },
  {
    "name": "update-browserslist-db",
    "version": "1.1.3",
    "license": "MIT",
    "homepage": "browserslist/update-db",
    "licenseFile": "/licenses/update-browserslist-db-1.1.3.txt"
  },
  {
    "name": "uri-js",
    "version": "4.4.1",
    "license": "BSD-2-Clause",
    "homepage": "https://github.com/garycourt/uri-js",
    "licenseFile": "/licenses/uri-js-4.4.1.txt"
  },
  {
    "name": "url-parse",
    "version": "1.5.10",
    "license": "MIT",
    "homepage": "https://github.com/unshiftio/url-parse.git",
    "licenseFile": "/licenses/url-parse-1.5.10.txt"
  },
  {
    "name": "util-deprecate",
    "version": "1.0.2",
    "license": "MIT",
    "homepage": "https://github.com/TooTallNate/util-deprecate",
    "licenseFile": "/licenses/util-deprecate-1.0.2.txt"
  },
  {
    "name": "util.promisify",
    "version": "1.0.1",
    "license": "MIT",
    "homepage": "https://github.com/ljharb/util.promisify#readme",
    "licenseFile": "/licenses/util.promisify-1.0.1.txt"
  },
  {
    "name": "utila",
    "version": "0.4.0",
    "license": "MIT",
    "homepage": "https://github.com/AriaMinaei/utila.git",
    "licenseFile": "/licenses/utila-0.4.0.txt"
  },
  {
    "name": "utils-merge",
    "version": "1.0.1",
    "license": "MIT",
    "homepage": "git://github.com/jaredhanson/utils-merge.git",
    "licenseFile": "/licenses/utils-merge-1.0.1.txt"
  },
  {
    "name": "uuid",
    "version": "8.3.2",
    "license": "MIT",
    "homepage": "https://github.com/uuidjs/uuid.git",
    "licenseFile": "/licenses/uuid-8.3.2.txt"
  },
  {
    "name": "v8-to-istanbul",
    "version": "8.1.1",
    "license": "ISC",
    "homepage": "istanbuljs/v8-to-istanbul",
    "licenseFile": "/licenses/v8-to-istanbul-8.1.1.txt"
  },
  {
    "name": "vary",
    "version": "1.1.2",
    "license": "MIT",
    "homepage": "jshttp/vary",
    "licenseFile": "/licenses/vary-1.1.2.txt"
  },
  {
    "name": "w3c-hr-time",
    "version": "1.0.2",
    "license": "MIT",
    "homepage": "https://github.com/jsdom/w3c-hr-time",
    "licenseFile": "/licenses/w3c-hr-time-1.0.2.txt"
  },
  {
    "name": "w3c-xmlserializer",
    "version": "2.0.0",
    "license": "MIT",
    "homepage": "jsdom/w3c-xmlserializer",
    "licenseFile": "/licenses/w3c-xmlserializer-2.0.0.txt"
  },
  {
    "name": "walker",
    "version": "1.0.8",
    "license": "Apache-2.0",
    "homepage": "https://github.com/daaku/nodejs-walker",
    "licenseFile": "/licenses/walker-1.0.8.txt"
  },
  {
    "name": "watchpack",
    "version": "2.4.4",
    "license": "MIT",
    "homepage": "https://github.com/webpack/watchpack",
    "licenseFile": "/licenses/watchpack-2.4.4.txt"
  },
  {
    "name": "wbuf",
    "version": "1.7.3",
    "license": "MIT",
    "homepage": "https://github.com/indutny/wbuf",
    "licenseFile": null
  },
  {
    "name": "web-vitals",
    "version": "2.1.4",
    "license": "Apache-2.0",
    "homepage": "https://github.com/GoogleChrome/web-vitals.git",
    "licenseFile": "/licenses/web-vitals-2.1.4.txt"
  },
  {
    "name": "webidl-conversions",
    "version": "5.0.0",
    "license": "BSD-2-Clause",
    "homepage": "jsdom/webidl-conversions",
    "licenseFile": "/licenses/webidl-conversions-5.0.0.txt"
  },
  {
    "name": "webidl-conversions",
    "version": "6.1.0",
    "license": "BSD-2-Clause",
    "homepage": "jsdom/webidl-conversions",
    "licenseFile": "/licenses/webidl-conversions-6.1.0.txt"
  },
  {
    "name": "webidl-conversions",
    "version": "4.0.2",
    "license": "BSD-2-Clause",
    "homepage": "jsdom/webidl-conversions",
    "licenseFile": "/licenses/webidl-conversions-4.0.2.txt"
  },
  {
    "name": "webpack",
    "version": "5.101.3",
    "license": "MIT",
    "homepage": "https://github.com/webpack/webpack",
    "licenseFile": "/licenses/webpack-5.101.3.txt"
  },
  {
    "name": "webpack-dev-middleware",
    "version": "5.3.4",
    "license": "MIT",
    "homepage": "https://github.com/webpack/webpack-dev-middleware",
    "licenseFile": "/licenses/webpack-dev-middleware-5.3.4.txt"
  },
  {
    "name": "webpack-dev-server",
    "version": "4.15.2",
    "license": "MIT",
    "homepage": "https://github.com/webpack/webpack-dev-server#readme",
    "licenseFile": "/licenses/webpack-dev-server-4.15.2.txt"
  },
  {
    "name": "webpack-manifest-plugin",
    "version": "4.1.1",
    "license": "MIT",
    "homepage": "https://github.com/shellscape/webpack-manifest-plugin",
    "licenseFile": "/licenses/webpack-manifest-plugin-4.1.1.txt"
  },
  {
    "name": "webpack-sources",
    "version": "2.3.1",
    "license": "MIT",
    "homepage": "https://github.com/webpack/webpack-sources#readme",
    "licenseFile": "/licenses/webpack-sources-2.3.1.txt"
  },
  {
    "name": "webpack-sources",
    "version": "3.3.3",
    "license": "MIT",
    "homepage": "https://github.com/webpack/webpack-sources#readme",
    "licenseFile": "/licenses/webpack-sources-3.3.3.txt"
  },
  {
    "name": "webpack-sources",
    "version": "1.4.3",
    "license": "MIT",
    "homepage": "https://github.com/webpack/webpack-sources#readme",
    "licenseFile": "/licenses/webpack-sources-1.4.3.txt"
  },
  {
    "name": "websocket-driver",
    "version": "0.7.4",
    "license": "Apache-2.0",
    "homepage": "https://github.com/faye/websocket-driver-node",
    "licenseFile": "/licenses/websocket-driver-0.7.4.txt"
  },
  {
    "name": "websocket-extensions",
    "version": "0.1.4",
    "license": "Apache-2.0",
    "homepage": "http://github.com/faye/websocket-extensions-node",
    "licenseFile": "/licenses/websocket-extensions-0.1.4.txt"
  },
  {
    "name": "whatwg-encoding",
    "version": "1.0.5",
    "license": "MIT",
    "homepage": "jsdom/whatwg-encoding",
    "licenseFile": "/licenses/whatwg-encoding-1.0.5.txt"
  },
  {
    "name": "whatwg-fetch",
    "version": "3.6.20",
    "license": "MIT",
    "homepage": "github/fetch",
    "licenseFile": "/licenses/whatwg-fetch-3.6.20.txt"
  },
  {
    "name": "whatwg-mimetype",
    "version": "2.3.0",
    "license": "MIT",
    "homepage": "jsdom/whatwg-mimetype",
    "licenseFile": "/licenses/whatwg-mimetype-2.3.0.txt"
  },
  {
    "name": "whatwg-url",
    "version": "8.7.0",
    "license": "MIT",
    "homepage": "jsdom/whatwg-url",
    "licenseFile": "/licenses/whatwg-url-8.7.0.txt"
  },
  {
    "name": "whatwg-url",
    "version": "7.1.0",
    "license": "MIT",
    "homepage": "jsdom/whatwg-url",
    "licenseFile": "/licenses/whatwg-url-7.1.0.txt"
  },
  {
    "name": "which",
    "version": "1.3.1",
    "license": "ISC",
    "homepage": "git://github.com/isaacs/node-which.git",
    "licenseFile": "/licenses/which-1.3.1.txt"
  },
  {
    "name": "which",
    "version": "2.0.2",
    "license": "ISC",
    "homepage": "git://github.com/isaacs/node-which.git",
    "licenseFile": "/licenses/which-2.0.2.txt"
  },
  {
    "name": "which-boxed-primitive",
    "version": "1.1.1",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/which-boxed-primitive#readme",
    "licenseFile": "/licenses/which-boxed-primitive-1.1.1.txt"
  },
  {
    "name": "which-builtin-type",
    "version": "1.2.1",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/which-builtin-type#readme",
    "licenseFile": "/licenses/which-builtin-type-1.2.1.txt"
  },
  {
    "name": "which-collection",
    "version": "1.0.2",
    "license": "MIT",
    "homepage": "https://github.com/inspect-js/which-collection#readme",
    "licenseFile": "/licenses/which-collection-1.0.2.txt"
  },
  {
    "name": "which-typed-array",
    "version": "1.1.19",
    "license": "MIT",
    "homepage": "git://github.com/inspect-js/which-typed-array.git",
    "licenseFile": "/licenses/which-typed-array-1.1.19.txt"
  },
  {
    "name": "word-wrap",
    "version": "1.2.5",
    "license": "MIT",
    "homepage": "https://github.com/jonschlinkert/word-wrap",
    "licenseFile": "/licenses/word-wrap-1.2.5.txt"
  },
  {
    "name": "workbox-background-sync",
    "version": "6.6.0",
    "license": "MIT",
    "homepage": "https://github.com/GoogleChrome/workbox",
    "licenseFile": "/licenses/workbox-background-sync-6.6.0.txt"
  },
  {
    "name": "workbox-broadcast-update",
    "version": "6.6.0",
    "license": "MIT",
    "homepage": "https://github.com/GoogleChrome/workbox",
    "licenseFile": "/licenses/workbox-broadcast-update-6.6.0.txt"
  },
  {
    "name": "workbox-build",
    "version": "6.6.0",
    "license": "MIT",
    "homepage": "https://github.com/GoogleChrome/workbox",
    "licenseFile": "/licenses/workbox-build-6.6.0.txt"
  },
  {
    "name": "workbox-cacheable-response",
    "version": "6.6.0",
    "license": "MIT",
    "homepage": "https://github.com/GoogleChrome/workbox",
    "licenseFile": "/licenses/workbox-cacheable-response-6.6.0.txt"
  },
  {
    "name": "workbox-core",
    "version": "6.6.0",
    "license": "MIT",
    "homepage": "https://github.com/GoogleChrome/workbox",
    "licenseFile": "/licenses/workbox-core-6.6.0.txt"
  },
  {
    "name": "workbox-expiration",
    "version": "6.6.0",
    "license": "MIT",
    "homepage": "https://github.com/GoogleChrome/workbox",
    "licenseFile": "/licenses/workbox-expiration-6.6.0.txt"
  },
  {
    "name": "workbox-google-analytics",
    "version": "6.6.0",
    "license": "MIT",
    "homepage": "https://github.com/GoogleChrome/workbox",
    "licenseFile": "/licenses/workbox-google-analytics-6.6.0.txt"
  },
  {
    "name": "workbox-navigation-preload",
    "version": "6.6.0",
    "license": "MIT",
    "homepage": "https://github.com/GoogleChrome/workbox",
    "licenseFile": "/licenses/workbox-navigation-preload-6.6.0.txt"
  },
  {
    "name": "workbox-precaching",
    "version": "6.6.0",
    "license": "MIT",
    "homepage": "https://github.com/GoogleChrome/workbox",
    "licenseFile": "/licenses/workbox-precaching-6.6.0.txt"
  },
  {
    "name": "workbox-range-requests",
    "version": "6.6.0",
    "license": "MIT",
    "homepage": "https://github.com/GoogleChrome/workbox",
    "licenseFile": "/licenses/workbox-range-requests-6.6.0.txt"
  },
  {
    "name": "workbox-recipes",
    "version": "6.6.0",
    "license": "MIT",
    "homepage": "https://github.com/GoogleChrome/workbox",
    "licenseFile": "/licenses/workbox-recipes-6.6.0.txt"
  },
  {
    "name": "workbox-routing",
    "version": "6.6.0",
    "license": "MIT",
    "homepage": "https://github.com/GoogleChrome/workbox",
    "licenseFile": "/licenses/workbox-routing-6.6.0.txt"
  },
  {
    "name": "workbox-strategies",
    "version": "6.6.0",
    "license": "MIT",
    "homepage": "https://github.com/GoogleChrome/workbox",
    "licenseFile": "/licenses/workbox-strategies-6.6.0.txt"
  },
  {
    "name": "workbox-streams",
    "version": "6.6.0",
    "license": "MIT",
    "homepage": "https://github.com/GoogleChrome/workbox",
    "licenseFile": "/licenses/workbox-streams-6.6.0.txt"
  },
  {
    "name": "workbox-sw",
    "version": "6.6.0",
    "license": "MIT",
    "homepage": "https://github.com/GoogleChrome/workbox",
    "licenseFile": "/licenses/workbox-sw-6.6.0.txt"
  },
  {
    "name": "workbox-webpack-plugin",
    "version": "6.6.0",
    "license": "MIT",
    "homepage": "https://github.com/GoogleChrome/workbox",
    "licenseFile": "/licenses/workbox-webpack-plugin-6.6.0.txt"
  },
  {
    "name": "workbox-window",
    "version": "6.6.0",
    "license": "MIT",
    "homepage": "https://github.com/GoogleChrome/workbox",
    "licenseFile": "/licenses/workbox-window-6.6.0.txt"
  },
  {
    "name": "wrap-ansi",
    "version": "8.1.0",
    "license": "MIT",
    "homepage": "chalk/wrap-ansi",
    "licenseFile": "/licenses/wrap-ansi-8.1.0.txt"
  },
  {
    "name": "wrap-ansi",
    "version": "7.0.0",
    "license": "MIT",
    "homepage": "chalk/wrap-ansi",
    "licenseFile": "/licenses/wrap-ansi-7.0.0.txt"
  },
  {
    "name": "wrappy",
    "version": "1.0.2",
    "license": "ISC",
    "homepage": "https://github.com/npm/wrappy",
    "licenseFile": "/licenses/wrappy-1.0.2.txt"
  },
  {
    "name": "write-file-atomic",
    "version": "3.0.3",
    "license": "ISC",
    "homepage": "https://github.com/npm/write-file-atomic",
    "licenseFile": "/licenses/write-file-atomic-3.0.3.txt"
  },
  {
    "name": "ws",
    "version": "8.18.3",
    "license": "MIT",
    "homepage": "https://github.com/websockets/ws",
    "licenseFile": "/licenses/ws-8.18.3.txt"
  },
  {
    "name": "ws",
    "version": "7.5.10",
    "license": "MIT",
    "homepage": "https://github.com/websockets/ws",
    "licenseFile": "/licenses/ws-7.5.10.txt"
  },
  {
    "name": "xml-name-validator",
    "version": "3.0.0",
    "license": "Apache-2.0",
    "homepage": "jsdom/xml-name-validator",
    "licenseFile": "/licenses/xml-name-validator-3.0.0.txt"
  },
  {
    "name": "xmlchars",
    "version": "2.2.0",
    "license": "MIT",
    "homepage": "https://github.com/lddubeau/xmlchars.git",
    "licenseFile": "/licenses/xmlchars-2.2.0.txt"
  },
  {
    "name": "y18n",
    "version": "5.0.8",
    "license": "ISC",
    "homepage": "https://github.com/yargs/y18n",
    "licenseFile": "/licenses/y18n-5.0.8.txt"
  },
  {
    "name": "yallist",
    "version": "3.1.1",
    "license": "ISC",
    "homepage": "https://github.com/isaacs/yallist.git",
    "licenseFile": "/licenses/yallist-3.1.1.txt"
  },
  {
    "name": "yaml",
    "version": "2.8.1",
    "license": "ISC",
    "homepage": "https://eemeli.org/yaml/",
    "licenseFile": "/licenses/yaml-2.8.1.txt"
  },
  {
    "name": "yaml",
    "version": "1.10.2",
    "license": "ISC",
    "homepage": "https://eemeli.org/yaml/v1/",
    "licenseFile": "/licenses/yaml-1.10.2.txt"
  },
  {
    "name": "yargs",
    "version": "16.2.0",
    "license": "MIT",
    "homepage": "https://yargs.js.org/",
    "licenseFile": "/licenses/yargs-16.2.0.txt"
  },
  {
    "name": "yargs-parser",
    "version": "20.2.9",
    "license": "ISC",
    "homepage": "https://github.com/yargs/yargs-parser.git",
    "licenseFile": "/licenses/yargs-parser-20.2.9.txt"
  },
  {
    "name": "yocto-queue",
    "version": "0.1.0",
    "license": "MIT",
    "homepage": "sindresorhus/yocto-queue",
    "licenseFile": "/licenses/yocto-queue-0.1.0.txt"
  }
];
